import * as d from "react";
import f, { useEffect as F, useMemo as he, useCallback as q, useRef as Y1, useState as ve } from "react";
import { s as V2, k as L2, l as Mt, m as A2, n as ze, T as M2, o as P2, C as _2, S as $2, h as k, p as K1, q as zn, r as a1, t as N, v as O2, w as Pt, x as R2, y as I2, z as D2, A as B2, B as F2, D as z2, E as be, G as Ue } from "./index-BBPp1-L5.mjs";
import { a as ce, f as Q } from "./variables-BSQ2K9t-.mjs";
import { u as R, s as Z2, c as W2, P as re } from "./contexts-BhsnKQH-.mjs";
import { Badge as N2, badgeClasses as U2, Popover as j2, CircularProgress as q2, IconButton as X1, Drawer as G2, Popper as Y2, Tooltip as K2, tooltipClasses as _t, ClickAwayListener as X2, Fade as Q2, ThemeProvider as J2 } from "@mui/material";
import { useMountEffect as Ve, useUpdateEffect as ea, useMap as ta, useAsync as je, useDeepCompareEffect as Zn, useToggle as na, useIntersectionObserver as ra, useSyncedRef as Wn } from "@react-hookz/web";
import { t as i1 } from "./breakpoints-DvaoDEis.mjs";
import { u as o1 } from "./hooks-DEKsUlYx.mjs";
import { u as ae } from "./fallback-storage-value-DraZAU_d.mjs";
import Q1 from "axios";
import { g as C1 } from "./environment-BQ4WWa7b.mjs";
import { _ as J1, h as Nn, j as Un, k as jn, l as qn, m as et, n as h1, o as qe, p as tt, q as aa, r as ia, s as nt, t as Gn, u as Yn, v as Le, w as oa, x as Kn, y as sa, z as rt, B as v1, C as la, D as ca, E as ua, G as da, M as fa } from "./component-DHVnJ6XL.mjs";
import { readInlineData as s1, useRelayEnvironment as Xn, fetchQuery as Qn } from "react-relay";
import { getRequest as pa, createOperationDescriptor as ma } from "relay-runtime";
import { v as U, w as le, x as ga, y as Ca, z as Jn, A as ha, B as va, n as ya, f as ba, k as y1, u as $t } from "./index-CnymUPx7.mjs";
import { Z as b1 } from "./z-index-CEuzp1gH.mjs";
import wa from "@emotion/styled";
import { css as De } from "@emotion/react";
import xa, { bindTrigger as ka, bindPopover as Ea } from "material-ui-popup-state";
import { WhatsappShareButton as Ha, TwitterShareButton as Sa, TelegramShareButton as Ta, FacebookShareButton as Va, EmailShareButton as La } from "react-share";
import { useCopyToClipboard as Aa } from "react-use";
import * as Ma from "react-dom";
import { t as er } from "./transient-options-DbpnFyL2.mjs";
let Pa = {};
function w1() {
  return Pa;
}
function Ze(e, t) {
  var s, l, c, u;
  const n = w1(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, a = U(e), i = a.getDay(), o = (i < r ? 7 : 0) + i - r;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function l1(e) {
  return Ze(e, { weekStartsOn: 1 });
}
function tr(e) {
  const t = U(e), n = t.getFullYear(), r = le(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const a = l1(r), i = le(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const o = l1(i);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function c1(e) {
  const t = U(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Ot(e) {
  const t = U(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function _a(e, t) {
  const n = c1(e), r = c1(t), a = +n - Ot(n), i = +r - Ot(r);
  return Math.round((a - i) / ga);
}
function $a(e) {
  const t = tr(e), n = le(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), l1(n);
}
function nr(e) {
  return le(e, Date.now());
}
function rr(e, t) {
  const n = c1(e), r = c1(t);
  return +n == +r;
}
function Oa(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function Ra(e, t) {
  return +U(e) - +U(t);
}
function Ia(e, t, n) {
  const r = Ra(e, t) / Ca;
  return Oa(n == null ? void 0 : n.roundingMethod)(r);
}
function Da(e) {
  const t = U(e), n = le(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const Ba = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Fa = (e, t, n) => {
  let r;
  const a = Ba[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function L1(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const za = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Za = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Wa = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Na = {
  date: L1({
    formats: za,
    defaultWidth: "full"
  }),
  time: L1({
    formats: Za,
    defaultWidth: "full"
  }),
  dateTime: L1({
    formats: Wa,
    defaultWidth: "full"
  })
}, Ua = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ja = (e, t, n, r) => Ua[e];
function $e(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : o;
      a = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[s] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
const qa = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Ga = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Ya = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Ka = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Xa = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Qa = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ja = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, ei = {
  ordinalNumber: Ja,
  era: $e({
    values: qa,
    defaultWidth: "wide"
  }),
  quarter: $e({
    values: Ga,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: $e({
    values: Ya,
    defaultWidth: "wide"
  }),
  day: $e({
    values: Ka,
    defaultWidth: "wide"
  }),
  dayPeriod: $e({
    values: Xa,
    defaultWidth: "wide",
    formattingValues: Qa,
    defaultFormattingWidth: "wide"
  })
};
function Oe(e) {
  return (t, n = {}) => {
    const r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const o = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? ni(s, (m) => m.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      ti(s, (m) => m.test(o))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(o.length);
    return { value: c, rest: u };
  };
}
function ti(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function ni(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function ri(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const a = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const s = t.slice(a.length);
    return { value: o, rest: s };
  };
}
const ai = /^(\d+)(th|st|nd|rd)?/i, ii = /\d+/i, oi = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, si = {
  any: [/^b/i, /^(a|c)/i]
}, li = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, ci = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ui = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, di = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, fi = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, pi = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, mi = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, gi = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Ci = {
  ordinalNumber: ri({
    matchPattern: ai,
    parsePattern: ii,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Oe({
    matchPatterns: oi,
    defaultMatchWidth: "wide",
    parsePatterns: si,
    defaultParseWidth: "any"
  }),
  quarter: Oe({
    matchPatterns: li,
    defaultMatchWidth: "wide",
    parsePatterns: ci,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Oe({
    matchPatterns: ui,
    defaultMatchWidth: "wide",
    parsePatterns: di,
    defaultParseWidth: "any"
  }),
  day: Oe({
    matchPatterns: fi,
    defaultMatchWidth: "wide",
    parsePatterns: pi,
    defaultParseWidth: "any"
  }),
  dayPeriod: Oe({
    matchPatterns: mi,
    defaultMatchWidth: "any",
    parsePatterns: gi,
    defaultParseWidth: "any"
  })
}, hi = {
  code: "en-US",
  formatDistance: Fa,
  formatLong: Na,
  formatRelative: ja,
  localize: ei,
  match: Ci,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function vi(e) {
  const t = U(e);
  return _a(t, Da(t)) + 1;
}
function yi(e) {
  const t = U(e), n = +l1(t) - +$a(t);
  return Math.round(n / Jn) + 1;
}
function ar(e, t) {
  var u, m, p, h;
  const n = U(e), r = n.getFullYear(), a = w1(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((m = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : m.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((h = (p = a.locale) == null ? void 0 : p.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = le(e, 0);
  o.setFullYear(r + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = Ze(o, t), l = le(e, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const c = Ze(l, t);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function bi(e, t) {
  var s, l, c, u;
  const n = w1(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, a = ar(e, t), i = le(e, 0);
  return i.setFullYear(a, 0, r), i.setHours(0, 0, 0, 0), Ze(i, t);
}
function wi(e, t) {
  const n = U(e), r = +Ze(n, t) - +bi(n, t);
  return Math.round(r / Jn) + 1;
}
function _(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const se = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return _(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : _(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return _(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return _(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return _(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return _(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return _(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return _(a, t.length);
  }
}, xe = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Rt = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return se.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const a = ar(e, r), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = i % 100;
      return _(o, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : _(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = tr(e);
    return _(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return _(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return _(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return _(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return se.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return _(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const a = wi(e, r);
    return t === "wo" ? n.ordinalNumber(a, { unit: "week" }) : _(a, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = yi(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : _(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : se.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = vi(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : _(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return _(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return _(i, t.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), a = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return _(a, t.length);
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r === 12 ? a = xe.noon : r === 0 ? a = xe.midnight : a = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r >= 17 ? a = xe.evening : r >= 12 ? a = xe.afternoon : r >= 4 ? a = xe.morning : a = xe.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return se.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : se.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : _(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : _(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : se.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : se.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return se.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return Dt(r);
      case "XXXX":
      case "XX":
        return me(r);
      case "XXXXX":
      case "XXX":
      default:
        return me(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Dt(r);
      case "xxxx":
      case "xx":
        return me(r);
      case "xxxxx":
      case "xxx":
      default:
        return me(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + It(r, ":");
      case "OOOO":
      default:
        return "GMT" + me(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + It(r, ":");
      case "zzzz":
      default:
        return "GMT" + me(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return _(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return _(r, t.length);
  }
};
function It(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(a) : n + String(a) + t + _(i, 2);
}
function Dt(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + _(Math.abs(e) / 60, 2) : me(e, t);
}
function me(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = _(Math.trunc(r / 60), 2), i = _(r % 60, 2);
  return n + a + t + i;
}
const Bt = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, ir = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, xi = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return Bt(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Bt(r, t)).replace("{{time}}", ir(a, t));
}, ki = {
  p: ir,
  P: xi
}, Ei = /^D+$/, Hi = /^Y+$/, Si = ["D", "DD", "YY", "YYYY"];
function Ti(e) {
  return Ei.test(e);
}
function Vi(e) {
  return Hi.test(e);
}
function Li(e, t, n) {
  const r = Ai(e, t, n);
  if (console.warn(r), Si.includes(e)) throw new RangeError(r);
}
function Ai(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Mi = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Pi = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, _i = /^'([^]*?)'?$/, $i = /''/g, Oi = /[a-zA-Z]/;
function or(e, t, n) {
  var u, m, p, h;
  const r = w1(), a = r.locale ?? hi, i = r.firstWeekContainsDate ?? ((m = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, o = r.weekStartsOn ?? ((h = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : h.weekStartsOn) ?? 0, s = U(e);
  if (!ha(s))
    throw new RangeError("Invalid time value");
  let l = t.match(Pi).map((C) => {
    const g = C[0];
    if (g === "p" || g === "P") {
      const v = ki[g];
      return v(C, a.formatLong);
    }
    return C;
  }).join("").match(Mi).map((C) => {
    if (C === "''")
      return { isToken: !1, value: "'" };
    const g = C[0];
    if (g === "'")
      return { isToken: !1, value: Ri(C) };
    if (Rt[g])
      return { isToken: !0, value: C };
    if (g.match(Oi))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + g + "`"
      );
    return { isToken: !1, value: C };
  });
  a.localize.preprocessor && (l = a.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: a
  };
  return l.map((C) => {
    if (!C.isToken) return C.value;
    const g = C.value;
    (Vi(g) || Ti(g)) && Li(g, t, String(e));
    const v = Rt[g[0]];
    return v(s, g, a.localize, c);
  }).join("");
}
function Ri(e) {
  const t = e.match(_i);
  return t ? t[1].replace($i, "'") : e;
}
function O1(e) {
  return Math.trunc(+U(e) / 1e3);
}
function Ii(e) {
  return rr(e, nr(e));
}
function Di(e, t) {
  return va(e, -t);
}
function Bi(e) {
  return rr(e, Di(nr(e), 1));
}
function Fi(e, t) {
  return wa(e, t);
}
function zi(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const Ft = [];
function zt(e) {
  return Ft[0] = e, V2(Ft);
}
const Zt = (e) => e, Zi = () => {
  let e = Zt;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = Zt;
    }
  };
}, Wi = Zi();
function sr(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = sr(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function R1() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = sr(e)) && (r && (r += " "), r += t);
  return r;
}
const lr = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function cr(e, t, n = "Mui") {
  const r = lr[t];
  return r ? `${n}-${r}` : `${Wi.generate(e)}-${t}`;
}
function Ni(e, t, n = "Mui") {
  const r = {};
  return t.forEach((a) => {
    r[a] = cr(e, a, n);
  }), r;
}
function ur(e) {
  const {
    variants: t,
    ...n
  } = e, r = {
    variants: t,
    style: zt(n),
    isProcessed: !0
  };
  return r.style === n || t && t.forEach((a) => {
    typeof a.style != "function" && (a.style = zt(a.style));
  }), r;
}
const Ui = L2();
function A1(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function ji(e) {
  return e ? (t, n) => n[e] : null;
}
function qi(e, t, n) {
  e.theme = Ki(e.theme) ? n : e.theme[t] || e.theme;
}
function n1(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((r) => n1(e, r));
  if (Array.isArray(n == null ? void 0 : n.variants)) {
    let r;
    if (n.isProcessed)
      r = n.style;
    else {
      const {
        variants: a,
        ...i
      } = n;
      r = i;
    }
    return dr(e, n.variants, [r]);
  }
  return n != null && n.isProcessed ? n.style : n;
}
function dr(e, t, n = []) {
  var a;
  let r;
  e: for (let i = 0; i < t.length; i += 1) {
    const o = t[i];
    if (typeof o.props == "function") {
      if (r ?? (r = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !o.props(r))
        continue;
    } else
      for (const s in o.props)
        if (e[s] !== o.props[s] && ((a = e.ownerState) == null ? void 0 : a[s]) !== o.props[s])
          continue e;
    typeof o.style == "function" ? (r ?? (r = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), n.push(o.style(r))) : n.push(o.style);
  }
  return n;
}
function Gi(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = Ui,
    rootShouldForwardProp: r = A1,
    slotShouldForwardProp: a = A1
  } = e;
  function i(s) {
    qi(s, t, n);
  }
  return (s, l = {}) => {
    zi(s, (w) => w.filter((x) => x !== Mt));
    const {
      name: c,
      slot: u,
      skipVariantsResolver: m,
      skipSx: p,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: h = ji(Qi(u)),
      ...C
    } = l, g = m !== void 0 ? m : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      u && u !== "Root" && u !== "root" || !1
    ), v = p || !1;
    let y = A1;
    u === "Root" || u === "root" ? y = r : u ? y = a : Xi(s) && (y = void 0);
    const E = Fi(s, {
      shouldForwardProp: y,
      label: Yi(),
      ...C
    }), H = (w) => {
      if (typeof w == "function" && w.__emotion_real !== w)
        return function(T) {
          return n1(T, w);
        };
      if (A2(w)) {
        const x = ur(w);
        return x.variants ? function(L) {
          return n1(L, x);
        } : x.style;
      }
      return w;
    }, b = (...w) => {
      const x = [], T = w.map(H), L = [];
      if (x.push(i), c && h && L.push(function(A) {
        var P, B;
        const $ = (B = (P = A.theme.components) == null ? void 0 : P[c]) == null ? void 0 : B.styleOverrides;
        if (!$)
          return null;
        const D = {};
        for (const W in $)
          D[W] = n1(A, $[W]);
        return h(A, D);
      }), c && !g && L.push(function(A) {
        var D, P;
        const S = A.theme, $ = (P = (D = S == null ? void 0 : S.components) == null ? void 0 : D[c]) == null ? void 0 : P.variants;
        return $ ? dr(A, $) : null;
      }), v || L.push(Mt), Array.isArray(T[0])) {
        const O = T.shift(), A = new Array(x.length).fill(""), S = new Array(L.length).fill("");
        let $;
        $ = [...A, ...O, ...S], $.raw = [...A, ...O.raw, ...S], x.unshift($);
      }
      const M = [...x, ...T, ...L], V = E(...M);
      return s.muiName && (V.muiName = s.muiName), V;
    };
    return E.withConfig && (b.withConfig = E.withConfig), b;
  };
}
function Yi(e, t) {
  return void 0;
}
function Ki(e) {
  for (const t in e)
    return !1;
  return !0;
}
function Xi(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Qi(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
function I1(e, t) {
  const n = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const a = r;
      if (a === "components" || a === "slots")
        n[a] = {
          ...e[a],
          ...n[a]
        };
      else if (a === "componentsProps" || a === "slotProps") {
        const i = e[a], o = t[a];
        if (!o)
          n[a] = i || {};
        else if (!i)
          n[a] = o;
        else {
          n[a] = {
            ...o
          };
          for (const s in i)
            if (Object.prototype.hasOwnProperty.call(i, s)) {
              const l = s;
              n[a][l] = I1(i[l], o[l]);
            }
        }
      } else n[a] === void 0 && (n[a] = e[a]);
    }
  return n;
}
const u1 = typeof window < "u" ? d.useLayoutEffect : d.useEffect;
function Wt(e) {
  return e && e.ownerDocument || document;
}
function Ji({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: a
  } = d.useRef(e !== void 0), [i, o] = d.useState(t), s = a ? e : i, l = d.useCallback((c) => {
    a || o(c);
  }, []);
  return [s, l];
}
function Nt(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
  }
  return !1;
}
function at(e, t, n = void 0) {
  const r = {};
  for (const a in e) {
    const i = e[a];
    let o = "", s = !0;
    for (let l = 0; l < i.length; l += 1) {
      const c = i[l];
      c && (o += (s === !0 ? "" : " ") + t(c), s = !1, n && n[c] && (o += " " + n[c]));
    }
    r[a] = o;
  }
  return r;
}
function eo(e) {
  return typeof e == "string";
}
function to(e, t, n) {
  return e === void 0 || eo(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function no(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function Ut(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function ro(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: a,
    className: i
  } = e;
  if (!t) {
    const h = R1(n == null ? void 0 : n.className, i, a == null ? void 0 : a.className, r == null ? void 0 : r.className), C = {
      ...n == null ? void 0 : n.style,
      ...a == null ? void 0 : a.style,
      ...r == null ? void 0 : r.style
    }, g = {
      ...n,
      ...a,
      ...r
    };
    return h.length > 0 && (g.className = h), Object.keys(C).length > 0 && (g.style = C), {
      props: g,
      internalRef: void 0
    };
  }
  const o = no({
    ...a,
    ...r
  }), s = Ut(r), l = Ut(a), c = t(o), u = R1(c == null ? void 0 : c.className, n == null ? void 0 : n.className, i, a == null ? void 0 : a.className, r == null ? void 0 : r.className), m = {
    ...c == null ? void 0 : c.style,
    ...n == null ? void 0 : n.style,
    ...a == null ? void 0 : a.style,
    ...r == null ? void 0 : r.style
  }, p = {
    ...c,
    ...n,
    ...l,
    ...s
  };
  return u.length > 0 && (p.className = u), Object.keys(m).length > 0 && (p.style = m), {
    props: p,
    internalRef: c.ref
  };
}
function ao(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function Ie(e) {
  var m;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: a = !1,
    ...i
  } = e, o = a ? {} : ao(n, r), {
    props: s,
    internalRef: l
  } = ro({
    ...i,
    externalSlotProps: o
  }), c = ze(l, o == null ? void 0 : o.ref, (m = e.additionalProps) == null ? void 0 : m.ref);
  return to(t, {
    ...s,
    ref: c
  }, r);
}
const io = /* @__PURE__ */ d.createContext(void 0);
function oo(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const a = t.components[n];
  return a.defaultProps ? I1(a.defaultProps, r) : !a.styleOverrides && !a.variants ? I1(a, r) : r;
}
function so({
  props: e,
  name: t
}) {
  const n = d.useContext(io);
  return oo({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const jt = {
  theme: void 0
};
function lo(e) {
  let t, n;
  return function(a) {
    let i = t;
    return (i === void 0 || a.theme !== n) && (jt.theme = a.theme, i = ur(e(jt)), t = i, n = a.theme), i;
  };
}
function co(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const uo = (e) => co(e) && e !== "classes", fo = Gi({
  themeId: M2,
  defaultTheme: P2,
  rootShouldForwardProp: uo
}), po = () => /* @__PURE__ */ f.createElement(_2, {
  "data-qa": "article-20-theme-sign-up-button-display"
}, /* @__PURE__ */ f.createElement($2, null), "GET OUR NEWSLETTER");
po.displayName = "Article20ThemeSignUpButtonDisplay";
const mo = /* @__PURE__ */ k("span", {
  target: "erbhhn31"
})("color:#4585ff;font-weight:700;font-size:12px;font-family:", ce, ';text-transform:uppercase;&:after{content:"|";margin-inline:6px;color:#000000;}'), go = /* @__PURE__ */ k("span", {
  target: "erbhhn30"
})("color:#000000;font-weight:700;font-size:12px;font-family:", ce, ";text-transform:uppercase;"), Co = () => {
  var e;
  const {
    newsletterItemForDisplay: t
  } = K1();
  return /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement(mo, null, "NEWSLETTER"), /* @__PURE__ */ f.createElement(go, null, t == null || (e = t.summary) === null || e === void 0 ? void 0 : e.text));
};
Co.displayName = "Article20ThemeSummary";
const ho = (e) => /* @__PURE__ */ d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 60, height: 51, viewBox: "0 0 60 51", fill: "none", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_3254_37968)" }, /* @__PURE__ */ d.createElement("rect", { width: 60, height: 51, rx: 6, fill: "url(#paint0_linear_3254_37968)" }), /* @__PURE__ */ d.createElement("path", { d: "M0.276732 19.0391L-1 18.6714V20V51V52H0H60H61V51V20V18.6714L59.7233 19.0391L30 27.5987L0.276732 19.0391Z", fill: "#FFCA05", stroke: "white", strokeWidth: 2 })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("linearGradient", { id: "paint0_linear_3254_37968", x1: 30, y1: 0, x2: 30, y2: 31.875, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ d.createElement("stop", { stopColor: "#FFCA05" }), /* @__PURE__ */ d.createElement("stop", { offset: 1, stopColor: "white" })), /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_3254_37968" }, /* @__PURE__ */ d.createElement("rect", { width: 60, height: 51, rx: 8, fill: "white" })))), vo = (e) => /* @__PURE__ */ d.createElement("svg", { width: 154, height: 24, viewBox: "0 0 154 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1909 3.64817C11.52 4.83676 11.6844 6.3637 11.6844 8.22859H7.07678V6.11617C7.07678 5.55023 6.99861 5.11073 6.84343 4.79998C6.68786 4.48923 6.40891 4.33366 6.00697 4.33366C5.11073 4.33366 4.6628 4.91914 4.6628 6.08896V17.499C4.6628 18.2125 4.75438 18.752 4.93715 19.1179C5.11993 19.4838 5.43987 19.6662 5.897 19.6662C6.35412 19.6662 6.67407 19.4838 6.85722 19.1179C7.03961 18.752 7.13157 18.2125 7.13157 17.499V14.126H5.86979V10.0663H11.6296V23.7807H9.73713L8.94167 21.8059C8.10023 23.2688 6.80243 23.9999 5.04674 23.9999C3.34623 23.9999 2.07985 23.4014 1.24799 22.2036C0.41574 21.0058 0 19.1911 0 16.7591V6.61046C0 4.43482 0.484328 2.78872 1.45375 1.67331C2.42279 0.55828 3.86734 0 5.78741 0C7.34155 0 8.54854 0.311135 9.40799 0.933021C10.2671 1.55452 10.8617 2.45957 11.1909 3.64817ZM13.4941 0.219727H18.2117V19.776H23.0665V23.7805H13.4941V0.219727ZM31.0753 17.5815C31.0753 18.2402 31.0021 18.7521 30.8558 19.118C30.7094 19.4839 30.4259 19.6659 30.0055 19.6659C29.5664 19.6659 29.2648 19.4927 29.1005 19.1452C28.9357 18.798 28.8533 18.2857 28.8533 17.6091V6.11625C28.8533 4.92842 29.2468 4.33374 30.0331 4.33374C30.4534 4.33374 30.732 4.49391 30.8696 4.81385C31.0067 5.13418 31.0753 5.55031 31.0753 6.06222V17.5815ZM30.0054 0C28.1034 0 26.6592 0.51728 25.6714 1.54993C24.6843 2.58295 24.1904 4.1141 24.1904 6.14376V17.3626C24.1904 19.4651 24.6843 21.097 25.6714 22.258C26.6592 23.4198 28.1034 23.9999 30.0054 23.9999C31.9067 23.9999 33.3517 23.424 34.3391 22.2718C35.3265 21.12 35.8204 19.4838 35.8204 17.3626V6.14376C35.8204 4.1141 35.3265 2.58295 34.3391 1.54993C33.3517 0.51728 31.9067 0 30.0054 0ZM42.7868 19.6387C44.0118 19.6387 44.6249 19.054 44.6249 17.8834V14.9484C44.6249 14.2353 44.5195 13.6962 44.3096 13.3302C44.0988 12.9647 43.7287 12.7819 43.1984 12.7819H42.3209V19.6115L42.7868 19.6387ZM43.3079 3.84021H42.3209V9.07892H43.2807C43.6827 9.07892 43.957 8.92795 44.1034 8.62601C44.2498 8.32484 44.323 7.89952 44.323 7.35082V4.99164C44.323 4.22415 43.9842 3.84021 43.3079 3.84021ZM49.0134 6.63766C49.0134 8.88688 48.2083 10.2307 46.5994 10.6698C47.5868 10.9257 48.2819 11.52 48.6842 12.4523C49.0862 13.3853 49.2873 14.6191 49.2873 16.1549C49.2873 18.6604 48.9122 20.5575 48.1627 21.8469C47.4128 23.1355 46.0599 23.7807 44.1034 23.7807H37.7125V0.219556H44.1034C45.8223 0.219556 47.0703 0.64066 47.8474 1.48134C48.6244 2.3224 49.0134 3.69376 49.0134 5.59544V6.63766ZM55.4313 16.2102L56.3092 4.22422H56.5287L57.571 16.2102H55.4313ZM52.4965 0.22002L50.2201 23.7808H54.8009L55.0749 19.9679H57.9276L58.2567 23.7808H62.7276L60.4784 0.22002H52.4965ZM64.1537 0.219727H68.8713V19.776H73.7261V23.7805H64.1537V0.219727ZM78.5473 23.7804H83.1001V0.21958H78.5473V23.7804ZM92.1784 0.21958L94.1532 14.5919L96.1281 0.21958H103.369V23.7804H99.0628V6.80207L96.3476 23.7804H92.1236L89.2437 6.80207V23.7804H84.992V0.21958H92.1784ZM112.133 8.98287C112.051 9.376 111.877 9.67756 111.612 9.88754C111.346 10.0983 110.93 10.2037 110.364 10.2037H110.089V4.49824H110.61C111.269 4.49824 111.708 4.7178 111.927 5.15653C112.146 5.59526 112.256 6.30872 112.256 7.29577C112.256 8.02763 112.215 8.58974 112.133 8.98287ZM115.712 2.04362C114.908 0.827818 113.564 0.219727 111.68 0.219727H105.454V23.7805H110.09V14.4545H112.01C113.856 14.4545 115.136 13.8606 115.85 12.672C116.563 11.4834 116.919 9.71891 116.919 7.37812C116.919 5.03771 116.517 3.25942 115.712 2.04362ZM122.878 4.22422L122 16.2102H124.14L123.098 4.22422H122.878ZM116.788 23.7808L119.066 0.22002H127.047L129.296 23.7808H124.825L124.496 19.9679H121.644L121.37 23.7808H116.788ZM137.415 17.8835C137.415 19.0728 137.049 19.666 136.317 19.666C135.951 19.666 135.677 19.525 135.495 19.2414C135.312 18.9579 135.22 18.5054 135.22 17.8835V6.06191C135.22 5.4952 135.298 5.06566 135.454 4.77292C135.609 4.48056 135.897 4.33381 136.317 4.33381C136.72 4.33381 137.003 4.46217 137.168 4.71813C137.332 4.97447 137.415 5.4404 137.415 6.11632V9.6001H142.105V5.54041C142.105 3.7487 141.574 2.37734 140.514 1.42669C139.454 0.476044 138.055 0.000146484 136.317 0.000146484C134.324 0.000146484 132.861 0.594827 131.929 1.78266C130.997 2.97202 130.53 4.73575 130.53 7.07692V17.9387C130.53 19.8223 131.047 21.3029 132.08 22.3815C133.112 23.4613 134.488 24 136.208 24C140.175 24 142.16 22.0252 142.16 18.0751V13.6322H137.415V17.8835ZM145.753 4.74482H142.955V0.21958H153.268V4.74482H150.47V23.7807H145.753V4.74482Z", fill: "#001246" })), yo = (e) => /* @__PURE__ */ d.createElement("svg", { width: 108, height: 25, viewBox: "0 0 108 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_2024_40345)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0.855469V1.59582H2.9687V23.3497H0V24.0901H2.9687H19.668V19.5134H18.3543V23.3497H9.53687V1.59582H12.5061V0.855469H0Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M65.3869 23.3492V13.1913C65.3869 7.14114 62.2327 5.97756 58.7445 5.97756C56.4436 5.97756 54.5881 6.52053 52.3986 8.03312V6.21206L44.0229 6.21367V6.95018H45.8309L45.8304 23.3492H43.975V24.0896H45.8304H54.2542V23.3492H52.3986V8.96134C53.9572 7.83658 55.4045 7.2549 56.7405 6.9833C58.8559 7.21597 58.8186 10.3602 58.8186 12.8423V23.3492H56.9631V24.0896H58.8186H65.09H67.2425V23.3492H65.3869ZM40.9727 23.3492V6.21034H40.6757L40.6725 6.21367H34.4821V6.21034H32.5938V6.95029H34.4049L34.4043 21.3386C32.8457 22.4633 31.3985 23.045 30.0626 23.3164C27.9473 23.0839 27.9844 19.9397 27.9844 17.4575V6.21034H27.9784V6.21367H19.6063V6.95029H21.4138L21.416 17.1084C21.416 23.1588 24.5704 24.3225 28.0588 24.3225C30.3593 24.3225 32.2149 23.7793 34.4043 22.2668V24.0896H37.0021H42.8281V23.3492H40.9727ZM78.2677 21.2196C74.3341 22.5771 73.3322 20.5215 73.3322 19.0088C73.3322 15.7123 77.2285 14.2359 78.2677 12.2967V21.2196ZM84.836 23.3493V14.9755C84.836 8.1494 81.6446 6.21027 76.8946 6.21027H75.9669C74.9147 6.2121 74.1451 6.31038 74.1451 6.31038C71.7914 6.59229 70.6794 7.12882 70.2099 7.4417C69.2997 8.00586 68.6892 9.04246 68.6892 10.2285C68.6892 12.0169 70.0763 13.4668 71.7875 13.4668C72.7299 13.4668 73.5734 13.0264 74.1416 12.3326C72.8076 12.1121 71.7875 10.9051 71.7875 9.44888C71.7875 8.00758 72.7871 7.35138 74.1011 7.11333C74.1051 7.11237 74.1086 7.11108 74.1128 7.11032C74.8005 6.99807 75.7037 6.99119 76.527 7.06871C76.5722 7.07291 76.8257 7.10839 76.8625 7.12172C78.2365 7.46256 78.2677 8.63807 78.2677 10.6704C77.7852 15.1693 67.506 13.618 67.506 20.2499C67.506 23.4689 69.8438 24.3223 71.7736 24.3223C74.4455 24.3223 77.1544 22.5771 78.2677 21.7238V24.0895H84.5391H86.6915V23.3493H84.836ZM106.294 7.487C106.294 4.92727 104.661 3.37598 101.915 3.37598C99.6141 3.37598 98.1295 3.91884 95.9402 5.43154V3.60876H95.6435C93.194 6.2459 89.9658 6.51749 87.5165 6.51749V7.25777C88.0732 7.25777 88.704 7.25777 89.3718 7.18024V23.3492H87.5165V24.0896H89.3718H97.7957V23.3492H95.9402V6.35965C96.5919 5.89001 97.1887 5.50627 97.7562 5.20736C97.7625 5.20424 97.769 5.20037 97.7754 5.19726C97.8926 5.13586 98.0085 5.07812 98.1233 5.02404C98.492 4.84158 98.9201 4.63622 99.1368 4.57278C99.1385 4.57235 99.1401 4.57213 99.1418 4.5716C99.4232 4.47182 99.7245 4.41741 100.038 4.41741C101.581 4.41741 102.832 5.18435 102.832 6.79704C102.832 8.16341 101.934 9.31021 100.721 9.62869C101.287 10.4118 102.184 10.9182 103.195 10.9182C104.907 10.9182 106.294 9.46848 106.294 7.6801C106.294 7.65301 106.292 7.62624 106.292 7.59936C106.293 7.56194 106.294 7.52485 106.294 7.487Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M106.739 19.7826C106.649 21.232 105.435 22.3801 103.949 22.3801C102.405 22.3801 101.153 21.1401 101.153 19.6103C101.153 18.5162 101.791 17.5701 102.72 17.1201C100.962 17.3702 99.6104 18.8811 99.6104 20.7078C99.6104 22.7094 101.233 24.3319 103.234 24.3319C105.236 24.3319 106.859 22.7094 106.859 20.7078C106.859 20.3881 106.817 20.078 106.739 19.7826Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M100.744 20.4491C100.744 19.0232 101.621 17.7768 102.875 17.1016C101.042 17.2819 99.6104 18.8277 99.6104 20.708C99.6104 22.7095 101.233 24.332 103.234 24.332C103.522 24.332 103.802 24.2984 104.071 24.235C102.215 23.8412 100.744 22.2957 100.744 20.4491Z", fill: "#00CCCC" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_2024_40345" }, /* @__PURE__ */ d.createElement("rect", { width: 107.478, height: 24, fill: "white", transform: "translate(0 0.855469)" })))), bo = (e) => /* @__PURE__ */ d.createElement("svg", { width: 163, height: 24, viewBox: "0 0 163 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_2024_49250)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.71059 10.7704C9.11012 10.8409 9.59435 10.8748 10.1605 10.8748C10.9779 10.8748 11.7558 10.7633 12.4998 10.5431C13.2177 10.3331 13.893 9.99804 14.4946 9.55341C15.0706 9.13034 15.5435 8.58258 15.8781 7.95106C16.2113 7.32141 16.3793 6.60988 16.3793 5.81506C16.3186 4.584 15.9501 3.55906 15.2739 2.73741C14.5833 1.90837 13.6777 1.28559 12.6565 0.937412C11.5511 0.550362 10.3872 0.356936 9.216 0.365647H0V0.592941H2.07529V18.1412H0V18.3685H10.2056V18.1412H7.416V10.3765C7.87765 10.5685 8.30824 10.6998 8.70918 10.7704H8.71059ZM10.7153 1.99906C11.0965 2.93506 11.304 4.16047 11.3336 5.67529C11.3336 6.64094 11.2941 7.45129 11.2122 8.10918C11.1318 8.76706 10.9158 9.34024 10.5656 9.82729C10.2155 10.3158 9.67341 10.5586 8.93929 10.5586C8.81223 10.5586 8.57788 10.5191 8.23906 10.4372C7.95035 10.3751 7.67248 10.2704 7.41459 10.1266V0.592941H8.31529C9.53224 0.592941 10.3341 1.06165 10.7153 1.99906ZM19.5529 6.02824C17.9647 6.69234 16.6953 7.94559 16.0108 9.52518C15.6644 10.3166 15.4819 11.17 15.4744 12.0339C15.4744 13.1972 15.7793 14.2913 16.392 15.3148C16.9853 16.3202 17.8186 17.1628 18.8174 17.7671C19.8254 18.3784 20.8828 18.6847 21.9939 18.6847C23.1233 18.6847 24.1892 18.384 25.1944 17.784C26.1916 17.1919 27.0222 16.3564 27.6085 15.3558C28.2113 14.3393 28.512 13.2452 28.512 12.0776C28.512 11.3322 28.3807 10.5798 28.1167 9.82165C27.8455 9.05274 27.4391 8.33846 26.9167 7.71247C26.3618 7.04768 25.6698 6.5107 24.888 6.13835C24.0692 5.73741 23.1332 5.53129 22.0828 5.52141C21.1948 5.52141 20.3506 5.69082 19.5529 6.02824ZM22.8706 6.21882C23.0527 6.51812 23.1671 6.97129 23.2136 7.57694C23.2602 8.18118 23.2842 9.11435 23.2842 10.3736V12.4179C23.2842 14.4395 23.2645 15.8188 23.2249 16.5572C23.1854 17.2955 23.0781 17.7995 22.9002 18.0692C22.7252 18.3388 22.4089 18.4828 21.9515 18.5012C21.5647 18.5012 21.2753 18.3685 21.0833 18.1031C20.8899 17.8362 20.7628 17.4494 20.7021 16.9412C20.6428 16.4329 20.6132 15.7426 20.6132 14.8673C20.6132 14.6414 20.6174 14.2574 20.6245 13.7153C20.6315 13.1718 20.6358 12.7412 20.6358 12.4193V9.94165C20.6358 8.82212 20.664 7.98212 20.7233 7.42165C20.7798 6.85977 20.9068 6.44471 21.0974 6.17506C21.288 5.90541 21.5873 5.76988 21.9967 5.76988C22.3976 5.76988 22.6885 5.91953 22.8706 6.21882ZM35.3816 6.35435C35.2034 6.5069 35.0589 6.69489 34.9573 6.90635C34.8557 7.11782 34.7992 7.34811 34.7915 7.58259C34.7915 8.12188 34.9807 8.58353 35.3576 8.96612C35.7346 9.34729 36.1906 9.53929 36.7285 9.53929C37.2367 9.53929 37.6616 9.34729 38.0075 8.96188C38.3435 8.60085 38.5288 8.12514 38.5256 7.632C38.4833 6.84988 38.0838 6.27106 37.3256 5.89835C36.5661 5.52424 35.6612 5.33788 34.6122 5.33788C33.6846 5.33281 32.7645 5.50533 31.9016 5.84612C31.0504 6.18494 30.3685 6.67482 29.8546 7.32C29.342 7.9626 29.0698 8.76402 29.0852 9.58588C29.0852 11.2235 30.0452 12.4489 31.9652 13.2621C32.904 13.6532 33.6734 14.0922 34.2706 14.5793C34.8692 15.0649 35.1685 15.6805 35.1685 16.4216C35.1304 17.7529 34.272 18.4193 32.5906 18.4193C31.7901 18.4193 31.1746 18.2979 30.744 18.0579C31.1746 18.0579 31.6758 17.9209 32.2433 17.6485C32.8136 17.3732 33.1256 16.7732 33.1821 15.8499C33.1821 15.2132 32.9788 14.6965 32.5722 14.2984C32.1848 13.9093 31.6627 13.6839 31.1139 13.6687C30.7087 13.6687 30.3304 13.7746 29.976 13.9864C29.6216 14.1995 29.3393 14.4805 29.1261 14.8334C28.9144 15.1835 28.8099 15.5534 28.8099 15.9402C28.8099 16.5656 29.0386 17.0838 29.4974 17.4988C29.9576 17.9125 30.5393 18.2174 31.2438 18.4136C31.9496 18.6085 32.6795 18.7158 33.4362 18.7341C34.1633 18.7341 34.8762 18.6353 35.5736 18.4376C36.2711 18.24 36.9021 17.9435 37.4682 17.5511C38.0329 17.1572 38.4791 16.6744 38.8038 16.0998C39.1285 15.5252 39.2894 14.8744 39.2894 14.1459C39.2753 13.4598 39.1186 12.864 38.8207 12.3614C38.5273 11.864 38.1329 11.4336 37.6631 11.0979C37.0838 10.6961 36.4728 10.342 35.8362 10.0391C35.3677 9.82853 34.9004 9.61535 34.4344 9.39953C33.9662 9.19072 33.5366 8.90434 33.1638 8.55247C32.9984 8.39516 32.8662 8.20629 32.775 7.99703C32.6838 7.78777 32.6355 7.56236 32.6329 7.33412C32.6329 6.80471 32.8885 6.37835 33.4009 6.05365C33.9134 5.72894 34.4852 5.56518 35.1205 5.56518C35.7501 5.56518 36.2739 5.664 36.6904 5.85882C36.2071 5.85208 35.7393 6.02921 35.3816 6.35435ZM40.9101 14.6456C40.9101 15.3911 41.0329 16.0588 41.2772 16.6489C41.5242 17.2376 41.9322 17.7106 42.5054 18.0664C43.0772 18.4235 43.8212 18.6141 44.736 18.6395C45.1228 18.6395 45.5252 18.5534 45.9431 18.3798C46.3624 18.2061 46.7054 17.9605 46.9793 17.64C47.2504 17.3209 47.3873 16.9581 47.3873 16.5515V13.5826H47.2009V16.5064C47.2009 16.7986 47.1304 17.064 46.9849 17.3054C46.8409 17.5454 46.6419 17.664 46.392 17.664C46.1365 17.664 45.9388 17.5412 45.7991 17.2969C45.6579 17.0513 45.5873 16.7887 45.5873 16.5064V6.65647H47.7304V5.76988H45.6325V0.727059C44.9647 1.55435 44.3661 2.14306 43.8367 2.49459C43.3073 2.84612 42.6847 3.02118 41.9675 3.02118C41.6277 3.02194 41.2884 2.99217 40.9539 2.93224V5.72612H39.3191V6.61271H40.9101V14.6456ZM53.0965 0.365647V0.638118H55.8409V18.0974H53.1868V18.3685H58.9948V18.0974H56.16V1.95671L61.2706 18.6395L66.3134 1.752V18.1412H63.8061V18.3685H74.6753V18.1412H71.9308V0.638118H74.5849V0.365647H66.3586L63.9191 8.60753L61.4569 0.367059H53.0965V0.365647ZM76.7689 7.2C76.9341 7.008 77.3068 6.79765 77.8899 6.56894C78.4729 6.33882 79.0899 6.22447 79.7435 6.22447C80.1473 6.22447 80.5129 6.29506 80.8391 6.43765C81.1652 6.58024 81.4249 6.80047 81.6184 7.10118C81.8104 7.39906 81.9078 7.77318 81.9078 8.21929V10.0376C81.9078 10.5784 81.6494 11.0245 81.1341 11.376C80.6188 11.7289 80.0711 11.9633 79.4894 12.0776C78.3656 12.2612 77.64 12.3868 77.3153 12.4489C76.9189 12.5384 76.5349 12.6759 76.1718 12.8584C75.7341 13.0701 75.3784 13.3878 75.1073 13.8127C74.8348 14.2376 74.6922 14.7953 74.6767 15.4871C74.6767 16.0631 74.8151 16.5911 75.0932 17.0711C75.3699 17.5511 75.7609 17.9322 76.2649 18.216C76.7689 18.4984 77.3464 18.6395 77.9944 18.6395C79.0673 18.6395 79.9002 18.3784 80.4988 17.8532C81.0974 17.3294 81.4969 16.7845 81.696 16.2212C81.8979 15.6565 81.9981 15.2753 81.9981 15.0762C81.9981 15.2951 82.0842 15.6847 82.2593 16.248C82.4329 16.8127 82.7901 17.3591 83.3294 17.8899C83.8701 18.4193 84.6381 18.6847 85.6348 18.6847C87.5252 18.6438 88.4697 17.7812 88.4697 16.0955V13.7647H88.2833V16.1478C88.2833 16.5614 88.1788 16.9666 87.9727 17.3633C87.7638 17.7614 87.5379 17.9605 87.2951 17.9605C87.1875 17.9615 87.0811 17.9393 86.9829 17.8955C86.8847 17.8516 86.7971 17.7871 86.7261 17.7064C86.5685 17.5358 86.4839 17.3103 86.4904 17.0781V8.60753C86.4904 7.96941 86.208 7.43859 85.6405 7.01788C85.0758 6.59577 84.3473 6.29082 83.4593 6.10024C82.5482 5.90783 81.6192 5.81224 80.688 5.81506C79.8438 5.81506 79.0433 5.93224 78.2866 6.16659C77.5299 6.40094 76.9115 6.76376 76.4315 7.25647C75.9515 7.74635 75.7115 8.34918 75.7115 9.06353C75.7115 9.72 75.9247 10.2748 76.3525 10.7252C76.7802 11.1769 77.3096 11.4028 77.9435 11.4028C78.3671 11.4028 78.7595 11.2941 79.1224 11.0809C79.477 10.8721 79.774 10.5781 79.9865 10.2256C80.1989 9.87314 80.3202 9.47325 80.3393 9.06212C80.3393 8.64847 80.2362 8.27859 80.0287 7.95106C79.8305 7.63833 79.5566 7.38069 79.2323 7.20201C78.908 7.02334 78.5439 6.92941 78.1737 6.92894C77.4988 6.97976 77.0301 7.07012 76.7689 7.2ZM81.6819 15.3176C81.5601 15.8162 81.361 16.2925 81.0918 16.7294C80.8489 17.1106 80.5976 17.2984 80.3393 17.2984C80.0951 17.28 79.9355 17.1049 79.8593 16.776C79.7817 16.4442 79.7435 15.9925 79.7435 15.4207V14.7388C79.7435 13.9186 79.8 13.2776 79.9144 12.8188C80.0287 12.3572 80.3167 11.9901 80.7769 11.7176C81.0614 11.5534 81.3282 11.3604 81.5732 11.1416C81.6943 11.0325 81.8062 10.9135 81.9078 10.7859V13.7125C81.9078 14.2193 81.8329 14.7544 81.6819 15.3176ZM96.7511 5.27012C96.8668 5.58071 96.9939 5.83906 97.1322 6.04659C97.272 6.25412 97.3567 6.35718 97.3864 6.35718C97.4005 6.35718 97.2536 6.30635 96.9445 6.20188C96.6084 6.09147 96.2662 6.00096 95.9195 5.93082C95.5456 5.85379 95.1648 5.815 94.7831 5.81506C94.0306 5.81506 93.2767 5.952 92.5214 6.22447C91.8068 6.47177 91.1625 6.88833 90.6438 7.43859C90.1482 7.97506 89.8913 8.60612 89.8772 9.33459C89.8772 9.90635 90.0155 10.3976 90.2922 10.8056C90.5704 11.2151 90.8711 11.5285 91.1958 11.7473C91.5219 11.9675 91.7266 12.0776 91.8085 12.0776C91.3638 12.2104 90.8075 12.5167 90.1426 12.9981C89.4762 13.4781 89.1431 14.1854 89.1431 15.12C89.1431 16.0588 89.4537 16.7831 90.0748 17.2941C90.696 17.8024 91.2141 18.1327 91.6278 18.2795C91.1732 18.3459 90.6014 18.5548 89.9167 18.9064C89.232 19.2579 88.8904 19.8508 88.8904 20.6852C88.8904 21.3911 89.1699 21.9939 89.7304 22.4951C90.2908 22.9962 91.0038 23.3704 91.8692 23.6245C92.727 23.874 93.6158 24.0005 94.5092 24C95.7064 24 96.8315 23.8024 97.8889 23.4042C98.9449 23.0075 99.8005 22.4019 100.454 21.5859C101.108 20.7713 101.434 19.7746 101.434 18.5958C101.434 17.6612 101.246 16.8551 100.869 16.176C100.492 15.4984 99.8908 14.9718 99.0621 14.5962C98.2334 14.2221 97.1746 14.0344 95.8857 14.0344C95.6118 14.0344 95.1445 14.0569 94.4852 14.1007C93.8259 14.1459 93.3402 14.1671 93.0297 14.1671C91.6489 14.1671 90.96 13.7986 90.96 13.0588C90.96 12.8442 91.0334 12.6819 91.1816 12.5746C91.4104 12.4197 91.6523 12.2851 91.9045 12.1722C92.0654 12.2795 92.4466 12.4306 93.0452 12.6268C93.6452 12.8216 94.2762 12.9205 94.9398 12.9205C95.7073 12.9113 96.4675 12.7704 97.1873 12.504C97.9264 12.2536 98.5979 11.8362 99.1497 11.2842C99.6762 10.7478 99.9402 10.1195 99.9402 9.39953C99.9402 8.79247 99.8019 8.29835 99.528 7.91294C99.2555 7.52894 98.8433 7.11388 98.2941 6.66777C97.7449 6.22306 97.3454 5.84329 97.0941 5.53129C96.8428 5.21929 96.7172 4.81271 96.7172 4.31435C96.7355 3.81176 96.8668 3.41929 97.1082 3.13553C97.3497 2.85318 97.5501 2.66965 97.7068 2.58494C97.6027 2.77737 97.5071 2.97427 97.4202 3.17506C97.3153 3.38927 97.2557 3.62286 97.2452 3.86118C97.2452 4.36376 97.4344 4.79294 97.8141 5.14588C98.1925 5.49882 98.6329 5.67529 99.1355 5.67529C99.6254 5.67529 100.042 5.50447 100.384 5.16C100.724 4.81553 100.906 4.39765 100.928 3.90494C100.928 3.57176 100.834 3.25835 100.645 2.96471C100.443 2.66498 100.171 2.41973 99.8515 2.25076C99.5323 2.08179 99.1762 1.99436 98.8151 1.99624C98.1882 2.04424 97.6645 2.26165 97.2423 2.65129C96.8216 3.03953 96.5986 3.59435 96.5774 4.31576C96.5774 4.64047 96.6339 4.95953 96.7511 5.27012ZM96.0706 10.1492C96.0706 10.8988 96 11.4904 95.8574 11.9195C95.7148 12.3501 95.4085 12.5788 94.9398 12.6042C94.3892 12.6042 94.0362 12.3035 93.8838 11.7007C93.7285 11.0979 93.6522 10.3242 93.6522 9.37835C93.6522 9.25694 93.6494 9.07059 93.6409 8.81929C93.6345 8.62689 93.6308 8.4344 93.6296 8.24188C93.6296 7.51765 93.7115 6.94729 93.8725 6.52941C94.0334 6.11153 94.3525 5.90259 94.8282 5.90259C95.0424 5.90049 95.2511 5.97006 95.4212 6.10024C95.5962 6.23153 95.7473 6.53788 95.8772 7.02353C96.0057 7.50776 96.0706 8.23059 96.0706 9.19624V10.1492ZM97.2 18.4828C97.6729 18.6169 98.1176 18.864 98.5327 19.2254C98.9492 19.5854 99.1652 20.0866 99.1793 20.7304C99.1793 21.4729 98.9506 22.0673 98.4904 22.5148C98.0043 22.9774 97.4041 23.3024 96.7511 23.4565C96.0173 23.6414 95.263 23.7325 94.5064 23.7275C93.4052 23.7275 92.4932 23.4678 91.7689 22.9468C91.0461 22.4245 90.6833 21.6113 90.6833 20.5031C90.6833 19.608 91.1068 18.8668 91.9496 18.2795H96.1609C96.3812 18.2795 96.7285 18.3473 97.2014 18.4828H97.2ZM103.601 7.2C103.766 7.008 104.14 6.79765 104.723 6.56894C105.313 6.33773 105.942 6.22083 106.576 6.22447C106.981 6.22447 107.346 6.29506 107.672 6.43765C107.997 6.58024 108.257 6.80047 108.45 7.10118C108.644 7.39906 108.74 7.77318 108.74 8.21929V10.0376C108.74 10.5784 108.483 11.0245 107.968 11.376C107.452 11.7289 106.904 11.9633 106.323 12.0776C105.198 12.2612 104.473 12.3868 104.149 12.4489C103.825 12.5125 103.443 12.6494 103.005 12.8584C102.568 13.0701 102.212 13.3878 101.941 13.8127C101.668 14.2376 101.524 14.7953 101.51 15.4871C101.502 16.0431 101.646 16.5908 101.925 17.0715C102.205 17.5523 102.61 17.9479 103.097 18.216C103.602 18.4984 104.178 18.6395 104.826 18.6395C105.899 18.6395 106.734 18.3784 107.332 17.8532C107.929 17.3294 108.329 16.7845 108.529 16.2212C108.73 15.6565 108.83 15.2753 108.83 15.0762C108.83 15.2951 108.918 15.6847 109.091 16.248C109.266 16.8127 109.624 17.3591 110.164 17.8899C110.702 18.4193 111.472 18.6847 112.468 18.6847C114.357 18.6438 115.302 17.7812 115.302 16.0955V13.7647H115.117V16.1478C115.117 16.5614 115.012 16.9666 114.805 17.3633C114.596 17.7614 114.37 17.9605 114.127 17.9605C114.02 17.9613 113.914 17.939 113.816 17.8952C113.718 17.8513 113.63 17.7869 113.56 17.7064C113.401 17.5361 113.316 17.3105 113.322 17.0781V8.60753C113.322 7.96941 113.04 7.43859 112.474 7.01788C111.909 6.59577 111.181 6.29082 110.293 6.10024C109.381 5.90779 108.452 5.8122 107.52 5.81506C106.707 5.81052 105.898 5.92903 105.12 6.16659C104.362 6.40094 103.744 6.76376 103.264 7.25647C103.028 7.49377 102.843 7.77611 102.719 8.08661C102.596 8.39711 102.536 8.72938 102.544 9.06353C102.544 9.72 102.758 10.2748 103.186 10.7252C103.612 11.1769 104.143 11.4028 104.777 11.4028C105.2 11.4028 105.593 11.2941 105.954 11.0809C106.309 10.8721 106.606 10.5781 106.818 10.2256C107.031 9.87314 107.152 9.47325 107.171 9.06212C107.171 8.64847 107.068 8.27859 106.862 7.95106C106.664 7.63814 106.39 7.38036 106.066 7.20166C105.742 7.02296 105.377 6.92915 105.007 6.92894C104.332 6.97976 103.864 7.07012 103.601 7.2ZM108.515 15.3176C108.366 15.8824 108.168 16.3511 107.925 16.7294C107.681 17.1106 107.431 17.2984 107.171 17.2984C106.928 17.28 106.768 17.1049 106.691 16.776C106.614 16.4442 106.576 15.9925 106.576 15.4207V14.7388C106.576 13.9186 106.632 13.2776 106.748 12.8188C106.861 12.3572 107.149 11.9901 107.609 11.7176C107.962 11.5031 108.227 11.3111 108.407 11.1416C108.583 10.9708 108.696 10.8522 108.74 10.7859V13.7125C108.74 14.2193 108.665 14.7544 108.515 15.3176ZM118.9 6.88376C119.372 6.88376 119.771 6.98824 120.097 7.19435C120.422 7.40047 120.822 7.71953 121.295 8.15153C121.768 8.58212 122.197 8.90541 122.582 9.12141C122.968 9.33741 123.439 9.44612 123.994 9.44612C124.801 9.43059 125.445 9.25412 125.922 8.91671C126.4 8.57788 126.726 8.24329 126.899 7.91012C127.073 7.57553 127.177 7.32565 127.21 7.16047C127.117 8.34635 126.815 9.23294 126.299 9.82306C125.787 10.4146 125.183 10.7972 124.488 10.9694C123.792 11.1431 122.921 11.256 121.871 11.3082C121.246 11.3563 120.63 11.4776 120.034 11.6696C119.364 11.8793 118.725 12.1764 118.134 12.5534C117.527 12.9388 117.025 13.4146 116.629 13.9821C116.228 14.5588 116.002 15.2385 115.976 15.9402C115.976 16.3581 116.061 16.7774 116.226 17.1995C116.393 17.6202 116.63 17.9661 116.936 18.2358C117.244 18.5054 117.6 18.6395 118.004 18.6395C118.289 18.6395 118.54 18.5435 118.756 18.3487C118.858 18.2657 118.94 18.1612 118.996 18.0429C119.052 17.9245 119.082 17.7951 119.082 17.664C119.082 17.3026 118.978 17.0259 118.768 16.8367C118.543 16.6405 118.252 16.538 117.954 16.5501C117.64 16.5501 117.39 16.6941 117.202 16.9793C117.014 17.2673 116.921 17.4805 116.921 17.6202C116.921 16.5304 117.435 15.9854 118.464 15.9854C118.986 15.9896 119.438 16.104 119.819 16.3313C120.2 16.5586 120.645 16.8918 121.151 17.3322C121.657 17.7713 122.105 18.1002 122.495 18.3162C122.884 18.5322 123.352 18.6409 123.895 18.6409C124.786 18.6409 125.527 18.3798 126.117 17.8588C126.707 17.3365 127.138 16.6687 127.408 15.8513C127.677 15.0353 127.813 14.1713 127.813 13.2579V11.1967H127.581V12.6042C127.581 13.1478 127.324 13.5784 126.812 13.896C126.302 14.2124 125.713 14.3775 125.113 14.3718C124.749 14.3718 124.422 14.3435 124.132 14.2885C123.74 14.2097 123.351 14.1174 122.965 14.0118C122.478 13.8833 122.072 13.7859 121.748 13.7209C121.386 13.6531 121.018 13.621 120.649 13.6249C119.534 13.6616 118.681 13.9228 118.094 14.4113C117.505 14.8984 117.126 15.4376 116.951 16.0264C116.784 16.5719 116.696 17.1387 116.691 17.7092C116.31 17.0541 116.116 16.4668 116.116 15.9402C116.159 15.1101 116.427 14.4155 116.924 13.8565C117.435 13.2892 118.084 12.8645 118.808 12.624C119.593 12.3552 120.417 12.2174 121.247 12.216C122.411 12.1906 123.453 11.9732 124.372 11.5624C125.29 11.1529 126.007 10.5854 126.525 9.86118C127.042 9.13661 127.33 8.27347 127.351 7.38353C127.358 6.91163 127.221 6.44885 126.959 6.05647C126.697 5.66541 126.352 5.47059 125.927 5.47059C125.64 5.4937 125.372 5.62013 125.171 5.82635C125.07 5.91675 124.989 6.02696 124.933 6.15011C124.877 6.27326 124.846 6.40671 124.844 6.54212C124.845 6.67652 124.873 6.80935 124.926 6.93294C124.978 7.05653 125.055 7.16841 125.152 7.26212C125.243 7.364 125.354 7.44546 125.479 7.50118C125.604 7.55689 125.739 7.5856 125.876 7.58541C126.051 7.58541 126.237 7.50776 126.433 7.35529C126.631 7.20282 126.775 7.07718 126.868 6.97835C126.868 7.14776 126.792 7.35953 126.642 7.61365C126.488 7.86635 126.157 7.99341 125.643 7.99341C125.235 7.99341 124.896 7.90165 124.626 7.72094C124.192 7.40897 123.776 7.07341 123.378 6.71576C122.816 6.22588 122.301 5.85882 121.83 5.61459C121.36 5.37035 120.806 5.24894 120.169 5.24894C119.571 5.25459 118.983 5.41197 118.461 5.70635C117.911 6.00036 117.438 6.42142 117.083 6.93459C116.735 7.42434 116.542 8.00691 116.527 8.60753C116.527 9.28094 116.726 9.87953 117.126 10.4061C117.524 10.9327 118.024 11.1967 118.622 11.1967C118.969 11.1967 119.3 11.1134 119.61 10.9468C119.911 10.7896 120.169 10.5619 120.363 10.2833C120.549 10.0189 120.649 9.70331 120.649 9.37976C120.649 8.89271 120.456 8.46353 120.071 8.09506C119.893 7.91768 119.682 7.7773 119.45 7.68206C119.218 7.58682 118.969 7.53861 118.718 7.54024C118.175 7.54024 117.74 7.73506 117.412 8.12471C117.088 8.50485 116.913 8.99021 116.921 9.48988C116.921 7.75341 117.58 6.88376 118.9 6.88376ZM133.662 4.872C134.058 4.62494 134.356 4.30024 134.555 3.89506C134.753 3.49129 134.853 3.06212 134.853 2.60753C134.853 1.90729 134.623 1.29741 134.164 0.777882C133.704 0.259765 133.059 0 132.226 0C131.397 0 130.749 0.261176 130.28 0.780706C129.812 1.30165 129.577 1.91012 129.577 2.60753C129.577 3.05929 129.68 3.48706 129.884 3.89224C130.087 4.29795 130.401 4.63768 130.79 4.872C131.188 5.12047 131.667 5.24329 132.226 5.24329C132.784 5.24329 133.262 5.12047 133.66 4.872H133.662ZM129.878 6.04235V18.3247H134.555V5.85882H127.897V6.04235H129.877H129.878ZM136.793 6.22447V18.3685H141.466V9.85553C141.466 9.43765 141.522 8.99435 141.641 8.52424C141.757 8.05553 141.919 7.66306 142.127 7.34965C142.334 7.03624 142.566 6.87812 142.821 6.87812C143.421 6.87812 143.72 7.78729 143.72 9.60565C143.72 10.2198 143.685 11.0922 143.613 12.2245C143.543 13.3567 143.5 14.0287 143.49 14.2391C143.49 15.1934 143.651 16.0066 143.973 16.6814C144.296 17.3548 144.74 17.8574 145.303 18.1892C145.868 18.5195 146.507 18.6833 147.223 18.6833C148.36 18.6438 149.129 18.3939 149.538 17.9336C149.944 17.4734 150.147 16.8099 150.147 15.9402V13.8071L149.917 13.7633V15.8965C149.917 17.0965 149.647 17.7318 149.106 17.8024C148.957 17.8108 148.81 17.7687 148.687 17.6829C148.565 17.5971 148.476 17.4725 148.433 17.3294C148.316 17.0132 148.258 16.4598 148.258 15.6692C148.28 14.6628 148.311 13.6567 148.348 12.6508C148.36 12.3868 148.374 11.8715 148.393 11.1021C148.393 7.65741 147.151 5.91106 144.665 5.85882C143.879 5.85882 143.207 6.09035 142.65 6.55482C142.093 7.01788 141.68 7.64188 141.415 8.42541V6.04235H135.572V6.22447H136.792H136.793ZM153.734 6.44047C152.778 7.03202 151.991 7.85947 151.447 8.84329C150.889 9.83133 150.585 10.9429 150.563 12.0776C150.563 13.368 150.857 14.5101 151.441 15.5054C152.006 16.4824 152.83 17.2839 153.823 17.8207C154.825 18.3671 155.927 18.6395 157.127 18.6395C158.651 18.6395 159.802 18.288 160.578 17.5849C161.355 16.8805 161.843 16.1506 162.048 15.3953C162.253 14.6386 162.354 14.0344 162.354 13.5798H162.124C162.124 13.7562 162.085 14.064 162.006 14.5031C161.928 14.9407 161.761 15.4348 161.509 15.9882C161.243 16.5561 160.852 17.0562 160.365 17.4508C159.854 17.8744 159.196 18.1186 158.39 18.1849C157.278 18.1849 156.531 17.6908 156.152 16.7026C155.774 15.7144 155.585 14.6202 155.585 13.4188C155.585 12.9049 155.593 12.6494 155.608 12.6494C156.154 12.8894 156.799 13.0094 157.542 13.0094C158.273 13.0094 158.984 12.8894 159.679 12.6494C160.371 12.4094 160.945 12.0339 161.399 11.5242C161.852 11.0132 162.079 10.3807 162.079 9.62824C162.079 9.04377 161.931 8.50306 161.634 8.00612C161.326 7.49627 160.919 7.05286 160.437 6.70165C159.927 6.32449 159.361 6.03049 158.759 5.83059C158.166 5.62771 157.544 5.52281 156.918 5.52C155.792 5.52515 154.69 5.8439 153.736 6.44047H153.734ZM155.855 6.23012C156.049 5.83059 156.344 5.63153 156.737 5.63153C157.262 5.63153 157.604 5.87576 157.763 6.36282C157.923 6.85129 158.003 7.51624 158.003 8.35906V8.96894C158.003 10.0871 157.919 10.9878 157.746 11.6696C157.577 12.3515 157.163 12.6932 156.507 12.6932C156.266 12.6751 156.03 12.6119 155.812 12.5068C155.646 12.4165 155.562 12.2287 155.562 11.9449V7.632C155.562 7.09553 155.661 6.62965 155.855 6.23012Z", fill: "black" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_2024_49250" }, /* @__PURE__ */ d.createElement("rect", { width: 162.353, height: 24, fill: "white" })))), wo = (e) => /* @__PURE__ */ d.createElement("svg", { width: 187, height: 16, viewBox: "0 0 187 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M153.841 14.4763L154.423 16H151.014L150.026 13.1692H144.076L143.064 16H139.654L145.746 0H148.309L153.515 13.6197L155.306 11.9335C156.364 12.928 157.797 13.2591 159.346 13.2591C161.272 13.2591 162.306 12.5748 162.306 11.3145C162.306 10.7618 162.141 10.2978 161.789 9.98892C161.459 9.70216 161.084 9.54585 160.31 9.43631L158.289 9.17169C156.858 8.97231 155.799 8.55262 155.047 7.86708C154.25 7.11631 153.851 6.09969 153.851 4.77415C153.851 1.968 156.058 0 159.675 0C161.976 0 163.645 0.530462 165.078 1.83385L163.01 3.75754C161.953 2.80615 160.685 2.67446 159.581 2.67446C157.843 2.67446 156.997 3.58031 156.997 4.66338C156.997 5.06092 157.138 5.48062 157.49 5.78954C157.82 6.07754 158.36 6.32 159.041 6.40862L161.014 6.67446C162.54 6.87262 163.504 7.27138 164.208 7.88923C165.101 8.68554 165.5 9.83385 165.5 11.2271C165.5 14.2757 162.8 16 159.299 16C157.089 16 155.341 15.6135 153.841 14.4763ZM70.7308 16V0H81.8077V2.78646H74.0132V6.54031H80.6507V9.32554H74.0132V13.2135H81.8077V16H70.7308ZM63.7388 10.0898L66.2372 0H69.5L65.2021 16H62.5904L59.6428 6.29169L56.6938 16H54.0846L49.8077 0H53.0717L55.5467 10.0898L58.4723 0H60.8132L63.7388 10.0898ZM83.0384 16V0H94.1154V2.78646H86.3209V6.54031H92.9584V9.32554H86.3209V13.2135H94.1154V16H83.0384ZM40.3984 6.67446C41.9246 6.87262 42.8883 7.27138 43.5923 7.88923C44.4858 8.68554 44.8846 9.83385 44.8846 11.2271C44.8846 14.2757 42.1843 16 38.684 16C36.1474 16 34.2212 15.4917 32.5769 13.9225L34.6901 11.9335C35.7486 12.928 37.1812 13.2591 38.7308 13.2591C40.6569 13.2591 41.6908 12.5748 41.6908 11.3145C41.6908 10.7618 41.5258 10.2978 41.1738 9.98892C40.844 9.70216 40.4686 9.54585 39.6944 9.43631L37.6735 9.17169C36.2409 8.97231 35.1837 8.55262 34.4329 7.86708C33.6329 7.11631 33.2341 6.09969 33.2341 4.77415C33.2341 1.968 35.4421 0 39.0594 0C41.3609 0 43.0298 0.530462 44.4624 1.83385L42.3948 3.75754C41.3375 2.80615 40.0698 2.67446 38.9658 2.67446C37.228 2.67446 36.3812 3.58031 36.3812 4.66338C36.3812 5.06092 36.5228 5.48062 36.876 5.78954C37.2034 6.07754 37.7437 6.32 38.4255 6.40862L40.3984 6.67446ZM0.576904 2.78646V0H11.6538V2.78646H7.62183V16H4.6089V2.78646H0.576904ZM21.8963 6.54031V0H25.1923V16H21.8963V9.30462H16.1806V16H12.8846V0H16.1806V6.53908H21.8963V6.54031ZM27.6538 16V0H31.3461V16H27.6538ZM166.731 16V0H170.423V16H166.731ZM176.993 10.5391H181.155L179.109 4.72L176.992 10.5391H176.993ZM180.309 0L186.423 16H183.014L182.026 13.1692H176.076L175.064 16H171.654L177.746 0H180.309ZM144.993 10.5391H149.155L147.109 4.72L144.993 10.5391ZM115.038 16V0H118.731V16H115.038ZM109.715 0L104.168 6.35939L110.115 16H106.307L102.006 8.71877L99.8446 11.1914V16H96.5769V0H99.8446V6.96615L105.742 0H109.715ZM130.362 9.79692V0H133.5V16H130.7L124.331 6.17846V16H121.192V0H123.992L130.362 9.79692Z", fill: "black" })), xo = /* @__PURE__ */ k("div", {
  target: "e90s7e13"
})('display:grid;grid-template:"Title Image" min-content "Description Image" min-content/auto 60px;gap:4px 12px;align-items:center;color:#000000;font-family:', ce, ";"), ko = /* @__PURE__ */ k("div", {
  target: "e90s7e12"
})("grid-area:Title;color:#000000;font-weight:700;font-size:18px;font-family:", ce, ";line-height:25.2px;"), Eo = /* @__PURE__ */ k("div", {
  target: "e90s7e11"
})("grid-area:Description;font-weight:400;font-size:12px;font-family:", Q, ";line-height:14px;"), Ho = /* @__PURE__ */ k("div", {
  target: "e90s7e10"
})({
  name: "g893ev",
  styles: "grid-area:Image"
}), So = () => {
  var e, t;
  const {
    config: n
  } = R(), {
    newsletterItemForDisplay: r
  } = K1(), a = {
    [n.newsletter.globalImpact]: /* @__PURE__ */ f.createElement(vo, null),
    [n.newsletter.lunar]: /* @__PURE__ */ f.createElement(yo, null),
    [n.newsletter.postMag]: /* @__PURE__ */ f.createElement(bo, null),
    [n.newsletter.thisWeekInAsia]: /* @__PURE__ */ f.createElement(wo, null)
  }, i = zn(r), o = (e = r == null ? void 0 : r.entityId) !== null && e !== void 0 ? e : "", s = () => o in a ? a[o] : i;
  return /* @__PURE__ */ f.createElement(xo, {
    "data-qa": "article-20-theme-title"
  }, /* @__PURE__ */ f.createElement(ko, null, s()), /* @__PURE__ */ f.createElement(Eo, null, r == null || (t = r.description) === null || t === void 0 ? void 0 : t.text), /* @__PURE__ */ f.createElement(Ho, null, /* @__PURE__ */ f.createElement(ho, null)));
};
So.displayName = "Article20ThemeTitle";
const To = (e) => /* @__PURE__ */ d.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6364 4.54544V10.6064C15.6364 10.9904 15.4866 11.3184 15.1865 11.5911C14.8863 11.8637 14.5264 12 14.1061 12H1.89388C1.47415 12 1.11368 11.8637 0.813555 11.5911C0.513983 11.3184 0.363647 10.9904 0.363647 10.6064V4.54544L8.01483 7.63631L15.6364 4.54544ZM15.6364 3.60621L8.01483 6.72756L0.363647 3.60621V1.39416C0.363647 1.01016 0.513983 0.681566 0.813555 0.40894C1.11368 0.136313 1.47415 0 1.89388 0H14.1061C14.5264 0 14.8863 0.136313 15.1865 0.40894C15.4866 0.681566 15.6364 1.01016 15.6364 1.39416V3.60621Z", fill: "white" })), Vo = /* @__PURE__ */ k("div", {
  target: "e1ylzbp51"
})("font-size:14px;font-family:", Q, ";"), Lo = /* @__PURE__ */ k(To, {
  target: "e1ylzbp50"
})({
  name: "1o82tng",
  styles: "margin-inline-end:12px"
}), Ao = () => /* @__PURE__ */ f.createElement(Vo, {
  "data-qa": "article-theme-sign-up-button-display"
}, /* @__PURE__ */ f.createElement(Lo, null), "GET OUR NEWSLETTER");
Ao.displayName = "ArticleThemeSignUpButtonDisplay";
const Mo = (e) => /* @__PURE__ */ d.createElement("svg", { width: 154, height: 24, viewBox: "0 0 154 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1909 3.64817C11.52 4.83676 11.6844 6.3637 11.6844 8.22859H7.07678V6.11617C7.07678 5.55023 6.99861 5.11073 6.84343 4.79998C6.68786 4.48923 6.40891 4.33366 6.00697 4.33366C5.11073 4.33366 4.6628 4.91914 4.6628 6.08896V17.499C4.6628 18.2125 4.75438 18.752 4.93715 19.1179C5.11993 19.4838 5.43987 19.6662 5.897 19.6662C6.35412 19.6662 6.67407 19.4838 6.85722 19.1179C7.03961 18.752 7.13157 18.2125 7.13157 17.499V14.126H5.86979V10.0663H11.6296V23.7807H9.73713L8.94167 21.8059C8.10023 23.2688 6.80243 23.9999 5.04674 23.9999C3.34623 23.9999 2.07985 23.4014 1.24799 22.2036C0.41574 21.0058 0 19.1911 0 16.7591V6.61046C0 4.43482 0.484328 2.78872 1.45375 1.67331C2.42279 0.55828 3.86734 0 5.78741 0C7.34155 0 8.54854 0.311135 9.40799 0.933021C10.2671 1.55452 10.8617 2.45957 11.1909 3.64817ZM13.4941 0.219727H18.2117V19.776H23.0665V23.7805H13.4941V0.219727ZM31.0753 17.5815C31.0753 18.2402 31.0021 18.7521 30.8558 19.118C30.7094 19.4839 30.4259 19.6659 30.0055 19.6659C29.5664 19.6659 29.2648 19.4927 29.1005 19.1452C28.9357 18.798 28.8533 18.2857 28.8533 17.6091V6.11625C28.8533 4.92842 29.2468 4.33374 30.0331 4.33374C30.4534 4.33374 30.732 4.49391 30.8696 4.81385C31.0067 5.13418 31.0753 5.55031 31.0753 6.06222V17.5815ZM30.0054 0C28.1034 0 26.6592 0.51728 25.6714 1.54993C24.6843 2.58295 24.1904 4.1141 24.1904 6.14376V17.3626C24.1904 19.4651 24.6843 21.097 25.6714 22.258C26.6592 23.4198 28.1034 23.9999 30.0054 23.9999C31.9067 23.9999 33.3517 23.424 34.3391 22.2718C35.3265 21.12 35.8204 19.4838 35.8204 17.3626V6.14376C35.8204 4.1141 35.3265 2.58295 34.3391 1.54993C33.3517 0.51728 31.9067 0 30.0054 0ZM42.7868 19.6387C44.0118 19.6387 44.6249 19.054 44.6249 17.8834V14.9484C44.6249 14.2353 44.5195 13.6962 44.3096 13.3302C44.0988 12.9647 43.7287 12.7819 43.1984 12.7819H42.3209V19.6115L42.7868 19.6387ZM43.3079 3.84021H42.3209V9.07892H43.2807C43.6827 9.07892 43.957 8.92795 44.1034 8.62601C44.2498 8.32484 44.323 7.89952 44.323 7.35082V4.99164C44.323 4.22415 43.9842 3.84021 43.3079 3.84021ZM49.0134 6.63766C49.0134 8.88688 48.2083 10.2307 46.5994 10.6698C47.5868 10.9257 48.2819 11.52 48.6842 12.4523C49.0862 13.3853 49.2873 14.6191 49.2873 16.1549C49.2873 18.6604 48.9122 20.5575 48.1627 21.8469C47.4128 23.1355 46.0599 23.7807 44.1034 23.7807H37.7125V0.219556H44.1034C45.8223 0.219556 47.0703 0.64066 47.8474 1.48134C48.6244 2.3224 49.0134 3.69376 49.0134 5.59544V6.63766ZM55.4313 16.2102L56.3092 4.22422H56.5287L57.571 16.2102H55.4313ZM52.4965 0.22002L50.2201 23.7808H54.8009L55.0749 19.9679H57.9276L58.2567 23.7808H62.7276L60.4784 0.22002H52.4965ZM64.1537 0.219727H68.8713V19.776H73.7261V23.7805H64.1537V0.219727ZM78.5473 23.7804H83.1001V0.21958H78.5473V23.7804ZM92.1784 0.21958L94.1532 14.5919L96.1281 0.21958H103.369V23.7804H99.0628V6.80207L96.3476 23.7804H92.1236L89.2437 6.80207V23.7804H84.992V0.21958H92.1784ZM112.133 8.98287C112.051 9.376 111.877 9.67756 111.612 9.88754C111.346 10.0983 110.93 10.2037 110.364 10.2037H110.089V4.49824H110.61C111.269 4.49824 111.708 4.7178 111.927 5.15653C112.146 5.59526 112.256 6.30872 112.256 7.29577C112.256 8.02763 112.215 8.58974 112.133 8.98287ZM115.712 2.04362C114.908 0.827818 113.564 0.219727 111.68 0.219727H105.454V23.7805H110.09V14.4545H112.01C113.856 14.4545 115.136 13.8606 115.85 12.672C116.563 11.4834 116.919 9.71891 116.919 7.37812C116.919 5.03771 116.517 3.25942 115.712 2.04362ZM122.878 4.22422L122 16.2102H124.14L123.098 4.22422H122.878ZM116.788 23.7808L119.066 0.22002H127.047L129.296 23.7808H124.825L124.496 19.9679H121.644L121.37 23.7808H116.788ZM137.415 17.8835C137.415 19.0728 137.049 19.666 136.317 19.666C135.951 19.666 135.677 19.525 135.495 19.2414C135.312 18.9579 135.22 18.5054 135.22 17.8835V6.06191C135.22 5.4952 135.298 5.06566 135.454 4.77292C135.609 4.48056 135.897 4.33381 136.317 4.33381C136.72 4.33381 137.003 4.46217 137.168 4.71813C137.332 4.97447 137.415 5.4404 137.415 6.11632V9.6001H142.105V5.54041C142.105 3.7487 141.574 2.37734 140.514 1.42669C139.454 0.476044 138.055 0.000146484 136.317 0.000146484C134.324 0.000146484 132.861 0.594827 131.929 1.78266C130.997 2.97202 130.53 4.73575 130.53 7.07692V17.9387C130.53 19.8223 131.047 21.3029 132.08 22.3815C133.112 23.4613 134.488 24 136.208 24C140.175 24 142.16 22.0252 142.16 18.0751V13.6322H137.415V17.8835ZM145.753 4.74482H142.955V0.21958H153.268V4.74482H150.47V23.7807H145.753V4.74482Z", fill: "#001246" })), Po = (e) => /* @__PURE__ */ d.createElement("svg", { width: 108, height: 25, viewBox: "0 0 108 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_2024_40345)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0.855469V1.59582H2.9687V23.3497H0V24.0901H2.9687H19.668V19.5134H18.3543V23.3497H9.53687V1.59582H12.5061V0.855469H0Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M65.3869 23.3492V13.1913C65.3869 7.14114 62.2327 5.97756 58.7445 5.97756C56.4436 5.97756 54.5881 6.52053 52.3986 8.03312V6.21206L44.0229 6.21367V6.95018H45.8309L45.8304 23.3492H43.975V24.0896H45.8304H54.2542V23.3492H52.3986V8.96134C53.9572 7.83658 55.4045 7.2549 56.7405 6.9833C58.8559 7.21597 58.8186 10.3602 58.8186 12.8423V23.3492H56.9631V24.0896H58.8186H65.09H67.2425V23.3492H65.3869ZM40.9727 23.3492V6.21034H40.6757L40.6725 6.21367H34.4821V6.21034H32.5938V6.95029H34.4049L34.4043 21.3386C32.8457 22.4633 31.3985 23.045 30.0626 23.3164C27.9473 23.0839 27.9844 19.9397 27.9844 17.4575V6.21034H27.9784V6.21367H19.6063V6.95029H21.4138L21.416 17.1084C21.416 23.1588 24.5704 24.3225 28.0588 24.3225C30.3593 24.3225 32.2149 23.7793 34.4043 22.2668V24.0896H37.0021H42.8281V23.3492H40.9727ZM78.2677 21.2196C74.3341 22.5771 73.3322 20.5215 73.3322 19.0088C73.3322 15.7123 77.2285 14.2359 78.2677 12.2967V21.2196ZM84.836 23.3493V14.9755C84.836 8.1494 81.6446 6.21027 76.8946 6.21027H75.9669C74.9147 6.2121 74.1451 6.31038 74.1451 6.31038C71.7914 6.59229 70.6794 7.12882 70.2099 7.4417C69.2997 8.00586 68.6892 9.04246 68.6892 10.2285C68.6892 12.0169 70.0763 13.4668 71.7875 13.4668C72.7299 13.4668 73.5734 13.0264 74.1416 12.3326C72.8076 12.1121 71.7875 10.9051 71.7875 9.44888C71.7875 8.00758 72.7871 7.35138 74.1011 7.11333C74.1051 7.11237 74.1086 7.11108 74.1128 7.11032C74.8005 6.99807 75.7037 6.99119 76.527 7.06871C76.5722 7.07291 76.8257 7.10839 76.8625 7.12172C78.2365 7.46256 78.2677 8.63807 78.2677 10.6704C77.7852 15.1693 67.506 13.618 67.506 20.2499C67.506 23.4689 69.8438 24.3223 71.7736 24.3223C74.4455 24.3223 77.1544 22.5771 78.2677 21.7238V24.0895H84.5391H86.6915V23.3493H84.836ZM106.294 7.487C106.294 4.92727 104.661 3.37598 101.915 3.37598C99.6141 3.37598 98.1295 3.91884 95.9402 5.43154V3.60876H95.6435C93.194 6.2459 89.9658 6.51749 87.5165 6.51749V7.25777C88.0732 7.25777 88.704 7.25777 89.3718 7.18024V23.3492H87.5165V24.0896H89.3718H97.7957V23.3492H95.9402V6.35965C96.5919 5.89001 97.1887 5.50627 97.7562 5.20736C97.7625 5.20424 97.769 5.20037 97.7754 5.19726C97.8926 5.13586 98.0085 5.07812 98.1233 5.02404C98.492 4.84158 98.9201 4.63622 99.1368 4.57278C99.1385 4.57235 99.1401 4.57213 99.1418 4.5716C99.4232 4.47182 99.7245 4.41741 100.038 4.41741C101.581 4.41741 102.832 5.18435 102.832 6.79704C102.832 8.16341 101.934 9.31021 100.721 9.62869C101.287 10.4118 102.184 10.9182 103.195 10.9182C104.907 10.9182 106.294 9.46848 106.294 7.6801C106.294 7.65301 106.292 7.62624 106.292 7.59936C106.293 7.56194 106.294 7.52485 106.294 7.487Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M106.739 19.7826C106.649 21.232 105.435 22.3801 103.949 22.3801C102.405 22.3801 101.153 21.1401 101.153 19.6103C101.153 18.5162 101.791 17.5701 102.72 17.1201C100.962 17.3702 99.6104 18.8811 99.6104 20.7078C99.6104 22.7094 101.233 24.3319 103.234 24.3319C105.236 24.3319 106.859 22.7094 106.859 20.7078C106.859 20.3881 106.817 20.078 106.739 19.7826Z", fill: "#0A0A66" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M100.744 20.4491C100.744 19.0232 101.621 17.7768 102.875 17.1016C101.042 17.2819 99.6104 18.8277 99.6104 20.708C99.6104 22.7095 101.233 24.332 103.234 24.332C103.522 24.332 103.802 24.2984 104.071 24.235C102.215 23.8412 100.744 22.2957 100.744 20.4491Z", fill: "#00CCCC" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_2024_40345" }, /* @__PURE__ */ d.createElement("rect", { width: 107.478, height: 24, fill: "white", transform: "translate(0 0.855469)" })))), _o = (e) => /* @__PURE__ */ d.createElement("svg", { width: 163, height: 24, viewBox: "0 0 163 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_2024_49250)" }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.71059 10.7704C9.11012 10.8409 9.59435 10.8748 10.1605 10.8748C10.9779 10.8748 11.7558 10.7633 12.4998 10.5431C13.2177 10.3331 13.893 9.99804 14.4946 9.55341C15.0706 9.13034 15.5435 8.58258 15.8781 7.95106C16.2113 7.32141 16.3793 6.60988 16.3793 5.81506C16.3186 4.584 15.9501 3.55906 15.2739 2.73741C14.5833 1.90837 13.6777 1.28559 12.6565 0.937412C11.5511 0.550362 10.3872 0.356936 9.216 0.365647H0V0.592941H2.07529V18.1412H0V18.3685H10.2056V18.1412H7.416V10.3765C7.87765 10.5685 8.30824 10.6998 8.70918 10.7704H8.71059ZM10.7153 1.99906C11.0965 2.93506 11.304 4.16047 11.3336 5.67529C11.3336 6.64094 11.2941 7.45129 11.2122 8.10918C11.1318 8.76706 10.9158 9.34024 10.5656 9.82729C10.2155 10.3158 9.67341 10.5586 8.93929 10.5586C8.81223 10.5586 8.57788 10.5191 8.23906 10.4372C7.95035 10.3751 7.67248 10.2704 7.41459 10.1266V0.592941H8.31529C9.53224 0.592941 10.3341 1.06165 10.7153 1.99906ZM19.5529 6.02824C17.9647 6.69234 16.6953 7.94559 16.0108 9.52518C15.6644 10.3166 15.4819 11.17 15.4744 12.0339C15.4744 13.1972 15.7793 14.2913 16.392 15.3148C16.9853 16.3202 17.8186 17.1628 18.8174 17.7671C19.8254 18.3784 20.8828 18.6847 21.9939 18.6847C23.1233 18.6847 24.1892 18.384 25.1944 17.784C26.1916 17.1919 27.0222 16.3564 27.6085 15.3558C28.2113 14.3393 28.512 13.2452 28.512 12.0776C28.512 11.3322 28.3807 10.5798 28.1167 9.82165C27.8455 9.05274 27.4391 8.33846 26.9167 7.71247C26.3618 7.04768 25.6698 6.5107 24.888 6.13835C24.0692 5.73741 23.1332 5.53129 22.0828 5.52141C21.1948 5.52141 20.3506 5.69082 19.5529 6.02824ZM22.8706 6.21882C23.0527 6.51812 23.1671 6.97129 23.2136 7.57694C23.2602 8.18118 23.2842 9.11435 23.2842 10.3736V12.4179C23.2842 14.4395 23.2645 15.8188 23.2249 16.5572C23.1854 17.2955 23.0781 17.7995 22.9002 18.0692C22.7252 18.3388 22.4089 18.4828 21.9515 18.5012C21.5647 18.5012 21.2753 18.3685 21.0833 18.1031C20.8899 17.8362 20.7628 17.4494 20.7021 16.9412C20.6428 16.4329 20.6132 15.7426 20.6132 14.8673C20.6132 14.6414 20.6174 14.2574 20.6245 13.7153C20.6315 13.1718 20.6358 12.7412 20.6358 12.4193V9.94165C20.6358 8.82212 20.664 7.98212 20.7233 7.42165C20.7798 6.85977 20.9068 6.44471 21.0974 6.17506C21.288 5.90541 21.5873 5.76988 21.9967 5.76988C22.3976 5.76988 22.6885 5.91953 22.8706 6.21882ZM35.3816 6.35435C35.2034 6.5069 35.0589 6.69489 34.9573 6.90635C34.8557 7.11782 34.7992 7.34811 34.7915 7.58259C34.7915 8.12188 34.9807 8.58353 35.3576 8.96612C35.7346 9.34729 36.1906 9.53929 36.7285 9.53929C37.2367 9.53929 37.6616 9.34729 38.0075 8.96188C38.3435 8.60085 38.5288 8.12514 38.5256 7.632C38.4833 6.84988 38.0838 6.27106 37.3256 5.89835C36.5661 5.52424 35.6612 5.33788 34.6122 5.33788C33.6846 5.33281 32.7645 5.50533 31.9016 5.84612C31.0504 6.18494 30.3685 6.67482 29.8546 7.32C29.342 7.9626 29.0698 8.76402 29.0852 9.58588C29.0852 11.2235 30.0452 12.4489 31.9652 13.2621C32.904 13.6532 33.6734 14.0922 34.2706 14.5793C34.8692 15.0649 35.1685 15.6805 35.1685 16.4216C35.1304 17.7529 34.272 18.4193 32.5906 18.4193C31.7901 18.4193 31.1746 18.2979 30.744 18.0579C31.1746 18.0579 31.6758 17.9209 32.2433 17.6485C32.8136 17.3732 33.1256 16.7732 33.1821 15.8499C33.1821 15.2132 32.9788 14.6965 32.5722 14.2984C32.1848 13.9093 31.6627 13.6839 31.1139 13.6687C30.7087 13.6687 30.3304 13.7746 29.976 13.9864C29.6216 14.1995 29.3393 14.4805 29.1261 14.8334C28.9144 15.1835 28.8099 15.5534 28.8099 15.9402C28.8099 16.5656 29.0386 17.0838 29.4974 17.4988C29.9576 17.9125 30.5393 18.2174 31.2438 18.4136C31.9496 18.6085 32.6795 18.7158 33.4362 18.7341C34.1633 18.7341 34.8762 18.6353 35.5736 18.4376C36.2711 18.24 36.9021 17.9435 37.4682 17.5511C38.0329 17.1572 38.4791 16.6744 38.8038 16.0998C39.1285 15.5252 39.2894 14.8744 39.2894 14.1459C39.2753 13.4598 39.1186 12.864 38.8207 12.3614C38.5273 11.864 38.1329 11.4336 37.6631 11.0979C37.0838 10.6961 36.4728 10.342 35.8362 10.0391C35.3677 9.82853 34.9004 9.61535 34.4344 9.39953C33.9662 9.19072 33.5366 8.90434 33.1638 8.55247C32.9984 8.39516 32.8662 8.20629 32.775 7.99703C32.6838 7.78777 32.6355 7.56236 32.6329 7.33412C32.6329 6.80471 32.8885 6.37835 33.4009 6.05365C33.9134 5.72894 34.4852 5.56518 35.1205 5.56518C35.7501 5.56518 36.2739 5.664 36.6904 5.85882C36.2071 5.85208 35.7393 6.02921 35.3816 6.35435ZM40.9101 14.6456C40.9101 15.3911 41.0329 16.0588 41.2772 16.6489C41.5242 17.2376 41.9322 17.7106 42.5054 18.0664C43.0772 18.4235 43.8212 18.6141 44.736 18.6395C45.1228 18.6395 45.5252 18.5534 45.9431 18.3798C46.3624 18.2061 46.7054 17.9605 46.9793 17.64C47.2504 17.3209 47.3873 16.9581 47.3873 16.5515V13.5826H47.2009V16.5064C47.2009 16.7986 47.1304 17.064 46.9849 17.3054C46.8409 17.5454 46.6419 17.664 46.392 17.664C46.1365 17.664 45.9388 17.5412 45.7991 17.2969C45.6579 17.0513 45.5873 16.7887 45.5873 16.5064V6.65647H47.7304V5.76988H45.6325V0.727059C44.9647 1.55435 44.3661 2.14306 43.8367 2.49459C43.3073 2.84612 42.6847 3.02118 41.9675 3.02118C41.6277 3.02194 41.2884 2.99217 40.9539 2.93224V5.72612H39.3191V6.61271H40.9101V14.6456ZM53.0965 0.365647V0.638118H55.8409V18.0974H53.1868V18.3685H58.9948V18.0974H56.16V1.95671L61.2706 18.6395L66.3134 1.752V18.1412H63.8061V18.3685H74.6753V18.1412H71.9308V0.638118H74.5849V0.365647H66.3586L63.9191 8.60753L61.4569 0.367059H53.0965V0.365647ZM76.7689 7.2C76.9341 7.008 77.3068 6.79765 77.8899 6.56894C78.4729 6.33882 79.0899 6.22447 79.7435 6.22447C80.1473 6.22447 80.5129 6.29506 80.8391 6.43765C81.1652 6.58024 81.4249 6.80047 81.6184 7.10118C81.8104 7.39906 81.9078 7.77318 81.9078 8.21929V10.0376C81.9078 10.5784 81.6494 11.0245 81.1341 11.376C80.6188 11.7289 80.0711 11.9633 79.4894 12.0776C78.3656 12.2612 77.64 12.3868 77.3153 12.4489C76.9189 12.5384 76.5349 12.6759 76.1718 12.8584C75.7341 13.0701 75.3784 13.3878 75.1073 13.8127C74.8348 14.2376 74.6922 14.7953 74.6767 15.4871C74.6767 16.0631 74.8151 16.5911 75.0932 17.0711C75.3699 17.5511 75.7609 17.9322 76.2649 18.216C76.7689 18.4984 77.3464 18.6395 77.9944 18.6395C79.0673 18.6395 79.9002 18.3784 80.4988 17.8532C81.0974 17.3294 81.4969 16.7845 81.696 16.2212C81.8979 15.6565 81.9981 15.2753 81.9981 15.0762C81.9981 15.2951 82.0842 15.6847 82.2593 16.248C82.4329 16.8127 82.7901 17.3591 83.3294 17.8899C83.8701 18.4193 84.6381 18.6847 85.6348 18.6847C87.5252 18.6438 88.4697 17.7812 88.4697 16.0955V13.7647H88.2833V16.1478C88.2833 16.5614 88.1788 16.9666 87.9727 17.3633C87.7638 17.7614 87.5379 17.9605 87.2951 17.9605C87.1875 17.9615 87.0811 17.9393 86.9829 17.8955C86.8847 17.8516 86.7971 17.7871 86.7261 17.7064C86.5685 17.5358 86.4839 17.3103 86.4904 17.0781V8.60753C86.4904 7.96941 86.208 7.43859 85.6405 7.01788C85.0758 6.59577 84.3473 6.29082 83.4593 6.10024C82.5482 5.90783 81.6192 5.81224 80.688 5.81506C79.8438 5.81506 79.0433 5.93224 78.2866 6.16659C77.5299 6.40094 76.9115 6.76376 76.4315 7.25647C75.9515 7.74635 75.7115 8.34918 75.7115 9.06353C75.7115 9.72 75.9247 10.2748 76.3525 10.7252C76.7802 11.1769 77.3096 11.4028 77.9435 11.4028C78.3671 11.4028 78.7595 11.2941 79.1224 11.0809C79.477 10.8721 79.774 10.5781 79.9865 10.2256C80.1989 9.87314 80.3202 9.47325 80.3393 9.06212C80.3393 8.64847 80.2362 8.27859 80.0287 7.95106C79.8305 7.63833 79.5566 7.38069 79.2323 7.20201C78.908 7.02334 78.5439 6.92941 78.1737 6.92894C77.4988 6.97976 77.0301 7.07012 76.7689 7.2ZM81.6819 15.3176C81.5601 15.8162 81.361 16.2925 81.0918 16.7294C80.8489 17.1106 80.5976 17.2984 80.3393 17.2984C80.0951 17.28 79.9355 17.1049 79.8593 16.776C79.7817 16.4442 79.7435 15.9925 79.7435 15.4207V14.7388C79.7435 13.9186 79.8 13.2776 79.9144 12.8188C80.0287 12.3572 80.3167 11.9901 80.7769 11.7176C81.0614 11.5534 81.3282 11.3604 81.5732 11.1416C81.6943 11.0325 81.8062 10.9135 81.9078 10.7859V13.7125C81.9078 14.2193 81.8329 14.7544 81.6819 15.3176ZM96.7511 5.27012C96.8668 5.58071 96.9939 5.83906 97.1322 6.04659C97.272 6.25412 97.3567 6.35718 97.3864 6.35718C97.4005 6.35718 97.2536 6.30635 96.9445 6.20188C96.6084 6.09147 96.2662 6.00096 95.9195 5.93082C95.5456 5.85379 95.1648 5.815 94.7831 5.81506C94.0306 5.81506 93.2767 5.952 92.5214 6.22447C91.8068 6.47177 91.1625 6.88833 90.6438 7.43859C90.1482 7.97506 89.8913 8.60612 89.8772 9.33459C89.8772 9.90635 90.0155 10.3976 90.2922 10.8056C90.5704 11.2151 90.8711 11.5285 91.1958 11.7473C91.5219 11.9675 91.7266 12.0776 91.8085 12.0776C91.3638 12.2104 90.8075 12.5167 90.1426 12.9981C89.4762 13.4781 89.1431 14.1854 89.1431 15.12C89.1431 16.0588 89.4537 16.7831 90.0748 17.2941C90.696 17.8024 91.2141 18.1327 91.6278 18.2795C91.1732 18.3459 90.6014 18.5548 89.9167 18.9064C89.232 19.2579 88.8904 19.8508 88.8904 20.6852C88.8904 21.3911 89.1699 21.9939 89.7304 22.4951C90.2908 22.9962 91.0038 23.3704 91.8692 23.6245C92.727 23.874 93.6158 24.0005 94.5092 24C95.7064 24 96.8315 23.8024 97.8889 23.4042C98.9449 23.0075 99.8005 22.4019 100.454 21.5859C101.108 20.7713 101.434 19.7746 101.434 18.5958C101.434 17.6612 101.246 16.8551 100.869 16.176C100.492 15.4984 99.8908 14.9718 99.0621 14.5962C98.2334 14.2221 97.1746 14.0344 95.8857 14.0344C95.6118 14.0344 95.1445 14.0569 94.4852 14.1007C93.8259 14.1459 93.3402 14.1671 93.0297 14.1671C91.6489 14.1671 90.96 13.7986 90.96 13.0588C90.96 12.8442 91.0334 12.6819 91.1816 12.5746C91.4104 12.4197 91.6523 12.2851 91.9045 12.1722C92.0654 12.2795 92.4466 12.4306 93.0452 12.6268C93.6452 12.8216 94.2762 12.9205 94.9398 12.9205C95.7073 12.9113 96.4675 12.7704 97.1873 12.504C97.9264 12.2536 98.5979 11.8362 99.1497 11.2842C99.6762 10.7478 99.9402 10.1195 99.9402 9.39953C99.9402 8.79247 99.8019 8.29835 99.528 7.91294C99.2555 7.52894 98.8433 7.11388 98.2941 6.66777C97.7449 6.22306 97.3454 5.84329 97.0941 5.53129C96.8428 5.21929 96.7172 4.81271 96.7172 4.31435C96.7355 3.81176 96.8668 3.41929 97.1082 3.13553C97.3497 2.85318 97.5501 2.66965 97.7068 2.58494C97.6027 2.77737 97.5071 2.97427 97.4202 3.17506C97.3153 3.38927 97.2557 3.62286 97.2452 3.86118C97.2452 4.36376 97.4344 4.79294 97.8141 5.14588C98.1925 5.49882 98.6329 5.67529 99.1355 5.67529C99.6254 5.67529 100.042 5.50447 100.384 5.16C100.724 4.81553 100.906 4.39765 100.928 3.90494C100.928 3.57176 100.834 3.25835 100.645 2.96471C100.443 2.66498 100.171 2.41973 99.8515 2.25076C99.5323 2.08179 99.1762 1.99436 98.8151 1.99624C98.1882 2.04424 97.6645 2.26165 97.2423 2.65129C96.8216 3.03953 96.5986 3.59435 96.5774 4.31576C96.5774 4.64047 96.6339 4.95953 96.7511 5.27012ZM96.0706 10.1492C96.0706 10.8988 96 11.4904 95.8574 11.9195C95.7148 12.3501 95.4085 12.5788 94.9398 12.6042C94.3892 12.6042 94.0362 12.3035 93.8838 11.7007C93.7285 11.0979 93.6522 10.3242 93.6522 9.37835C93.6522 9.25694 93.6494 9.07059 93.6409 8.81929C93.6345 8.62689 93.6308 8.4344 93.6296 8.24188C93.6296 7.51765 93.7115 6.94729 93.8725 6.52941C94.0334 6.11153 94.3525 5.90259 94.8282 5.90259C95.0424 5.90049 95.2511 5.97006 95.4212 6.10024C95.5962 6.23153 95.7473 6.53788 95.8772 7.02353C96.0057 7.50776 96.0706 8.23059 96.0706 9.19624V10.1492ZM97.2 18.4828C97.6729 18.6169 98.1176 18.864 98.5327 19.2254C98.9492 19.5854 99.1652 20.0866 99.1793 20.7304C99.1793 21.4729 98.9506 22.0673 98.4904 22.5148C98.0043 22.9774 97.4041 23.3024 96.7511 23.4565C96.0173 23.6414 95.263 23.7325 94.5064 23.7275C93.4052 23.7275 92.4932 23.4678 91.7689 22.9468C91.0461 22.4245 90.6833 21.6113 90.6833 20.5031C90.6833 19.608 91.1068 18.8668 91.9496 18.2795H96.1609C96.3812 18.2795 96.7285 18.3473 97.2014 18.4828H97.2ZM103.601 7.2C103.766 7.008 104.14 6.79765 104.723 6.56894C105.313 6.33773 105.942 6.22083 106.576 6.22447C106.981 6.22447 107.346 6.29506 107.672 6.43765C107.997 6.58024 108.257 6.80047 108.45 7.10118C108.644 7.39906 108.74 7.77318 108.74 8.21929V10.0376C108.74 10.5784 108.483 11.0245 107.968 11.376C107.452 11.7289 106.904 11.9633 106.323 12.0776C105.198 12.2612 104.473 12.3868 104.149 12.4489C103.825 12.5125 103.443 12.6494 103.005 12.8584C102.568 13.0701 102.212 13.3878 101.941 13.8127C101.668 14.2376 101.524 14.7953 101.51 15.4871C101.502 16.0431 101.646 16.5908 101.925 17.0715C102.205 17.5523 102.61 17.9479 103.097 18.216C103.602 18.4984 104.178 18.6395 104.826 18.6395C105.899 18.6395 106.734 18.3784 107.332 17.8532C107.929 17.3294 108.329 16.7845 108.529 16.2212C108.73 15.6565 108.83 15.2753 108.83 15.0762C108.83 15.2951 108.918 15.6847 109.091 16.248C109.266 16.8127 109.624 17.3591 110.164 17.8899C110.702 18.4193 111.472 18.6847 112.468 18.6847C114.357 18.6438 115.302 17.7812 115.302 16.0955V13.7647H115.117V16.1478C115.117 16.5614 115.012 16.9666 114.805 17.3633C114.596 17.7614 114.37 17.9605 114.127 17.9605C114.02 17.9613 113.914 17.939 113.816 17.8952C113.718 17.8513 113.63 17.7869 113.56 17.7064C113.401 17.5361 113.316 17.3105 113.322 17.0781V8.60753C113.322 7.96941 113.04 7.43859 112.474 7.01788C111.909 6.59577 111.181 6.29082 110.293 6.10024C109.381 5.90779 108.452 5.8122 107.52 5.81506C106.707 5.81052 105.898 5.92903 105.12 6.16659C104.362 6.40094 103.744 6.76376 103.264 7.25647C103.028 7.49377 102.843 7.77611 102.719 8.08661C102.596 8.39711 102.536 8.72938 102.544 9.06353C102.544 9.72 102.758 10.2748 103.186 10.7252C103.612 11.1769 104.143 11.4028 104.777 11.4028C105.2 11.4028 105.593 11.2941 105.954 11.0809C106.309 10.8721 106.606 10.5781 106.818 10.2256C107.031 9.87314 107.152 9.47325 107.171 9.06212C107.171 8.64847 107.068 8.27859 106.862 7.95106C106.664 7.63814 106.39 7.38036 106.066 7.20166C105.742 7.02296 105.377 6.92915 105.007 6.92894C104.332 6.97976 103.864 7.07012 103.601 7.2ZM108.515 15.3176C108.366 15.8824 108.168 16.3511 107.925 16.7294C107.681 17.1106 107.431 17.2984 107.171 17.2984C106.928 17.28 106.768 17.1049 106.691 16.776C106.614 16.4442 106.576 15.9925 106.576 15.4207V14.7388C106.576 13.9186 106.632 13.2776 106.748 12.8188C106.861 12.3572 107.149 11.9901 107.609 11.7176C107.962 11.5031 108.227 11.3111 108.407 11.1416C108.583 10.9708 108.696 10.8522 108.74 10.7859V13.7125C108.74 14.2193 108.665 14.7544 108.515 15.3176ZM118.9 6.88376C119.372 6.88376 119.771 6.98824 120.097 7.19435C120.422 7.40047 120.822 7.71953 121.295 8.15153C121.768 8.58212 122.197 8.90541 122.582 9.12141C122.968 9.33741 123.439 9.44612 123.994 9.44612C124.801 9.43059 125.445 9.25412 125.922 8.91671C126.4 8.57788 126.726 8.24329 126.899 7.91012C127.073 7.57553 127.177 7.32565 127.21 7.16047C127.117 8.34635 126.815 9.23294 126.299 9.82306C125.787 10.4146 125.183 10.7972 124.488 10.9694C123.792 11.1431 122.921 11.256 121.871 11.3082C121.246 11.3563 120.63 11.4776 120.034 11.6696C119.364 11.8793 118.725 12.1764 118.134 12.5534C117.527 12.9388 117.025 13.4146 116.629 13.9821C116.228 14.5588 116.002 15.2385 115.976 15.9402C115.976 16.3581 116.061 16.7774 116.226 17.1995C116.393 17.6202 116.63 17.9661 116.936 18.2358C117.244 18.5054 117.6 18.6395 118.004 18.6395C118.289 18.6395 118.54 18.5435 118.756 18.3487C118.858 18.2657 118.94 18.1612 118.996 18.0429C119.052 17.9245 119.082 17.7951 119.082 17.664C119.082 17.3026 118.978 17.0259 118.768 16.8367C118.543 16.6405 118.252 16.538 117.954 16.5501C117.64 16.5501 117.39 16.6941 117.202 16.9793C117.014 17.2673 116.921 17.4805 116.921 17.6202C116.921 16.5304 117.435 15.9854 118.464 15.9854C118.986 15.9896 119.438 16.104 119.819 16.3313C120.2 16.5586 120.645 16.8918 121.151 17.3322C121.657 17.7713 122.105 18.1002 122.495 18.3162C122.884 18.5322 123.352 18.6409 123.895 18.6409C124.786 18.6409 125.527 18.3798 126.117 17.8588C126.707 17.3365 127.138 16.6687 127.408 15.8513C127.677 15.0353 127.813 14.1713 127.813 13.2579V11.1967H127.581V12.6042C127.581 13.1478 127.324 13.5784 126.812 13.896C126.302 14.2124 125.713 14.3775 125.113 14.3718C124.749 14.3718 124.422 14.3435 124.132 14.2885C123.74 14.2097 123.351 14.1174 122.965 14.0118C122.478 13.8833 122.072 13.7859 121.748 13.7209C121.386 13.6531 121.018 13.621 120.649 13.6249C119.534 13.6616 118.681 13.9228 118.094 14.4113C117.505 14.8984 117.126 15.4376 116.951 16.0264C116.784 16.5719 116.696 17.1387 116.691 17.7092C116.31 17.0541 116.116 16.4668 116.116 15.9402C116.159 15.1101 116.427 14.4155 116.924 13.8565C117.435 13.2892 118.084 12.8645 118.808 12.624C119.593 12.3552 120.417 12.2174 121.247 12.216C122.411 12.1906 123.453 11.9732 124.372 11.5624C125.29 11.1529 126.007 10.5854 126.525 9.86118C127.042 9.13661 127.33 8.27347 127.351 7.38353C127.358 6.91163 127.221 6.44885 126.959 6.05647C126.697 5.66541 126.352 5.47059 125.927 5.47059C125.64 5.4937 125.372 5.62013 125.171 5.82635C125.07 5.91675 124.989 6.02696 124.933 6.15011C124.877 6.27326 124.846 6.40671 124.844 6.54212C124.845 6.67652 124.873 6.80935 124.926 6.93294C124.978 7.05653 125.055 7.16841 125.152 7.26212C125.243 7.364 125.354 7.44546 125.479 7.50118C125.604 7.55689 125.739 7.5856 125.876 7.58541C126.051 7.58541 126.237 7.50776 126.433 7.35529C126.631 7.20282 126.775 7.07718 126.868 6.97835C126.868 7.14776 126.792 7.35953 126.642 7.61365C126.488 7.86635 126.157 7.99341 125.643 7.99341C125.235 7.99341 124.896 7.90165 124.626 7.72094C124.192 7.40897 123.776 7.07341 123.378 6.71576C122.816 6.22588 122.301 5.85882 121.83 5.61459C121.36 5.37035 120.806 5.24894 120.169 5.24894C119.571 5.25459 118.983 5.41197 118.461 5.70635C117.911 6.00036 117.438 6.42142 117.083 6.93459C116.735 7.42434 116.542 8.00691 116.527 8.60753C116.527 9.28094 116.726 9.87953 117.126 10.4061C117.524 10.9327 118.024 11.1967 118.622 11.1967C118.969 11.1967 119.3 11.1134 119.61 10.9468C119.911 10.7896 120.169 10.5619 120.363 10.2833C120.549 10.0189 120.649 9.70331 120.649 9.37976C120.649 8.89271 120.456 8.46353 120.071 8.09506C119.893 7.91768 119.682 7.7773 119.45 7.68206C119.218 7.58682 118.969 7.53861 118.718 7.54024C118.175 7.54024 117.74 7.73506 117.412 8.12471C117.088 8.50485 116.913 8.99021 116.921 9.48988C116.921 7.75341 117.58 6.88376 118.9 6.88376ZM133.662 4.872C134.058 4.62494 134.356 4.30024 134.555 3.89506C134.753 3.49129 134.853 3.06212 134.853 2.60753C134.853 1.90729 134.623 1.29741 134.164 0.777882C133.704 0.259765 133.059 0 132.226 0C131.397 0 130.749 0.261176 130.28 0.780706C129.812 1.30165 129.577 1.91012 129.577 2.60753C129.577 3.05929 129.68 3.48706 129.884 3.89224C130.087 4.29795 130.401 4.63768 130.79 4.872C131.188 5.12047 131.667 5.24329 132.226 5.24329C132.784 5.24329 133.262 5.12047 133.66 4.872H133.662ZM129.878 6.04235V18.3247H134.555V5.85882H127.897V6.04235H129.877H129.878ZM136.793 6.22447V18.3685H141.466V9.85553C141.466 9.43765 141.522 8.99435 141.641 8.52424C141.757 8.05553 141.919 7.66306 142.127 7.34965C142.334 7.03624 142.566 6.87812 142.821 6.87812C143.421 6.87812 143.72 7.78729 143.72 9.60565C143.72 10.2198 143.685 11.0922 143.613 12.2245C143.543 13.3567 143.5 14.0287 143.49 14.2391C143.49 15.1934 143.651 16.0066 143.973 16.6814C144.296 17.3548 144.74 17.8574 145.303 18.1892C145.868 18.5195 146.507 18.6833 147.223 18.6833C148.36 18.6438 149.129 18.3939 149.538 17.9336C149.944 17.4734 150.147 16.8099 150.147 15.9402V13.8071L149.917 13.7633V15.8965C149.917 17.0965 149.647 17.7318 149.106 17.8024C148.957 17.8108 148.81 17.7687 148.687 17.6829C148.565 17.5971 148.476 17.4725 148.433 17.3294C148.316 17.0132 148.258 16.4598 148.258 15.6692C148.28 14.6628 148.311 13.6567 148.348 12.6508C148.36 12.3868 148.374 11.8715 148.393 11.1021C148.393 7.65741 147.151 5.91106 144.665 5.85882C143.879 5.85882 143.207 6.09035 142.65 6.55482C142.093 7.01788 141.68 7.64188 141.415 8.42541V6.04235H135.572V6.22447H136.792H136.793ZM153.734 6.44047C152.778 7.03202 151.991 7.85947 151.447 8.84329C150.889 9.83133 150.585 10.9429 150.563 12.0776C150.563 13.368 150.857 14.5101 151.441 15.5054C152.006 16.4824 152.83 17.2839 153.823 17.8207C154.825 18.3671 155.927 18.6395 157.127 18.6395C158.651 18.6395 159.802 18.288 160.578 17.5849C161.355 16.8805 161.843 16.1506 162.048 15.3953C162.253 14.6386 162.354 14.0344 162.354 13.5798H162.124C162.124 13.7562 162.085 14.064 162.006 14.5031C161.928 14.9407 161.761 15.4348 161.509 15.9882C161.243 16.5561 160.852 17.0562 160.365 17.4508C159.854 17.8744 159.196 18.1186 158.39 18.1849C157.278 18.1849 156.531 17.6908 156.152 16.7026C155.774 15.7144 155.585 14.6202 155.585 13.4188C155.585 12.9049 155.593 12.6494 155.608 12.6494C156.154 12.8894 156.799 13.0094 157.542 13.0094C158.273 13.0094 158.984 12.8894 159.679 12.6494C160.371 12.4094 160.945 12.0339 161.399 11.5242C161.852 11.0132 162.079 10.3807 162.079 9.62824C162.079 9.04377 161.931 8.50306 161.634 8.00612C161.326 7.49627 160.919 7.05286 160.437 6.70165C159.927 6.32449 159.361 6.03049 158.759 5.83059C158.166 5.62771 157.544 5.52281 156.918 5.52C155.792 5.52515 154.69 5.8439 153.736 6.44047H153.734ZM155.855 6.23012C156.049 5.83059 156.344 5.63153 156.737 5.63153C157.262 5.63153 157.604 5.87576 157.763 6.36282C157.923 6.85129 158.003 7.51624 158.003 8.35906V8.96894C158.003 10.0871 157.919 10.9878 157.746 11.6696C157.577 12.3515 157.163 12.6932 156.507 12.6932C156.266 12.6751 156.03 12.6119 155.812 12.5068C155.646 12.4165 155.562 12.2287 155.562 11.9449V7.632C155.562 7.09553 155.661 6.62965 155.855 6.23012Z", fill: "black" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_2024_49250" }, /* @__PURE__ */ d.createElement("rect", { width: 162.353, height: 24, fill: "white" })))), $o = (e) => /* @__PURE__ */ d.createElement("svg", { width: 187, height: 16, viewBox: "0 0 187 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M153.841 14.4763L154.423 16H151.014L150.026 13.1692H144.076L143.064 16H139.654L145.746 0H148.309L153.515 13.6197L155.306 11.9335C156.364 12.928 157.797 13.2591 159.346 13.2591C161.272 13.2591 162.306 12.5748 162.306 11.3145C162.306 10.7618 162.141 10.2978 161.789 9.98892C161.459 9.70216 161.084 9.54585 160.31 9.43631L158.289 9.17169C156.858 8.97231 155.799 8.55262 155.047 7.86708C154.25 7.11631 153.851 6.09969 153.851 4.77415C153.851 1.968 156.058 0 159.675 0C161.976 0 163.645 0.530462 165.078 1.83385L163.01 3.75754C161.953 2.80615 160.685 2.67446 159.581 2.67446C157.843 2.67446 156.997 3.58031 156.997 4.66338C156.997 5.06092 157.138 5.48062 157.49 5.78954C157.82 6.07754 158.36 6.32 159.041 6.40862L161.014 6.67446C162.54 6.87262 163.504 7.27138 164.208 7.88923C165.101 8.68554 165.5 9.83385 165.5 11.2271C165.5 14.2757 162.8 16 159.299 16C157.089 16 155.341 15.6135 153.841 14.4763ZM70.7308 16V0H81.8077V2.78646H74.0132V6.54031H80.6507V9.32554H74.0132V13.2135H81.8077V16H70.7308ZM63.7388 10.0898L66.2372 0H69.5L65.2021 16H62.5904L59.6428 6.29169L56.6938 16H54.0846L49.8077 0H53.0717L55.5467 10.0898L58.4723 0H60.8132L63.7388 10.0898ZM83.0384 16V0H94.1154V2.78646H86.3209V6.54031H92.9584V9.32554H86.3209V13.2135H94.1154V16H83.0384ZM40.3984 6.67446C41.9246 6.87262 42.8883 7.27138 43.5923 7.88923C44.4858 8.68554 44.8846 9.83385 44.8846 11.2271C44.8846 14.2757 42.1843 16 38.684 16C36.1474 16 34.2212 15.4917 32.5769 13.9225L34.6901 11.9335C35.7486 12.928 37.1812 13.2591 38.7308 13.2591C40.6569 13.2591 41.6908 12.5748 41.6908 11.3145C41.6908 10.7618 41.5258 10.2978 41.1738 9.98892C40.844 9.70216 40.4686 9.54585 39.6944 9.43631L37.6735 9.17169C36.2409 8.97231 35.1837 8.55262 34.4329 7.86708C33.6329 7.11631 33.2341 6.09969 33.2341 4.77415C33.2341 1.968 35.4421 0 39.0594 0C41.3609 0 43.0298 0.530462 44.4624 1.83385L42.3948 3.75754C41.3375 2.80615 40.0698 2.67446 38.9658 2.67446C37.228 2.67446 36.3812 3.58031 36.3812 4.66338C36.3812 5.06092 36.5228 5.48062 36.876 5.78954C37.2034 6.07754 37.7437 6.32 38.4255 6.40862L40.3984 6.67446ZM0.576904 2.78646V0H11.6538V2.78646H7.62183V16H4.6089V2.78646H0.576904ZM21.8963 6.54031V0H25.1923V16H21.8963V9.30462H16.1806V16H12.8846V0H16.1806V6.53908H21.8963V6.54031ZM27.6538 16V0H31.3461V16H27.6538ZM166.731 16V0H170.423V16H166.731ZM176.993 10.5391H181.155L179.109 4.72L176.992 10.5391H176.993ZM180.309 0L186.423 16H183.014L182.026 13.1692H176.076L175.064 16H171.654L177.746 0H180.309ZM144.993 10.5391H149.155L147.109 4.72L144.993 10.5391ZM115.038 16V0H118.731V16H115.038ZM109.715 0L104.168 6.35939L110.115 16H106.307L102.006 8.71877L99.8446 11.1914V16H96.5769V0H99.8446V6.96615L105.742 0H109.715ZM130.362 9.79692V0H133.5V16H130.7L124.331 6.17846V16H121.192V0H123.992L130.362 9.79692Z", fill: "black" })), Oo = (e) => /* @__PURE__ */ d.createElement("svg", { width: 22, height: 19, viewBox: "0 0 22 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1567 3.20829L19.7717 4.20332L11.0769 10.0104L2.3814 4.20332L2.95515 3.20829L11.0769 8.5998L19.1567 3.20829ZM20.4279 2.42031C20.4279 2.08813 20.3184 1.80524 20.1002 1.57014C19.8812 1.33503 19.6209 1.21748 19.3209 1.21748H2.83215C2.5314 1.21748 2.27115 1.33503 2.0529 1.57014C1.8339 1.80524 1.72515 2.08813 1.72515 2.42031V15.6507C1.72515 15.9829 1.8339 16.2665 2.0529 16.5009C2.27115 16.7367 2.5314 16.8535 2.83215 16.8535H19.3209C19.6209 16.8535 19.8812 16.7367 20.1002 16.5009C20.3184 16.2665 20.4279 15.9829 20.4279 15.6507V2.42031ZM20.9207 0.719966C21.3579 1.19018 21.5769 1.75671 21.5769 2.42031V15.6097C21.5769 16.2733 21.3579 16.8406 20.9207 17.3101C20.4827 17.7803 19.9494 18.0146 19.3209 18.0146H2.83215C2.20365 18.0146 1.6704 17.7803 1.23315 17.3101C0.795154 16.8406 0.576904 16.2733 0.576904 15.6097V2.42031C0.576904 1.75671 0.795154 1.19018 1.23315 0.719966C1.6704 0.250513 2.20365 0.0146484 2.83215 0.0146484H19.3209C19.9494 0.0146484 20.4827 0.250513 20.9207 0.719966Z", fill: "black" })), Ro = /* @__PURE__ */ k(Oo, {
  target: "e5xr1380"
})({
  name: "afd8d5",
  styles: "margin-inline-start:12px"
}), Io = () => {
  var e;
  const {
    config: t
  } = R(), {
    newsletterItemForDisplay: n
  } = K1(), r = {
    [t.newsletter.globalImpact]: /* @__PURE__ */ f.createElement(Mo, null),
    [t.newsletter.lunar]: /* @__PURE__ */ f.createElement(Po, null),
    [t.newsletter.postMag]: /* @__PURE__ */ f.createElement(_o, null),
    [t.newsletter.thisWeekInAsia]: /* @__PURE__ */ f.createElement($o, null)
  }, a = zn(n), i = (e = n == null ? void 0 : n.entityId) !== null && e !== void 0 ? e : "";
  return i in r ? /* @__PURE__ */ f.createElement(f.Fragment, null, r[i], /* @__PURE__ */ f.createElement(Ro, null)) : /* @__PURE__ */ f.createElement(f.Fragment, null, a);
};
Io.displayName = "ArticleThemeTitle";
const Do = (e) => /* @__PURE__ */ d.createElement("svg", { width: "16px", height: "18px", viewBox: "0 0 16 18", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("filter", { id: "filter-1" }, /* @__PURE__ */ d.createElement("feColorMatrix", { in: "SourceGraphic", type: "matrix", values: "0 0 0 0 0.000000 0 0 0 0 0.070588 0 0 0 0 0.274510 0 0 0 1.000000 0" }))), /* @__PURE__ */ d.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ d.createElement("g", { id: "icon_savearticle", transform: "translate(-306.000000, -22.000000)" }, /* @__PURE__ */ d.createElement("g", { transform: "translate(306.000000, 22.000000)", fill: "#4585FF", id: "Fill-14" }, /* @__PURE__ */ d.createElement("path", { d: "M14.8618719,3.16414286 C14.8618719,2.62542857 14.6777537,2.15678571 14.3101478,1.75757143 C13.9425419,1.35964286 13.5055764,1.16035714 12.9998818,1.16035714 L3.00011823,1.16035714 C2.49442365,1.16035714 2.05682759,1.35964286 1.68922167,1.75757143 C1.32161576,2.15678571 1.13749754,2.62542857 1.13749754,3.16414286 L1.13749754,16.1016429 L8.06904433,11.5662857 L14.8618719,16.0662857 L14.8618719,3.16414286 Z M15.1374187,0.914142857 C15.7124729,1.52357143 16,2.26221429 16,3.12878571 L16,18 L8.06904433,12.7967143 L0,18 L0,3.12878571 C0,2.26221429 0.287527094,1.52357143 0.861950739,0.914142857 C1.43637438,0.305357143 2.12618719,0 2.93075862,0 L13.0686108,0 C13.8738128,0 14.5629951,0.305357143 15.1374187,0.914142857 L15.1374187,0.914142857 Z" }))))), Bo = (e) => /* @__PURE__ */ d.createElement("svg", { width: "25px", height: "28px", viewBox: "0 0 25 28", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ d.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ d.createElement("g", { id: "icons_bookmarks-copy", transform: "translate(-272.000000, -439.000000)" }, /* @__PURE__ */ d.createElement("g", { id: "icon_bookmark_desktop_on", transform: "translate(272.000000, 439.000000)" }, /* @__PURE__ */ d.createElement("path", { d: "M23.2216749,4.922 C23.2216749,4.084 22.9339901,3.355 22.3596059,2.734 C21.7852217,2.115 21.1024631,1.805 20.3123153,1.805 L4.68768473,1.805 C3.89753695,1.805 3.2137931,2.115 2.63940887,2.734 C2.06502463,3.355 1.7773399,4.084 1.7773399,4.922 L1.7773399,25.047 L12.6078818,17.992 L23.2216749,24.992 L23.2216749,4.922 Z", id: "Path", fill: "#4585FF", opacity: 0.30392674 }), /* @__PURE__ */ d.createElement("path", { d: "M23.2216749,4.922 C23.2216749,4.084 22.9339901,3.355 22.3596059,2.734 C21.7852217,2.115 21.1024631,1.805 20.3123153,1.805 L4.68768473,1.805 C3.89753695,1.805 3.2137931,2.115 2.63940887,2.734 C2.06502463,3.355 1.7773399,4.084 1.7773399,4.922 L1.7773399,25.047 L12.6078818,17.992 L23.2216749,24.992 L23.2216749,4.922 Z M23.6522167,1.422 C24.5507389,2.37 25,3.519 25,4.867 L25,28 L12.6078818,19.906 L0,28 L0,4.867 C0,3.519 0.449261084,2.37 1.34679803,1.422 C2.24433498,0.475 3.32216749,0 4.57931034,0 L20.4197044,0 C21.6778325,0 22.7546798,0.475 23.6522167,1.422 L23.6522167,1.422 Z", id: "Fill-14", fill: "#4585ff" }))))), Fo = /* @__PURE__ */ k("button", {
  target: "e1wwhs9u2"
})({
  name: "6o7kh4",
  styles: "display:flex;justify-content:center;align-items:center;inline-size:30px;block-size:30px;padding:7.5px;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer"
}), fr = {
  name: "16o2qwc",
  styles: "inline-size:100%;block-size:100%"
}, zo = /* @__PURE__ */ k(Do, {
  target: "e1wwhs9u1"
})(fr, ";"), Zo = /* @__PURE__ */ k(Bo, {
  target: "e1wwhs9u0"
})(fr, ";"), pr = ({
  className: e,
  isBookmarked: t,
  onClick: n
}) => {
  const r = (a) => {
    n == null || n(t ? "unbookmark" : "bookmark", a);
  };
  return /* @__PURE__ */ f.createElement(Fo, {
    "aria-label": t ? "unbookmark" : "bookmark",
    className: e,
    onClick: r,
    "data-qa": "bookmark-button"
  }, t ? /* @__PURE__ */ f.createElement(Zo, null) : /* @__PURE__ */ f.createElement(zo, null));
};
pr.displayName = "BookmarkButton";
const Wo = () => {
  const {
    set: e,
    value: t
  } = ae("isFirstTimeVisitNotification", {
    defaultValue: !0
  });
  return {
    isFirstTime: t,
    setIsFirstTime: e
  };
}, No = /* @__PURE__ */ k(N2, {
  target: "egbuww0"
})(".", U2.dot, "{z-index:0;inline-size:4px;block-size:4px;min-inline-size:4px;border-radius:50%;background:#eb4254;transform:none;transition:none;translate:2px 0;}"), Uo = ({
  children: e
}) => {
  const {
    isFirstTime: t
  } = Wo();
  return /* @__PURE__ */ f.createElement(No, {
    invisible: !t,
    variant: "dot",
    "data-qa": "dashboard-badge"
  }, e);
}, mr = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "entityUuids"
  }, {
    defaultValue: null,
    kind: "LocalArgument",
    name: "first"
  }, {
    defaultValue: null,
    kind: "LocalArgument",
    name: "scmpPlusPaywallTypeIds"
  }], t = [{
    fields: [{
      kind: "Variable",
      name: "paywallTypeIds",
      variableName: "scmpPlusPaywallTypeIds"
    }],
    kind: "ObjectValue",
    name: "exclude"
  }, {
    fields: [{
      kind: "Variable",
      name: "entityUuids",
      variableName: "entityUuids"
    }],
    kind: "ObjectValue",
    name: "filter"
  }, {
    kind: "Variable",
    name: "first",
    variableName: "first"
  }], n = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityUuid",
    storageKey: null
  }, r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityId",
    storageKey: null
  }, a = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "__typename",
    storageKey: null
  }, i = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "urlAlias",
    storageKey: null
  }, o = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "headline",
    storageKey: null
  }, s = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "socialHeadline",
    storageKey: null
  }, l = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "id",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "hooksUseReadingHistoryWithArticleQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "ArticleConnection",
        kind: "LinkedField",
        name: "articles",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "ArticleEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Article",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [n, r, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryPanelArticle",
              selections: [a, n, r, i, o, s, {
                alias: null,
                args: null,
                concreteType: "Application",
                kind: "LinkedField",
                name: "application",
                plural: !1,
                selections: [
                  n
                  /*: any*/
                ],
                storageKey: null
              }],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryActionMenuBookmarkButtonArticle",
              selections: [
                i,
                r
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "readingHistoryActionMenuSocialButtonArticle",
              selections: [
                n,
                r,
                i,
                o,
                s
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }, {
              kind: "InlineDataFragmentSpread",
              name: "hooksRemoveReadingHistoryArticle",
              selections: [
                n,
                r
                /*: any*/
              ],
              args: null,
              argumentDefinitions: []
            }],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "hooksUseReadingHistoryWithArticleQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "ArticleConnection",
        kind: "LinkedField",
        name: "articles",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "ArticleEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Article",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [
              n,
              r,
              a,
              i,
              o,
              s,
              {
                alias: null,
                args: null,
                concreteType: "Application",
                kind: "LinkedField",
                name: "application",
                plural: !1,
                selections: [
                  n,
                  l
                  /*: any*/
                ],
                storageKey: null
              },
              l
              /*: any*/
            ],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }]
    },
    params: {
      cacheID: "09c86431a1ac0204ba9edf1bd9f7cdda",
      id: null,
      metadata: {},
      name: "hooksUseReadingHistoryWithArticleQuery",
      operationKind: "query",
      text: `query hooksUseReadingHistoryWithArticleQuery(
  $entityUuids: [String]!
  $first: Int!
  $scmpPlusPaywallTypeIds: [String]
) {
  articles(exclude: {paywallTypeIds: $scmpPlusPaywallTypeIds}, filter: {entityUuids: $entityUuids}, first: $first) {
    edges {
      node {
        entityUuid
        entityId
        ...readingHistoryPanelArticle
        ...readingHistoryActionMenuBookmarkButtonArticle
        ...readingHistoryActionMenuSocialButtonArticle
        ...hooksRemoveReadingHistoryArticle
        id
      }
    }
  }
}

fragment hooksRemoveReadingHistoryArticle on Article {
  entityUuid
  entityId
}

fragment readingHistoryActionMenuBookmarkButtonArticle on Article {
  urlAlias
  entityId
}

fragment readingHistoryActionMenuSocialButtonArticle on Article {
  entityUuid
  entityId
  urlAlias
  headline
  socialHeadline
}

fragment readingHistoryPanelArticle on Article {
  __typename
  entityUuid
  entityId
  urlAlias
  headline
  socialHeadline
  application {
    entityUuid
    id
  }
}
`
    }
  };
}();
mr.hash = "cbde35cb215893f736ea456fd1a2e149";
const gr = {
  kind: "InlineDataFragment",
  name: "hooksRemoveReadingHistoryArticle"
};
gr.hash = "9cf9cb93788ef385dc0937902f020c9b";
var jo = J1, qo = jn, Go = qn, Yo = Nn, Ko = Un, Xo = et, Qo = 200;
function Jo(e, t, n, r) {
  var a = -1, i = qo, o = !0, s = e.length, l = [], c = t.length;
  if (!s)
    return l;
  n && (t = Yo(t, Ko(n))), r ? (i = Go, o = !1) : t.length >= Qo && (i = Xo, o = !1, t = new jo(t));
  e:
    for (; ++a < s; ) {
      var u = e[a], m = n == null ? u : n(u);
      if (u = r || u !== 0 ? u : 0, o && m === m) {
        for (var p = c; p--; )
          if (t[p] === m)
            continue e;
        l.push(u);
      } else i(t, m, r) || l.push(u);
    }
  return l;
}
var e6 = Jo;
function t6(e, t) {
  for (var n = -1, r = t.length, a = e.length; ++n < r; )
    e[a + n] = t[n];
  return e;
}
var Cr = t6, n6 = h1, r6 = qe, a6 = "[object Arguments]";
function i6(e) {
  return r6(e) && n6(e) == a6;
}
var o6 = i6, qt = o6, s6 = qe, hr = Object.prototype, l6 = hr.hasOwnProperty, c6 = hr.propertyIsEnumerable, u6 = qt(/* @__PURE__ */ function() {
  return arguments;
}()) ? qt : function(e) {
  return s6(e) && l6.call(e, "callee") && !c6.call(e, "callee");
}, x1 = u6, d6 = Array.isArray, J = d6, Gt = tt, f6 = x1, p6 = J, Yt = Gt ? Gt.isConcatSpreadable : void 0;
function m6(e) {
  return p6(e) || f6(e) || !!(Yt && e && e[Yt]);
}
var g6 = m6, C6 = Cr, h6 = g6;
function vr(e, t, n, r, a) {
  var i = -1, o = e.length;
  for (n || (n = h6), a || (a = []); ++i < o; ) {
    var s = e[i];
    t > 0 && n(s) ? t > 1 ? vr(s, t - 1, n, r, a) : C6(a, s) : r || (a[a.length] = s);
  }
  return a;
}
var v6 = vr, y6 = e6, b6 = v6, w6 = aa, Kt = ia, x6 = w6(function(e, t) {
  return Kt(e) ? y6(e, b6(t, 1, Kt, !0)) : [];
}), k6 = x6;
const E6 = /* @__PURE__ */ C1(k6);
var H6 = nt;
function S6() {
  this.__data__ = new H6(), this.size = 0;
}
var T6 = S6;
function V6(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var L6 = V6;
function A6(e) {
  return this.__data__.get(e);
}
var M6 = A6;
function P6(e) {
  return this.__data__.has(e);
}
var _6 = P6, $6 = nt, O6 = Gn, R6 = Yn, I6 = 200;
function D6(e, t) {
  var n = this.__data__;
  if (n instanceof $6) {
    var r = n.__data__;
    if (!O6 || r.length < I6 - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new R6(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var B6 = D6, F6 = nt, z6 = T6, Z6 = L6, W6 = M6, N6 = _6, U6 = B6;
function Ae(e) {
  var t = this.__data__ = new F6(e);
  this.size = t.size;
}
Ae.prototype.clear = z6;
Ae.prototype.delete = Z6;
Ae.prototype.get = W6;
Ae.prototype.has = N6;
Ae.prototype.set = U6;
var yr = Ae;
function j6(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var q6 = j6, G6 = J1, Y6 = q6, K6 = et, X6 = 1, Q6 = 2;
function J6(e, t, n, r, a, i) {
  var o = n & X6, s = e.length, l = t.length;
  if (s != l && !(o && l > s))
    return !1;
  var c = i.get(e), u = i.get(t);
  if (c && u)
    return c == t && u == e;
  var m = -1, p = !0, h = n & Q6 ? new G6() : void 0;
  for (i.set(e, t), i.set(t, e); ++m < s; ) {
    var C = e[m], g = t[m];
    if (r)
      var v = o ? r(g, C, m, t, e, i) : r(C, g, m, e, t, i);
    if (v !== void 0) {
      if (v)
        continue;
      p = !1;
      break;
    }
    if (h) {
      if (!Y6(t, function(y, E) {
        if (!K6(h, E) && (C === y || a(C, y, n, r, i)))
          return h.push(E);
      })) {
        p = !1;
        break;
      }
    } else if (!(C === g || a(C, g, n, r, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), p;
}
var br = J6, e0 = Le, t0 = e0.Uint8Array, n0 = t0;
function r0(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, a) {
    n[++t] = [a, r];
  }), n;
}
var a0 = r0;
function i0(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var it = i0, Xt = tt, Qt = n0, o0 = oa, s0 = br, l0 = a0, c0 = it, u0 = 1, d0 = 2, f0 = "[object Boolean]", p0 = "[object Date]", m0 = "[object Error]", g0 = "[object Map]", C0 = "[object Number]", h0 = "[object RegExp]", v0 = "[object Set]", y0 = "[object String]", b0 = "[object Symbol]", w0 = "[object ArrayBuffer]", x0 = "[object DataView]", Jt = Xt ? Xt.prototype : void 0, M1 = Jt ? Jt.valueOf : void 0;
function k0(e, t, n, r, a, i, o) {
  switch (n) {
    case x0:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case w0:
      return !(e.byteLength != t.byteLength || !i(new Qt(e), new Qt(t)));
    case f0:
    case p0:
    case C0:
      return o0(+e, +t);
    case m0:
      return e.name == t.name && e.message == t.message;
    case h0:
    case y0:
      return e == t + "";
    case g0:
      var s = l0;
    case v0:
      var l = r & u0;
      if (s || (s = c0), e.size != t.size && !l)
        return !1;
      var c = o.get(e);
      if (c)
        return c == t;
      r |= d0, o.set(e, t);
      var u = s0(s(e), s(t), r, a, i, o);
      return o.delete(e), u;
    case b0:
      if (M1)
        return M1.call(e) == M1.call(t);
  }
  return !1;
}
var E0 = k0, H0 = Cr, S0 = J;
function T0(e, t, n) {
  var r = t(e);
  return S0(e) ? r : H0(r, n(e));
}
var V0 = T0;
function L0(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = 0, i = []; ++n < r; ) {
    var o = e[n];
    t(o, n, e) && (i[a++] = o);
  }
  return i;
}
var A0 = L0;
function M0() {
  return [];
}
var P0 = M0, _0 = A0, $0 = P0, O0 = Object.prototype, R0 = O0.propertyIsEnumerable, en = Object.getOwnPropertySymbols, I0 = en ? function(e) {
  return e == null ? [] : (e = Object(e), _0(en(e), function(t) {
    return R0.call(e, t);
  }));
} : $0, D0 = I0;
function B0(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var F0 = B0, d1 = { exports: {} };
function z0() {
  return !1;
}
var Z0 = z0;
d1.exports;
(function(e, t) {
  var n = Le, r = Z0, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
  e.exports = c;
})(d1, d1.exports);
var ot = d1.exports, W0 = 9007199254740991, N0 = /^(?:0|[1-9]\d*)$/;
function U0(e, t) {
  var n = typeof e;
  return t = t ?? W0, !!t && (n == "number" || n != "symbol" && N0.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var wr = U0, j0 = h1, q0 = Kn, G0 = qe, Y0 = "[object Arguments]", K0 = "[object Array]", X0 = "[object Boolean]", Q0 = "[object Date]", J0 = "[object Error]", e3 = "[object Function]", t3 = "[object Map]", n3 = "[object Number]", r3 = "[object Object]", a3 = "[object RegExp]", i3 = "[object Set]", o3 = "[object String]", s3 = "[object WeakMap]", l3 = "[object ArrayBuffer]", c3 = "[object DataView]", u3 = "[object Float32Array]", d3 = "[object Float64Array]", f3 = "[object Int8Array]", p3 = "[object Int16Array]", m3 = "[object Int32Array]", g3 = "[object Uint8Array]", C3 = "[object Uint8ClampedArray]", h3 = "[object Uint16Array]", v3 = "[object Uint32Array]", I = {};
I[u3] = I[d3] = I[f3] = I[p3] = I[m3] = I[g3] = I[C3] = I[h3] = I[v3] = !0;
I[Y0] = I[K0] = I[l3] = I[X0] = I[c3] = I[Q0] = I[J0] = I[e3] = I[t3] = I[n3] = I[r3] = I[a3] = I[i3] = I[o3] = I[s3] = !1;
function y3(e) {
  return G0(e) && q0(e.length) && !!I[j0(e)];
}
var b3 = y3, f1 = { exports: {} };
f1.exports;
(function(e, t) {
  var n = sa, r = t && !t.nodeType && t, a = r && !0 && e && !e.nodeType && e, i = a && a.exports === r, o = i && n.process, s = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(f1, f1.exports);
var w3 = f1.exports, x3 = b3, k3 = Un, tn = w3, nn = tn && tn.isTypedArray, E3 = nn ? k3(nn) : x3, st = E3, H3 = F0, S3 = x1, T3 = J, V3 = ot, L3 = wr, A3 = st, M3 = Object.prototype, P3 = M3.hasOwnProperty;
function _3(e, t) {
  var n = T3(e), r = !n && S3(e), a = !n && !r && V3(e), i = !n && !r && !a && A3(e), o = n || r || a || i, s = o ? H3(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || P3.call(e, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    L3(c, l))) && s.push(c);
  return s;
}
var $3 = _3, O3 = Object.prototype;
function R3(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || O3;
  return e === n;
}
var xr = R3;
function I3(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var D3 = I3, B3 = D3, F3 = B3(Object.keys, Object), z3 = F3, Z3 = xr, W3 = z3, N3 = Object.prototype, U3 = N3.hasOwnProperty;
function j3(e) {
  if (!Z3(e))
    return W3(e);
  var t = [];
  for (var n in Object(e))
    U3.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var kr = j3, q3 = $3, G3 = kr, Y3 = rt;
function K3(e) {
  return Y3(e) ? q3(e) : G3(e);
}
var lt = K3, X3 = V0, Q3 = D0, J3 = lt;
function e4(e) {
  return X3(e, J3, Q3);
}
var t4 = e4, rn = t4, n4 = 1, r4 = Object.prototype, a4 = r4.hasOwnProperty;
function i4(e, t, n, r, a, i) {
  var o = n & n4, s = rn(e), l = s.length, c = rn(t), u = c.length;
  if (l != u && !o)
    return !1;
  for (var m = l; m--; ) {
    var p = s[m];
    if (!(o ? p in t : a4.call(t, p)))
      return !1;
  }
  var h = i.get(e), C = i.get(t);
  if (h && C)
    return h == t && C == e;
  var g = !0;
  i.set(e, t), i.set(t, e);
  for (var v = o; ++m < l; ) {
    p = s[m];
    var y = e[p], E = t[p];
    if (r)
      var H = o ? r(E, y, p, t, e, i) : r(y, E, p, e, t, i);
    if (!(H === void 0 ? y === E || a(y, E, n, r, i) : H)) {
      g = !1;
      break;
    }
    v || (v = p == "constructor");
  }
  if (g && !v) {
    var b = e.constructor, w = t.constructor;
    b != w && "constructor" in e && "constructor" in t && !(typeof b == "function" && b instanceof b && typeof w == "function" && w instanceof w) && (g = !1);
  }
  return i.delete(e), i.delete(t), g;
}
var o4 = i4, s4 = v1, l4 = Le, c4 = s4(l4, "DataView"), u4 = c4, d4 = v1, f4 = Le, p4 = d4(f4, "Promise"), m4 = p4, g4 = v1, C4 = Le, h4 = g4(C4, "Set"), Er = h4, v4 = v1, y4 = Le, b4 = v4(y4, "WeakMap"), w4 = b4, D1 = u4, B1 = Gn, F1 = m4, z1 = Er, Z1 = w4, Hr = h1, Me = la, an = "[object Map]", x4 = "[object Object]", on = "[object Promise]", sn = "[object Set]", ln = "[object WeakMap]", cn = "[object DataView]", k4 = Me(D1), E4 = Me(B1), H4 = Me(F1), S4 = Me(z1), T4 = Me(Z1), ge = Hr;
(D1 && ge(new D1(new ArrayBuffer(1))) != cn || B1 && ge(new B1()) != an || F1 && ge(F1.resolve()) != on || z1 && ge(new z1()) != sn || Z1 && ge(new Z1()) != ln) && (ge = function(e) {
  var t = Hr(e), n = t == x4 ? e.constructor : void 0, r = n ? Me(n) : "";
  if (r)
    switch (r) {
      case k4:
        return cn;
      case E4:
        return an;
      case H4:
        return on;
      case S4:
        return sn;
      case T4:
        return ln;
    }
  return t;
});
var Sr = ge, P1 = yr, V4 = br, L4 = E0, A4 = o4, un = Sr, dn = J, fn = ot, M4 = st, P4 = 1, pn = "[object Arguments]", mn = "[object Array]", e1 = "[object Object]", _4 = Object.prototype, gn = _4.hasOwnProperty;
function $4(e, t, n, r, a, i) {
  var o = dn(e), s = dn(t), l = o ? mn : un(e), c = s ? mn : un(t);
  l = l == pn ? e1 : l, c = c == pn ? e1 : c;
  var u = l == e1, m = c == e1, p = l == c;
  if (p && fn(e)) {
    if (!fn(t))
      return !1;
    o = !0, u = !1;
  }
  if (p && !u)
    return i || (i = new P1()), o || M4(e) ? V4(e, t, n, r, a, i) : L4(e, t, l, n, r, a, i);
  if (!(n & P4)) {
    var h = u && gn.call(e, "__wrapped__"), C = m && gn.call(t, "__wrapped__");
    if (h || C) {
      var g = h ? e.value() : e, v = C ? t.value() : t;
      return i || (i = new P1()), a(g, v, n, r, i);
    }
  }
  return p ? (i || (i = new P1()), A4(e, t, n, r, a, i)) : !1;
}
var O4 = $4, R4 = O4, Cn = qe;
function Tr(e, t, n, r, a) {
  return e === t ? !0 : e == null || t == null || !Cn(e) && !Cn(t) ? e !== e && t !== t : R4(e, t, n, r, Tr, a);
}
var Vr = Tr, I4 = yr, D4 = Vr, B4 = 1, F4 = 2;
function z4(e, t, n, r) {
  var a = n.length, i = a, o = !r;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var s = n[a];
    if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    s = n[a];
    var l = s[0], c = e[l], u = s[1];
    if (o && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var m = new I4();
      if (r)
        var p = r(c, u, l, e, t, m);
      if (!(p === void 0 ? D4(u, c, B4 | F4, r, m) : p))
        return !1;
    }
  }
  return !0;
}
var Z4 = z4, W4 = ca;
function N4(e) {
  return e === e && !W4(e);
}
var Lr = N4, U4 = Lr, j4 = lt;
function q4(e) {
  for (var t = j4(e), n = t.length; n--; ) {
    var r = t[n], a = e[r];
    t[n] = [r, a, U4(a)];
  }
  return t;
}
var G4 = q4;
function Y4(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var Ar = Y4, K4 = Z4, X4 = G4, Q4 = Ar;
function J4(e) {
  var t = X4(e);
  return t.length == 1 && t[0][2] ? Q4(t[0][0], t[0][1]) : function(n) {
    return n === e || K4(n, e, t);
  };
}
var e7 = J4, t7 = h1, n7 = qe, r7 = "[object Symbol]";
function a7(e) {
  return typeof e == "symbol" || n7(e) && t7(e) == r7;
}
var ct = a7, i7 = J, o7 = ct, s7 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, l7 = /^\w*$/;
function c7(e, t) {
  if (i7(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || o7(e) ? !0 : l7.test(e) || !s7.test(e) || t != null && e in Object(t);
}
var ut = c7, Mr = Yn, u7 = "Expected a function";
function dt(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(u7);
  var n = function() {
    var r = arguments, a = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, r);
    return n.cache = i.set(a, o) || i, o;
  };
  return n.cache = new (dt.Cache || Mr)(), n;
}
dt.Cache = Mr;
var d7 = dt, f7 = d7, p7 = 500;
function m7(e) {
  var t = f7(e, function(r) {
    return n.size === p7 && n.clear(), r;
  }), n = t.cache;
  return t;
}
var g7 = m7, C7 = g7, h7 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, v7 = /\\(\\)?/g, y7 = C7(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(h7, function(n, r, a, i) {
    t.push(a ? i.replace(v7, "$1") : r || n);
  }), t;
}), b7 = y7, hn = tt, w7 = Nn, x7 = J, k7 = ct, E7 = 1 / 0, vn = hn ? hn.prototype : void 0, yn = vn ? vn.toString : void 0;
function Pr(e) {
  if (typeof e == "string")
    return e;
  if (x7(e))
    return w7(e, Pr) + "";
  if (k7(e))
    return yn ? yn.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -E7 ? "-0" : t;
}
var H7 = Pr, S7 = H7;
function T7(e) {
  return e == null ? "" : S7(e);
}
var V7 = T7, L7 = J, A7 = ut, M7 = b7, P7 = V7;
function _7(e, t) {
  return L7(e) ? e : A7(e, t) ? [e] : M7(P7(e));
}
var _r = _7, $7 = ct, O7 = 1 / 0;
function R7(e) {
  if (typeof e == "string" || $7(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -O7 ? "-0" : t;
}
var k1 = R7, I7 = _r, D7 = k1;
function B7(e, t) {
  t = I7(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[D7(t[n++])];
  return n && n == r ? e : void 0;
}
var $r = B7, F7 = $r;
function z7(e, t, n) {
  var r = e == null ? void 0 : F7(e, t);
  return r === void 0 ? n : r;
}
var Z7 = z7;
function W7(e, t) {
  return e != null && t in Object(e);
}
var N7 = W7, U7 = _r, j7 = x1, q7 = J, G7 = wr, Y7 = Kn, K7 = k1;
function X7(e, t, n) {
  t = U7(t, e);
  for (var r = -1, a = t.length, i = !1; ++r < a; ) {
    var o = K7(t[r]);
    if (!(i = e != null && n(e, o)))
      break;
    e = e[o];
  }
  return i || ++r != a ? i : (a = e == null ? 0 : e.length, !!a && Y7(a) && G7(o, a) && (q7(e) || j7(e)));
}
var Q7 = X7, J7 = N7, e8 = Q7;
function t8(e, t) {
  return e != null && e8(e, t, J7);
}
var n8 = t8, r8 = Vr, a8 = Z7, i8 = n8, o8 = ut, s8 = Lr, l8 = Ar, c8 = k1, u8 = 1, d8 = 2;
function f8(e, t) {
  return o8(e) && s8(t) ? l8(c8(e), t) : function(n) {
    var r = a8(n, e);
    return r === void 0 && r === t ? i8(n, e) : r8(t, r, u8 | d8);
  };
}
var p8 = f8;
function m8(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var g8 = m8, C8 = $r;
function h8(e) {
  return function(t) {
    return C8(t, e);
  };
}
var v8 = h8, y8 = g8, b8 = v8, w8 = ut, x8 = k1;
function k8(e) {
  return w8(e) ? y8(x8(e)) : b8(e);
}
var E8 = k8, H8 = e7, S8 = p8, T8 = ua, V8 = J, L8 = E8;
function A8(e) {
  return typeof e == "function" ? e : e == null ? T8 : typeof e == "object" ? V8(e) ? S8(e[0], e[1]) : H8(e) : L8(e);
}
var Or = A8;
function M8() {
}
var P8 = M8, _1 = Er, _8 = P8, $8 = it, O8 = 1 / 0, R8 = _1 && 1 / $8(new _1([, -0]))[1] == O8 ? function(e) {
  return new _1(e);
} : _8, I8 = R8, D8 = J1, B8 = jn, F8 = qn, z8 = et, Z8 = I8, W8 = it, N8 = 200;
function U8(e, t, n) {
  var r = -1, a = B8, i = e.length, o = !0, s = [], l = s;
  if (n)
    o = !1, a = F8;
  else if (i >= N8) {
    var c = t ? null : Z8(e);
    if (c)
      return W8(c);
    o = !1, a = z8, l = new D8();
  } else
    l = t ? [] : s;
  e:
    for (; ++r < i; ) {
      var u = e[r], m = t ? t(u) : u;
      if (u = n || u !== 0 ? u : 0, o && m === m) {
        for (var p = l.length; p--; )
          if (l[p] === m)
            continue e;
        t && l.push(m), s.push(u);
      } else a(l, m, n) || (l !== s && l.push(m), s.push(u));
    }
  return s;
}
var j8 = U8, q8 = Or, G8 = j8;
function Y8(e, t) {
  return e && e.length ? G8(e, q8(t)) : [];
}
var K8 = Y8;
const X8 = /* @__PURE__ */ C1(K8), bn = async (e, t, n, r = 0) => (await e.get(`items/${t}`, {
  params: {
    limit: n,
    offset: r,
    tz: ft()
  },
  withCredentials: !0
})).data.data || [], Q8 = (e, t, n) => e.post("/create", n.map(({
  createdAt: r,
  entityUuid: a,
  expiresAt: i
}) => ({
  createdAt: r,
  entitySubType: "article",
  entityType: "node",
  entityUuid: a,
  expiresAt: i,
  itemType: "log",
  userUuid: t
})), {
  withCredentials: !0
}), J8 = (e, t, n) => e.post("/items/delete", {
  entityUuids: [t]
}, {
  params: {
    day: Rr(n),
    tz: ft()
  },
  withCredentials: !0
}), e9 = (e, t, n) => e.delete(`/items/${n}`, {
  params: {
    day: Rr(t),
    tz: ft()
  },
  withCredentials: !0
}), ft = () => Intl.DateTimeFormat().resolvedOptions().timeZone, Rr = (e) => or(new Date(e), "yyyy-MM-dd"), $1 = {
  lastSyncedDate: "userArticleReadingHistoryLastUpdate",
  pending: "userNewArticleReadingHistory",
  synced: "userArticleReadingHistory"
}, wn = 50, ke = (e) => or(e, "dd MMM yyyy"), t9 = () => {
  const {
    currentArticleUuid: e,
    user: t
  } = R(), {
    createReadingHistory: n,
    fetchReadingHistory: r,
    lastSyncedDate: a,
    resetLocalReadingHistory: i,
    syncReadingHistory: o
  } = pt();
  Ve(async () => {
    await r();
  }), F(() => {
    t || i();
  }, [i, t]), F(() => {
    e && n(e);
  }, [n, e]), ea(() => {
    Ia(/* @__PURE__ */ new Date(), new Date(a ?? 0)) < 1 || o();
  }, [o, e, a]);
}, n9 = () => {
  const {
    user: e
  } = R(), {
    pendingReadingHistory: t,
    syncedReadingHistory: n
  } = Ir();
  return {
    readingHistory: he(() => e ? [...t ?? [], ...n ?? []].sort((i, o) => o.createdAt - i.createdAt) : [], [t, n, e])
  };
}, pt = () => {
  const {
    config: e,
    handleTrackGA4: t,
    user: n
  } = R(), r = he(() => Q1.create({
    baseURL: e.readingHistory.host,
    headers: {
      apikey: e.readingHistory.apiKey
    }
  }), [e]), {
    lastSyncedDate: a,
    pendingReadingHistory: i,
    setLastSyncedDate: o,
    setPendingReadingHistory: s,
    setSyncedReadingHistory: l
  } = Ir(), c = q(async () => {
    if (!n || a) return;
    const g = await bn(r, n.uuid, wn);
    l(g.map((v) => ({
      createdAt: new Date(v.createdAt).getTime(),
      entityUuid: v.entityUuid
    }))), o(Date.now());
  }, [r, a, o, l, n]), u = q(async () => {
    if (!n || !i || i.length === 0) return;
    const g = i.map((v) => ({
      createdAt: new Date(v.createdAt),
      entityUuid: v.entityUuid,
      expiresAt: new Date(v.createdAt)
    }));
    await Q8(r, n.uuid, g);
    try {
      const v = await bn(r, n.uuid, wn);
      l(v.map((y) => ({
        createdAt: new Date(y.createdAt).getTime(),
        entityUuid: y.entityUuid
      }))), o(Date.now());
    } catch {
      l((v) => [...i ?? [], ...v ?? []]);
    } finally {
      s([]);
    }
  }, [r, i, o, s, l, n]), m = q((g) => {
    if (!n) return;
    const v = {
      createdAt: Date.now(),
      entityUuid: g
    };
    s((y) => X8([v, ...y ?? []], (H) => `${H.entityUuid}-${ke(H.createdAt)}`)), l((y) => [...y ?? []].filter((E) => !(E.entityUuid === v.entityUuid && ke(E.createdAt) === ke(v.createdAt))));
  }, [s, l, n]), p = q(async (g) => {
    if (!n) return;
    const v = (y) => [...y ?? []].filter((E) => ke(E.createdAt) !== g);
    s(v), l(v), await e9(r, g, n.uuid), t({
      action: "click",
      category: "readinghistory",
      customized_parameters: {
        action_type: "clear"
      },
      subcategory: ""
    });
  }, [r, t, s, l, n]), h = q(async (g, v) => {
    if (!n) return;
    const {
      entityId: y,
      entityUuid: E
    } = s1(gr, g), H = (b) => [...b ?? []].filter((w) => !(w.entityUuid === E && w.createdAt === v));
    s(H), l(H), await J8(r, E, ke(v)), t({
      action: "click",
      category: "readinghistory",
      customized_parameters: {
        action_type: "remove",
        article_id: y ?? ""
      },
      subcategory: ""
    });
  }, [r, t, s, l, n]), C = q(() => {
    s([]), l([]), o(0);
  }, [o, s, l]);
  return {
    clearReadingHistory: p,
    createReadingHistory: m,
    fetchReadingHistory: c,
    lastSyncedDate: a,
    removeReadingHistory: h,
    resetLocalReadingHistory: C,
    syncReadingHistory: u
  };
}, Ir = () => {
  const {
    set: e,
    value: t
  } = ae($1.pending), {
    set: n,
    value: r
  } = ae($1.synced), {
    set: a,
    value: i
  } = ae($1.lastSyncedDate);
  return {
    lastSyncedDate: i,
    pendingReadingHistory: t,
    setLastSyncedDate: a,
    setPendingReadingHistory: e,
    setSyncedReadingHistory: n,
    syncedReadingHistory: r
  };
}, r9 = () => {
  const e = Xn(), {
    readingHistory: t
  } = n9(), n = ta(), r = Y1(), [a, i] = je(async () => {
    const o = E6(t.map((l) => l.entityUuid), [...n.keys()]);
    if (o.length > 0) {
      const l = mr, c = {
        entityUuids: [...o],
        first: o.length,
        scmpPlusPaywallTypeIds: [Z2.article.paywallTypeId]
      }, u = pa(l), m = ma(u, c), p = await Qn(e, l, c).toPromise();
      r.current = e.retain(m), p == null || p.articles.edges.forEach(({
        node: h
      }) => {
        n.set(h.entityUuid, h);
      });
    }
    return t.map((l) => {
      const c = n.get(l.entityUuid);
      if (c)
        return {
          ...l,
          article: c
        };
    }).filter(ya);
  }, []);
  return F(() => (i.execute(), () => {
    var o;
    (o = r.current) === null || o === void 0 || o.dispose();
  }), [i, t]), {
    state: a
  };
}, Dr = () => {
  const {
    set: e,
    value: t
  } = ae("isFirstTimeVisitSCMPNotificationWidgetVersionTwo", {
    defaultValue: !0
  });
  return {
    isFirstTime: t,
    setIsFirstTime: e
  };
}, a9 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0157 10.0393L20 18.9843L19.0629 20L10 10.9764L1.01571 20L0 18.9843L8.98429 10.0393L0 1.01571L1.01571 0L10 9.02357L19.0629 0L20 1.01571L11.0157 10.0393Z", fill: "#001246" })), i9 = (e) => /* @__PURE__ */ d.createElement("svg", { width: 32, height: 25, viewBox: "0 0 32 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 25H32V0H0V25Z", fill: "#FEFEFE" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.76069 22.2007H14.6138V2.79626H2.76019L2.76069 22.2007Z", fill: "#FFCA05" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.3866 22.2007H29.2397V2.79626H17.3866V22.2007Z", fill: "#001246" })), o9 = (e) => {
  const [t, n] = je(async () => {
    const a = await Promise.allSettled(e.map((i) => i()));
    for (const i of a)
      if (!(i.status === "rejected" || i.value === null))
        return i.value;
  });
  return Zn(() => {
    n.execute();
  }, [e]), {
    message: t.status === "success" ? t.result : void 0
  };
}, Br = {
  kind: "InlineDataFragment",
  name: "readingHistoryPanelArticle"
};
Br.hash = "af787a050af248c5e8bd042565039780";
const s9 = lo;
function l9(e) {
  return so(e);
}
function c9(e) {
  return cr("MuiSvgIcon", e);
}
Ni("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const u9 = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, a = {
    root: ["root", t !== "inherit" && `color${a1(t)}`, `fontSize${a1(n)}`]
  };
  return at(a, c9, r);
}, d9 = fo("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${a1(n.color)}`], t[`fontSize${a1(n.fontSize)}`]];
  }
})(s9(({
  theme: e
}) => {
  var t, n, r, a, i, o, s, l, c, u, m, p, h, C;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (a = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : a.call(t, "fill", {
      duration: (r = (n = (e.vars ?? e).transitions) == null ? void 0 : n.duration) == null ? void 0 : r.shorter
    }),
    variants: [
      {
        props: (g) => !g.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((o = (i = e.typography) == null ? void 0 : i.pxToRem) == null ? void 0 : o.call(i, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((l = (s = e.typography) == null ? void 0 : s.pxToRem) == null ? void 0 : l.call(s, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((u = (c = e.typography) == null ? void 0 : c.pxToRem) == null ? void 0 : u.call(c, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, g]) => g && g.main).map(([g]) => {
        var v, y;
        return {
          props: {
            color: g
          },
          style: {
            color: (y = (v = (e.vars ?? e).palette) == null ? void 0 : v[g]) == null ? void 0 : y.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (p = (m = (e.vars ?? e).palette) == null ? void 0 : m.action) == null ? void 0 : p.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (C = (h = (e.vars ?? e).palette) == null ? void 0 : h.action) == null ? void 0 : C.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), p1 = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const r = l9({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: a,
    className: i,
    color: o = "inherit",
    component: s = "svg",
    fontSize: l = "medium",
    htmlColor: c,
    inheritViewBox: u = !1,
    titleAccess: m,
    viewBox: p = "0 0 24 24",
    ...h
  } = r, C = /* @__PURE__ */ d.isValidElement(a) && a.type === "svg", g = {
    ...r,
    color: o,
    component: s,
    fontSize: l,
    instanceFontSize: t.fontSize,
    inheritViewBox: u,
    viewBox: p,
    hasSvgAsChild: C
  }, v = {};
  u || (v.viewBox = p);
  const y = u9(g);
  return /* @__PURE__ */ N.jsxs(d9, {
    as: s,
    className: R1(y.root, i),
    focusable: "false",
    color: c,
    "aria-hidden": m ? void 0 : !0,
    role: m ? "img" : void 0,
    ref: n,
    ...v,
    ...h,
    ...C && a.props,
    ownerState: g,
    children: [C ? a.props.children : a, m ? /* @__PURE__ */ N.jsx("title", {
      children: m
    }) : null]
  });
});
p1 && (p1.muiName = "SvgIcon");
function f9(e, t) {
  function n(r, a) {
    return /* @__PURE__ */ N.jsx(p1, {
      "data-testid": `${t}Icon`,
      ref: a,
      ...r,
      children: e
    });
  }
  return n.muiName = p1.muiName, /* @__PURE__ */ d.memo(/* @__PURE__ */ d.forwardRef(n));
}
const p9 = f9(/* @__PURE__ */ N.jsx("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreHoriz");
var xn = da;
function m9(e, t, n) {
  t == "__proto__" && xn ? xn(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var g9 = m9;
function C9(e, t, n, r) {
  for (var a = -1, i = e == null ? 0 : e.length; ++a < i; ) {
    var o = e[a];
    t(r, o, n(o), e);
  }
  return r;
}
var h9 = C9;
function v9(e) {
  return function(t, n, r) {
    for (var a = -1, i = Object(t), o = r(t), s = o.length; s--; ) {
      var l = o[e ? s : ++a];
      if (n(i[l], l, i) === !1)
        break;
    }
    return t;
  };
}
var y9 = v9, b9 = y9, w9 = b9(), x9 = w9, k9 = x9, E9 = lt;
function H9(e, t) {
  return e && k9(e, t, E9);
}
var S9 = H9, T9 = rt;
function V9(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!T9(n))
      return e(n, r);
    for (var a = n.length, i = t ? a : -1, o = Object(n); (t ? i-- : ++i < a) && r(o[i], i, o) !== !1; )
      ;
    return n;
  };
}
var L9 = V9, A9 = S9, M9 = L9, P9 = M9(A9), _9 = P9, $9 = _9;
function O9(e, t, n, r) {
  return $9(e, function(a, i, o) {
    t(r, a, n(a), o);
  }), r;
}
var R9 = O9, I9 = h9, D9 = R9, B9 = Or, F9 = J;
function z9(e, t) {
  return function(n, r) {
    var a = F9(n) ? I9 : D9, i = t ? t() : {};
    return a(n, e, B9(r), i);
  };
}
var Z9 = z9, W9 = g9, N9 = Z9, U9 = Object.prototype, j9 = U9.hasOwnProperty, q9 = N9(function(e, t, n) {
  j9.call(e, n) ? e[n].push(t) : W9(e, n, [t]);
}), G9 = q9;
const Y9 = /* @__PURE__ */ C1(G9), Fr = {
  kind: "InlineDataFragment",
  name: "readingHistoryActionMenuBookmarkButtonArticle"
};
Fr.hash = "a7c80ae823596510ff3e2edc0684d236";
const zr = {
  kind: "InlineDataFragment",
  name: "readingHistoryActionMenuSocialButtonArticle"
};
zr.hash = "f4c88864c5a03b3f32c07b9080058e99";
const K9 = () => {
  const {
    bookmark: e
  } = R(), t = q(({
    entityId: r
  }) => e.check({
    entityId: r
  }), [e]);
  return {
    bindBookmarkButton: q(({
      entityId: r,
      trackings: a
    }, i) => ({
      isBookmarked: t({
        entityId: r
      }),
      onClick: (l) => {
        e.update({
          action: l,
          entityId: r,
          trackings: a
        }), i == null || i();
      }
    }), [e, t]),
    checkIsBookmarked: t
  };
};
var z = "top", Y = "bottom", K = "right", Z = "left", mt = "auto", Ge = [z, Y, K, Z], Ee = "start", We = "end", X9 = "clippingParents", Zr = "viewport", Re = "popper", Q9 = "reference", kn = /* @__PURE__ */ Ge.reduce(function(e, t) {
  return e.concat([t + "-" + Ee, t + "-" + We]);
}, []), Wr = /* @__PURE__ */ [].concat(Ge, [mt]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Ee, t + "-" + We]);
}, []), J9 = "beforeRead", e5 = "read", t5 = "afterRead", n5 = "beforeMain", r5 = "main", a5 = "afterMain", i5 = "beforeWrite", o5 = "write", s5 = "afterWrite", l5 = [J9, e5, t5, n5, r5, a5, i5, o5, s5];
function te(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function j(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ye(e) {
  var t = j(e).Element;
  return e instanceof t || e instanceof Element;
}
function G(e) {
  var t = j(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function gt(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = j(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function c5(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, a = t.attributes[n] || {}, i = t.elements[n];
    !G(i) || !te(i) || (Object.assign(i.style, r), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function u5(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var a = t.elements[r], i = t.attributes[r] || {}, o = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !G(a) || !te(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
const d5 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: c5,
  effect: u5,
  requires: ["computeStyles"]
};
function ee(e) {
  return e.split("-")[0];
}
var Ce = Math.max, m1 = Math.min, He = Math.round;
function W1() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Nr() {
  return !/^((?!chrome|android).)*safari/i.test(W1());
}
function Se(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), a = 1, i = 1;
  t && G(e) && (a = e.offsetWidth > 0 && He(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && He(r.height) / e.offsetHeight || 1);
  var o = ye(e) ? j(e) : window, s = o.visualViewport, l = !Nr() && n, c = (r.left + (l && s ? s.offsetLeft : 0)) / a, u = (r.top + (l && s ? s.offsetTop : 0)) / i, m = r.width / a, p = r.height / i;
  return {
    width: m,
    height: p,
    top: u,
    right: c + m,
    bottom: u + p,
    left: c,
    x: c,
    y: u
  };
}
function Ct(e) {
  var t = Se(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function Ur(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && gt(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function ie(e) {
  return j(e).getComputedStyle(e);
}
function f5(e) {
  return ["table", "td", "th"].indexOf(te(e)) >= 0;
}
function ue(e) {
  return ((ye(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function E1(e) {
  return te(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (gt(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ue(e)
  );
}
function En(e) {
  return !G(e) || // https://github.com/popperjs/popper-core/issues/837
  ie(e).position === "fixed" ? null : e.offsetParent;
}
function p5(e) {
  var t = /firefox/i.test(W1()), n = /Trident/i.test(W1());
  if (n && G(e)) {
    var r = ie(e);
    if (r.position === "fixed")
      return null;
  }
  var a = E1(e);
  for (gt(a) && (a = a.host); G(a) && ["html", "body"].indexOf(te(a)) < 0; ) {
    var i = ie(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function Ye(e) {
  for (var t = j(e), n = En(e); n && f5(n) && ie(n).position === "static"; )
    n = En(n);
  return n && (te(n) === "html" || te(n) === "body" && ie(n).position === "static") ? t : n || p5(e) || t;
}
function ht(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Be(e, t, n) {
  return Ce(e, m1(t, n));
}
function m5(e, t, n) {
  var r = Be(e, t, n);
  return r > n ? n : r;
}
function jr() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function qr(e) {
  return Object.assign({}, jr(), e);
}
function Gr(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var g5 = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, qr(typeof t != "number" ? t : Gr(t, Ge));
};
function C5(e) {
  var t, n = e.state, r = e.name, a = e.options, i = n.elements.arrow, o = n.modifiersData.popperOffsets, s = ee(n.placement), l = ht(s), c = [Z, K].indexOf(s) >= 0, u = c ? "height" : "width";
  if (!(!i || !o)) {
    var m = g5(a.padding, n), p = Ct(i), h = l === "y" ? z : Z, C = l === "y" ? Y : K, g = n.rects.reference[u] + n.rects.reference[l] - o[l] - n.rects.popper[u], v = o[l] - n.rects.reference[l], y = Ye(i), E = y ? l === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, H = g / 2 - v / 2, b = m[h], w = E - p[u] - m[C], x = E / 2 - p[u] / 2 + H, T = Be(b, x, w), L = l;
    n.modifiersData[r] = (t = {}, t[L] = T, t.centerOffset = T - x, t);
  }
}
function h5(e) {
  var t = e.state, n = e.options, r = n.element, a = r === void 0 ? "[data-popper-arrow]" : r;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || Ur(t.elements.popper, a) && (t.elements.arrow = a));
}
const v5 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: C5,
  effect: h5,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Te(e) {
  return e.split("-")[1];
}
var y5 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function b5(e, t) {
  var n = e.x, r = e.y, a = t.devicePixelRatio || 1;
  return {
    x: He(n * a) / a || 0,
    y: He(r * a) / a || 0
  };
}
function Hn(e) {
  var t, n = e.popper, r = e.popperRect, a = e.placement, i = e.variation, o = e.offsets, s = e.position, l = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, m = e.isFixed, p = o.x, h = p === void 0 ? 0 : p, C = o.y, g = C === void 0 ? 0 : C, v = typeof u == "function" ? u({
    x: h,
    y: g
  }) : {
    x: h,
    y: g
  };
  h = v.x, g = v.y;
  var y = o.hasOwnProperty("x"), E = o.hasOwnProperty("y"), H = Z, b = z, w = window;
  if (c) {
    var x = Ye(n), T = "clientHeight", L = "clientWidth";
    if (x === j(n) && (x = ue(n), ie(x).position !== "static" && s === "absolute" && (T = "scrollHeight", L = "scrollWidth")), x = x, a === z || (a === Z || a === K) && i === We) {
      b = Y;
      var M = m && x === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        x[T]
      );
      g -= M - r.height, g *= l ? 1 : -1;
    }
    if (a === Z || (a === z || a === Y) && i === We) {
      H = K;
      var V = m && x === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        x[L]
      );
      h -= V - r.width, h *= l ? 1 : -1;
    }
  }
  var O = Object.assign({
    position: s
  }, c && y5), A = u === !0 ? b5({
    x: h,
    y: g
  }, j(n)) : {
    x: h,
    y: g
  };
  if (h = A.x, g = A.y, l) {
    var S;
    return Object.assign({}, O, (S = {}, S[b] = E ? "0" : "", S[H] = y ? "0" : "", S.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + g + "px)" : "translate3d(" + h + "px, " + g + "px, 0)", S));
  }
  return Object.assign({}, O, (t = {}, t[b] = E ? g + "px" : "", t[H] = y ? h + "px" : "", t.transform = "", t));
}
function w5(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, a = r === void 0 ? !0 : r, i = n.adaptive, o = i === void 0 ? !0 : i, s = n.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: ee(t.placement),
    variation: Te(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Hn(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Hn(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const x5 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: w5,
  data: {}
};
var t1 = {
  passive: !0
};
function k5(e) {
  var t = e.state, n = e.instance, r = e.options, a = r.scroll, i = a === void 0 ? !0 : a, o = r.resize, s = o === void 0 ? !0 : o, l = j(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, t1);
  }), s && l.addEventListener("resize", n.update, t1), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, t1);
    }), s && l.removeEventListener("resize", n.update, t1);
  };
}
const E5 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: k5,
  data: {}
};
var H5 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function r1(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return H5[t];
  });
}
var S5 = {
  start: "end",
  end: "start"
};
function Sn(e) {
  return e.replace(/start|end/g, function(t) {
    return S5[t];
  });
}
function vt(e) {
  var t = j(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function yt(e) {
  return Se(ue(e)).left + vt(e).scrollLeft;
}
function T5(e, t) {
  var n = j(e), r = ue(e), a = n.visualViewport, i = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (a) {
    i = a.width, o = a.height;
    var c = Nr();
    (c || !c && t === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + yt(e),
    y: l
  };
}
function V5(e) {
  var t, n = ue(e), r = vt(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = Ce(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = Ce(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -r.scrollLeft + yt(e), l = -r.scrollTop;
  return ie(a || n).direction === "rtl" && (s += Ce(n.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function bt(e) {
  var t = ie(e), n = t.overflow, r = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + a + r);
}
function Yr(e) {
  return ["html", "body", "#document"].indexOf(te(e)) >= 0 ? e.ownerDocument.body : G(e) && bt(e) ? e : Yr(E1(e));
}
function Fe(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Yr(e), a = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = j(r), o = a ? [i].concat(i.visualViewport || [], bt(r) ? r : []) : r, s = t.concat(o);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Fe(E1(o)))
  );
}
function N1(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function L5(e, t) {
  var n = Se(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Tn(e, t, n) {
  return t === Zr ? N1(T5(e, n)) : ye(t) ? L5(t, n) : N1(V5(ue(e)));
}
function A5(e) {
  var t = Fe(E1(e)), n = ["absolute", "fixed"].indexOf(ie(e).position) >= 0, r = n && G(e) ? Ye(e) : e;
  return ye(r) ? t.filter(function(a) {
    return ye(a) && Ur(a, r) && te(a) !== "body";
  }) : [];
}
function M5(e, t, n, r) {
  var a = t === "clippingParents" ? A5(e) : [].concat(t), i = [].concat(a, [n]), o = i[0], s = i.reduce(function(l, c) {
    var u = Tn(e, c, r);
    return l.top = Ce(u.top, l.top), l.right = m1(u.right, l.right), l.bottom = m1(u.bottom, l.bottom), l.left = Ce(u.left, l.left), l;
  }, Tn(e, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Kr(e) {
  var t = e.reference, n = e.element, r = e.placement, a = r ? ee(r) : null, i = r ? Te(r) : null, o = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, l;
  switch (a) {
    case z:
      l = {
        x: o,
        y: t.y - n.height
      };
      break;
    case Y:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case K:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Z:
      l = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = a ? ht(a) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case Ee:
        l[c] = l[c] - (t[u] / 2 - n[u] / 2);
        break;
      case We:
        l[c] = l[c] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Ne(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = r === void 0 ? e.placement : r, i = n.strategy, o = i === void 0 ? e.strategy : i, s = n.boundary, l = s === void 0 ? X9 : s, c = n.rootBoundary, u = c === void 0 ? Zr : c, m = n.elementContext, p = m === void 0 ? Re : m, h = n.altBoundary, C = h === void 0 ? !1 : h, g = n.padding, v = g === void 0 ? 0 : g, y = qr(typeof v != "number" ? v : Gr(v, Ge)), E = p === Re ? Q9 : Re, H = e.rects.popper, b = e.elements[C ? E : p], w = M5(ye(b) ? b : b.contextElement || ue(e.elements.popper), l, u, o), x = Se(e.elements.reference), T = Kr({
    reference: x,
    element: H,
    strategy: "absolute",
    placement: a
  }), L = N1(Object.assign({}, H, T)), M = p === Re ? L : x, V = {
    top: w.top - M.top + y.top,
    bottom: M.bottom - w.bottom + y.bottom,
    left: w.left - M.left + y.left,
    right: M.right - w.right + y.right
  }, O = e.modifiersData.offset;
  if (p === Re && O) {
    var A = O[a];
    Object.keys(V).forEach(function(S) {
      var $ = [K, Y].indexOf(S) >= 0 ? 1 : -1, D = [z, Y].indexOf(S) >= 0 ? "y" : "x";
      V[S] += A[D] * $;
    });
  }
  return V;
}
function P5(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = n.boundary, i = n.rootBoundary, o = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? Wr : l, u = Te(r), m = u ? s ? kn : kn.filter(function(C) {
    return Te(C) === u;
  }) : Ge, p = m.filter(function(C) {
    return c.indexOf(C) >= 0;
  });
  p.length === 0 && (p = m);
  var h = p.reduce(function(C, g) {
    return C[g] = Ne(e, {
      placement: g,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[ee(g)], C;
  }, {});
  return Object.keys(h).sort(function(C, g) {
    return h[C] - h[g];
  });
}
function _5(e) {
  if (ee(e) === mt)
    return [];
  var t = r1(e);
  return [Sn(e), t, Sn(t)];
}
function $5(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !0 : o, l = n.fallbackPlacements, c = n.padding, u = n.boundary, m = n.rootBoundary, p = n.altBoundary, h = n.flipVariations, C = h === void 0 ? !0 : h, g = n.allowedAutoPlacements, v = t.options.placement, y = ee(v), E = y === v, H = l || (E || !C ? [r1(v)] : _5(v)), b = [v].concat(H).reduce(function(we, oe) {
      return we.concat(ee(oe) === mt ? P5(t, {
        placement: oe,
        boundary: u,
        rootBoundary: m,
        padding: c,
        flipVariations: C,
        allowedAutoPlacements: g
      }) : oe);
    }, []), w = t.rects.reference, x = t.rects.popper, T = /* @__PURE__ */ new Map(), L = !0, M = b[0], V = 0; V < b.length; V++) {
      var O = b[V], A = ee(O), S = Te(O) === Ee, $ = [z, Y].indexOf(A) >= 0, D = $ ? "width" : "height", P = Ne(t, {
        placement: O,
        boundary: u,
        rootBoundary: m,
        altBoundary: p,
        padding: c
      }), B = $ ? S ? K : Z : S ? Y : z;
      w[D] > x[D] && (B = r1(B));
      var W = r1(B), de = [];
      if (i && de.push(P[A] <= 0), s && de.push(P[B] <= 0, P[W] <= 0), de.every(function(we) {
        return we;
      })) {
        M = O, L = !1;
        break;
      }
      T.set(O, de);
    }
    if (L)
      for (var Ke = C ? 3 : 1, H1 = function(oe) {
        var _e = b.find(function(Qe) {
          var fe = T.get(Qe);
          if (fe)
            return fe.slice(0, oe).every(function(S1) {
              return S1;
            });
        });
        if (_e)
          return M = _e, "break";
      }, Pe = Ke; Pe > 0; Pe--) {
        var Xe = H1(Pe);
        if (Xe === "break") break;
      }
    t.placement !== M && (t.modifiersData[r]._skip = !0, t.placement = M, t.reset = !0);
  }
}
const O5 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: $5,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Vn(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Ln(e) {
  return [z, K, Y, Z].some(function(t) {
    return e[t] >= 0;
  });
}
function R5(e) {
  var t = e.state, n = e.name, r = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, o = Ne(t, {
    elementContext: "reference"
  }), s = Ne(t, {
    altBoundary: !0
  }), l = Vn(o, r), c = Vn(s, a, i), u = Ln(l), m = Ln(c);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: m
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": m
  });
}
const I5 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: R5
};
function D5(e, t, n) {
  var r = ee(e), a = [Z, z].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [Z, K].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function B5(e) {
  var t = e.state, n = e.options, r = e.name, a = n.offset, i = a === void 0 ? [0, 0] : a, o = Wr.reduce(function(u, m) {
    return u[m] = D5(m, t.rects, i), u;
  }, {}), s = o[t.placement], l = s.x, c = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[r] = o;
}
const F5 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: B5
};
function z5(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Kr({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Z5 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: z5,
  data: {}
};
function W5(e) {
  return e === "x" ? "y" : "x";
}
function N5(e) {
  var t = e.state, n = e.options, r = e.name, a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !1 : o, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, m = n.padding, p = n.tether, h = p === void 0 ? !0 : p, C = n.tetherOffset, g = C === void 0 ? 0 : C, v = Ne(t, {
    boundary: l,
    rootBoundary: c,
    padding: m,
    altBoundary: u
  }), y = ee(t.placement), E = Te(t.placement), H = !E, b = ht(y), w = W5(b), x = t.modifiersData.popperOffsets, T = t.rects.reference, L = t.rects.popper, M = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, V = typeof M == "number" ? {
    mainAxis: M,
    altAxis: M
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, M), O = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, A = {
    x: 0,
    y: 0
  };
  if (x) {
    if (i) {
      var S, $ = b === "y" ? z : Z, D = b === "y" ? Y : K, P = b === "y" ? "height" : "width", B = x[b], W = B + v[$], de = B - v[D], Ke = h ? -L[P] / 2 : 0, H1 = E === Ee ? T[P] : L[P], Pe = E === Ee ? -L[P] : -T[P], Xe = t.elements.arrow, we = h && Xe ? Ct(Xe) : {
        width: 0,
        height: 0
      }, oe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : jr(), _e = oe[$], Qe = oe[D], fe = Be(0, T[P], we[P]), S1 = H ? T[P] / 2 - Ke - fe - _e - V.mainAxis : H1 - fe - _e - V.mainAxis, x2 = H ? -T[P] / 2 + Ke + fe + Qe + V.mainAxis : Pe + fe + Qe + V.mainAxis, T1 = t.elements.arrow && Ye(t.elements.arrow), k2 = T1 ? b === "y" ? T1.clientTop || 0 : T1.clientLeft || 0 : 0, xt = (S = O == null ? void 0 : O[b]) != null ? S : 0, E2 = B + S1 - xt - k2, H2 = B + x2 - xt, kt = Be(h ? m1(W, E2) : W, B, h ? Ce(de, H2) : de);
      x[b] = kt, A[b] = kt - B;
    }
    if (s) {
      var Et, S2 = b === "x" ? z : Z, T2 = b === "x" ? Y : K, pe = x[w], Je = w === "y" ? "height" : "width", Ht = pe + v[S2], St = pe - v[T2], V1 = [z, Z].indexOf(y) !== -1, Tt = (Et = O == null ? void 0 : O[w]) != null ? Et : 0, Vt = V1 ? Ht : pe - T[Je] - L[Je] - Tt + V.altAxis, Lt = V1 ? pe + T[Je] + L[Je] - Tt - V.altAxis : St, At = h && V1 ? m5(Vt, pe, Lt) : Be(h ? Vt : Ht, pe, h ? Lt : St);
      x[w] = At, A[w] = At - pe;
    }
    t.modifiersData[r] = A;
  }
}
const U5 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: N5,
  requiresIfExists: ["offset"]
};
function j5(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function q5(e) {
  return e === j(e) || !G(e) ? vt(e) : j5(e);
}
function G5(e) {
  var t = e.getBoundingClientRect(), n = He(t.width) / e.offsetWidth || 1, r = He(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Y5(e, t, n) {
  n === void 0 && (n = !1);
  var r = G(t), a = G(t) && G5(t), i = ue(t), o = Se(e, a, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((te(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  bt(i)) && (s = q5(t)), G(t) ? (l = Se(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = yt(i))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function K5(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    n.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var l = t.get(s);
        l && a(l);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || a(i);
  }), r;
}
function X5(e) {
  var t = K5(e);
  return l5.reduce(function(n, r) {
    return n.concat(t.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function Q5(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function J5(e) {
  var t = e.reduce(function(n, r) {
    var a = n[r.name];
    return n[r.name] = a ? Object.assign({}, a, r, {
      options: Object.assign({}, a.options, r.options),
      data: Object.assign({}, a.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var An = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Mn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function es(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, a = t.defaultOptions, i = a === void 0 ? An : a;
  return function(s, l, c) {
    c === void 0 && (c = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, An, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, m = [], p = !1, h = {
      state: u,
      setOptions: function(y) {
        var E = typeof y == "function" ? y(u.options) : y;
        g(), u.options = Object.assign({}, i, u.options, E), u.scrollParents = {
          reference: ye(s) ? Fe(s) : s.contextElement ? Fe(s.contextElement) : [],
          popper: Fe(l)
        };
        var H = X5(J5([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = H.filter(function(b) {
          return b.enabled;
        }), C(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var y = u.elements, E = y.reference, H = y.popper;
          if (Mn(E, H)) {
            u.rects = {
              reference: Y5(E, Ye(H), u.options.strategy === "fixed"),
              popper: Ct(H)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(V) {
              return u.modifiersData[V.name] = Object.assign({}, V.data);
            });
            for (var b = 0; b < u.orderedModifiers.length; b++) {
              if (u.reset === !0) {
                u.reset = !1, b = -1;
                continue;
              }
              var w = u.orderedModifiers[b], x = w.fn, T = w.options, L = T === void 0 ? {} : T, M = w.name;
              typeof x == "function" && (u = x({
                state: u,
                options: L,
                name: M,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Q5(function() {
        return new Promise(function(v) {
          h.forceUpdate(), v(u);
        });
      }),
      destroy: function() {
        g(), p = !0;
      }
    };
    if (!Mn(s, l))
      return h;
    h.setOptions(c).then(function(v) {
      !p && c.onFirstUpdate && c.onFirstUpdate(v);
    });
    function C() {
      u.orderedModifiers.forEach(function(v) {
        var y = v.name, E = v.options, H = E === void 0 ? {} : E, b = v.effect;
        if (typeof b == "function") {
          var w = b({
            state: u,
            name: y,
            instance: h,
            options: H
          }), x = function() {
          };
          m.push(w || x);
        }
      });
    }
    function g() {
      m.forEach(function(v) {
        return v();
      }), m = [];
    }
    return h;
  };
}
var ts = [E5, Z5, x5, d5, F5, O5, U5, v5, I5], ns = /* @__PURE__ */ es({
  defaultModifiers: ts
});
function rs(e) {
  return typeof e == "function" ? e() : e;
}
const as = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    children: r,
    container: a,
    disablePortal: i = !1
  } = t, [o, s] = d.useState(null), l = ze(/* @__PURE__ */ d.isValidElement(r) ? O2(r) : null, n);
  if (u1(() => {
    i || s(rs(a) || document.body);
  }, [a, i]), u1(() => {
    if (o && !i)
      return Pt(n, o), () => {
        Pt(n, null);
      };
  }, [n, o, i]), i) {
    if (/* @__PURE__ */ d.isValidElement(r)) {
      const c = {
        ref: l
      };
      return /* @__PURE__ */ d.cloneElement(r, c);
    }
    return /* @__PURE__ */ N.jsx(d.Fragment, {
      children: r
    });
  }
  return /* @__PURE__ */ N.jsx(d.Fragment, {
    children: o && /* @__PURE__ */ Ma.createPortal(r, o)
  });
}), Xr = "base";
function is(e) {
  return `${Xr}--${e}`;
}
function os(e, t) {
  return `${Xr}-${e}-${t}`;
}
function wt(e, t) {
  const n = lr[t];
  return n ? is(n) : os(e, t);
}
function Qr(e, t) {
  const n = {};
  return t.forEach((r) => {
    n[r] = wt(e, r);
  }), n;
}
const Jr = "Popper";
function ss(e) {
  return wt(Jr, e);
}
Qr(Jr, ["root"]);
const ls = {
  disableDefaultClasses: !1
}, cs = /* @__PURE__ */ d.createContext(ls);
function e2(e) {
  const {
    disableDefaultClasses: t
  } = d.useContext(cs);
  return (n) => t ? "" : e(n);
}
function us(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function U1(e) {
  return typeof e == "function" ? e() : e;
}
function ds(e) {
  return e.nodeType !== void 0;
}
const fs = () => at({
  root: ["root"]
}, e2(ss)), ps = {}, ms = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: a,
    direction: i,
    disablePortal: o,
    modifiers: s,
    open: l,
    placement: c,
    popperOptions: u,
    popperRef: m,
    slotProps: p = {},
    slots: h = {},
    TransitionProps: C,
    // @ts-ignore internal logic
    ownerState: g,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...v
  } = t, y = d.useRef(null), E = ze(y, n), H = d.useRef(null), b = ze(H, m), w = d.useRef(b);
  u1(() => {
    w.current = b;
  }, [b]), d.useImperativeHandle(m, () => H.current, []);
  const x = us(c, i), [T, L] = d.useState(x), [M, V] = d.useState(U1(r));
  d.useEffect(() => {
    H.current && H.current.forceUpdate();
  }), d.useEffect(() => {
    r && V(U1(r));
  }, [r]), u1(() => {
    if (!M || !l)
      return;
    const D = (W) => {
      L(W.placement);
    };
    let P = [{
      name: "preventOverflow",
      options: {
        altBoundary: o
      }
    }, {
      name: "flip",
      options: {
        altBoundary: o
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: W
      }) => {
        D(W);
      }
    }];
    s != null && (P = P.concat(s)), u && u.modifiers != null && (P = P.concat(u.modifiers));
    const B = ns(M, y.current, {
      placement: x,
      ...u,
      modifiers: P
    });
    return w.current(B), () => {
      B.destroy(), w.current(null);
    };
  }, [M, o, s, l, u, x]);
  const O = {
    placement: T
  };
  C !== null && (O.TransitionProps = C);
  const A = fs(), S = h.root ?? "div", $ = Ie({
    elementType: S,
    externalSlotProps: p.root,
    externalForwardedProps: v,
    additionalProps: {
      role: "tooltip",
      ref: E
    },
    ownerState: t,
    className: A.root
  });
  return /* @__PURE__ */ N.jsx(S, {
    ...$,
    children: typeof a == "function" ? a(O) : a
  });
}), gs = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: a,
    container: i,
    direction: o = "ltr",
    disablePortal: s = !1,
    keepMounted: l = !1,
    modifiers: c,
    open: u,
    placement: m = "bottom",
    popperOptions: p = ps,
    popperRef: h,
    style: C,
    transition: g = !1,
    slotProps: v = {},
    slots: y = {},
    ...E
  } = t, [H, b] = d.useState(!0), w = () => {
    b(!1);
  }, x = () => {
    b(!0);
  };
  if (!l && !u && (!g || H))
    return null;
  let T;
  if (i)
    T = i;
  else if (r) {
    const V = U1(r);
    T = V && ds(V) ? Wt(V).body : Wt(null).body;
  }
  const L = !u && l && (!g || H) ? "none" : void 0, M = g ? {
    in: u,
    onEnter: w,
    onExited: x
  } : void 0;
  return /* @__PURE__ */ N.jsx(as, {
    disablePortal: s,
    container: T,
    children: /* @__PURE__ */ N.jsx(ms, {
      anchorEl: r,
      direction: o,
      disablePortal: s,
      modifiers: c,
      ref: n,
      open: g ? !H : u,
      placement: m,
      popperOptions: p,
      popperRef: h,
      slotProps: v,
      slots: y,
      ...E,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: L,
        ...C
      },
      TransitionProps: M,
      children: a
    })
  });
}), Cs = (e) => /* @__PURE__ */ d.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("g", { id: "icon_tick1_24x24" }, /* @__PURE__ */ d.createElement("path", { id: "Fill 58", fillRule: "evenodd", clipRule: "evenodd", d: "M6.88586 12.8573L2 7.94102L3.96978 5.98439L6.88586 8.89321L12.4116 3.3335L14.381 5.31554L6.88586 12.8573Z", fill: "white" }))), Pn = /* @__PURE__ */ k(Cs, {
  target: "e1qkx15u3"
})(""), hs = /* @__PURE__ */ k("button", {
  target: "e1qkx15u2"
})({
  name: "h9xjp8",
  styles: "padding:0;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer;.copied{display:flex;align-items:center;padding-block:4px;padding-inline:6px;color:#ffffff;font-weight:700;background-color:#000000;}"
}), vs = /* @__PURE__ */ k(gs, {
  target: "e1qkx15u1"
})("z-index:", b1.Tooltip, ";"), ys = /* @__PURE__ */ k("div", {
  target: "e1qkx15u0"
})("display:flex;gap:4px;justify-content:center;align-items:center;inline-size:114px;block-size:32px;color:#ffffff;font-weight:700;font-size:14px;font-family:", Q, ";line-height:16px;text-align:center;background-color:#000000;"), t2 = ({
  children: e,
  className: t,
  disablePortal: n = !0,
  LabelComponent: r,
  onClick: a,
  showLabel: i,
  tooltipPlacement: o = "right",
  url: s,
  variant: l
}) => {
  const [c, u] = Aa(), [m, p] = ve(!1), [h, C] = ve(!1), g = Y1(null), v = o1(i1.breakpoints.up("tablet")), y = () => {
    u(s);
    const b = () => {
      p(!0), setTimeout(() => {
        p(!1), a == null || a();
      }, 1e3);
    }, w = () => {
      u(s), C(!0), a == null || a();
    };
    switch (l) {
      case "label":
        w();
        break;
      case "responsive":
        v ? b() : w();
        break;
      case "tooltip":
        b();
        break;
    }
  }, E = () => {
    const b = /* @__PURE__ */ f.createElement("span", {
      className: "copy"
    }, "Copy Link"), x = h ? /* @__PURE__ */ f.createElement("span", {
      className: "copied"
    }, "Link Copied ", /* @__PURE__ */ f.createElement(Pn, null)) : b;
    switch (l) {
      case "label":
        return x;
      case "responsive":
        return v ? b : x;
      case "tooltip":
        return b;
    }
  }, H = he(() => [{
    name: "offset",
    options: {
      offset: [0, 12]
    }
  }], []);
  return /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement(hs, {
    className: t,
    onClick: () => y(),
    ref: g,
    type: "button"
  }, e, i && /* @__PURE__ */ f.createElement(r, null, E())), /* @__PURE__ */ f.createElement(vs, {
    anchorEl: g.current,
    disablePortal: n,
    modifiers: H,
    open: m,
    placement: o
  }, /* @__PURE__ */ f.createElement(ys, null, "Link Copied", /* @__PURE__ */ f.createElement(Pn, null))));
};
t2.displayName = "CopyLinkButton";
const bs = (e) => /* @__PURE__ */ d.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 35, height: 35, rx: 17.5, stroke: "black" }), /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_3588_4477)" }, /* @__PURE__ */ d.createElement("path", { d: "M16.4987 18.75C16.8208 19.1806 17.2317 19.5369 17.7036 19.7947C18.1755 20.0525 18.6973 20.2058 19.2337 20.2442C19.7701 20.2826 20.3084 20.2052 20.8122 20.0173C21.316 19.8294 21.7736 19.5353 22.1537 19.155L24.4037 16.905C25.0868 16.1977 25.4648 15.2505 25.4562 14.2672C25.4477 13.284 25.0533 12.3434 24.358 11.6482C23.6628 10.9529 22.7222 10.5585 21.739 10.5499C20.7557 10.5414 19.8085 10.9194 19.1012 11.6025L17.8112 12.885M19.4987 17.25C19.1766 16.8194 18.7657 16.4631 18.2938 16.2053C17.8219 15.9475 17.3001 15.7941 16.7637 15.7557C16.2273 15.7173 15.689 15.7947 15.1852 15.9826C14.6814 16.1706 14.2238 16.4647 13.8437 16.845L11.5937 19.095C10.9106 19.8022 10.5326 20.7495 10.5412 21.7327C10.5497 22.716 10.9441 23.6565 11.6394 24.3518C12.3346 25.0471 13.2752 25.4415 14.2584 25.45C15.2417 25.4586 16.1889 25.0806 16.8962 24.3975L18.1787 23.115", stroke: "black", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_3588_4477" }, /* @__PURE__ */ d.createElement("rect", { width: 18, height: 18, fill: "white", transform: "translate(9 9)" })))), ws = (e) => /* @__PURE__ */ d.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, fill: "white" }), /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.3307 13.384V20.1183C23.3307 20.545 23.1673 20.9095 22.8398 21.2124C22.5122 21.5153 22.1195 21.6668 21.6608 21.6668H8.33396C7.87592 21.6668 7.48255 21.5153 7.15503 21.2124C6.82812 20.9095 6.66406 20.545 6.66406 20.1183V13.384L15.0136 16.8183L23.3307 13.384ZM23.3307 12.3404L15.0136 15.8086L6.66406 12.3404V9.88257C6.66406 9.45589 6.82812 9.09079 7.15503 8.78787C7.48255 8.48496 7.87592 8.3335 8.33396 8.3335H21.6608C22.1195 8.3335 22.5122 8.48496 22.8398 8.78787C23.1673 9.09079 23.3307 9.45589 23.3307 9.88257V12.3404Z", fill: "black" })), xs = (e) => /* @__PURE__ */ d.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, fill: "white" }), /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.909 7.5947V9.99461H17.4374C16.8706 9.99461 16.5106 10.1003 16.3582 10.3105C16.162 10.542 16.064 10.8689 16.064 11.2893V12.9951H18.8109L18.4509 15.6791H16.064V22.5H13.219V15.6791H10.832V12.9951H13.219V11.0369C13.219 9.94206 13.5353 9.06895 14.1673 8.41585C14.843 7.80547 15.7154 7.5 16.7833 7.5C17.6772 7.5 18.3858 7.53176 18.909 7.5947Z", fill: "black" })), ks = (e) => /* @__PURE__ */ d.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "css-e5fmgn e1218mwn1", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 35, height: 35, rx: 17.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M12 15V8H24V15", stroke: "black", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12 24H10C9.46957 24 8.96086 23.7893 8.58579 23.4142C8.21071 23.0391 8 22.5304 8 22V17C8 16.4696 8.21071 15.9609 8.58579 15.5858C8.96086 15.2107 9.46957 15 10 15H26C26.5304 15 27.0391 15.2107 27.4142 15.5858C27.7893 15.9609 28 16.4696 28 17V22C28 22.5304 27.7893 23.0391 27.4142 23.4142C27.0391 23.7893 26.5304 24 26 24H24", stroke: "black", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M24 20H12V28H24V20Z", stroke: "black", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })), Es = (e) => /* @__PURE__ */ d.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, fill: "white" }), /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M6.0218 14.6103C6.0218 14.6103 13.3931 11.8663 15.9495 10.9001C16.9296 10.5136 20.253 9.27685 20.253 9.27685C20.253 9.27685 21.7869 8.73581 21.6591 10.0498C21.6165 10.5909 21.2756 12.4846 20.9348 14.533C20.4234 17.4316 19.8695 20.6007 19.8695 20.6007C19.8695 20.6007 19.7843 21.4897 19.06 21.6442C18.3357 21.7988 17.1426 21.1032 16.9296 20.9486C16.7591 20.8327 13.7339 19.0935 12.6261 18.2432C12.3278 18.0113 11.987 17.5476 12.6687 17.0065C14.2026 15.7311 16.0348 14.1465 17.1426 13.1417C17.6539 12.6779 18.1652 11.5958 16.0348 12.9098C13.0096 14.8035 10.027 16.5814 10.027 16.5814C10.027 16.5814 9.34524 16.9678 8.06701 16.62C6.78871 16.2722 5.29742 15.8084 5.29742 15.8084C5.29742 15.8084 4.27487 15.2287 6.0218 14.6103Z", fill: "black" })), Hs = (e) => /* @__PURE__ */ d.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, fill: "white" }), /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { d: "M16.2349 13.8515L21.6988 7.5H20.4041L15.6598 13.0149L11.8705 7.5H7.5L13.2301 15.8395L7.5 22.5H8.79485L13.805 16.6761L17.8067 22.5H22.1772L16.2346 13.8515H16.2349ZM14.4615 15.913L13.8809 15.0825L9.2614 8.47476H11.2502L14.9782 13.8075L15.5588 14.6379L20.4047 21.5696H18.4159L14.4615 15.9133V15.913Z", fill: "black" })), Ss = (e) => /* @__PURE__ */ d.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, fill: "white" }), /* @__PURE__ */ d.createElement("rect", { x: 0.5, y: 0.5, width: 29, height: 29, rx: 14.5, stroke: "black" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.5937 16.0043C17.7337 16.0043 18.1237 16.186 18.7662 16.5485C19.4079 16.8835 19.7562 17.0927 19.812 17.1768C19.8404 17.2043 19.8537 17.2602 19.8537 17.3435C19.8537 17.5952 19.7845 17.9018 19.6454 18.2652C19.5054 18.5718 19.2262 18.8368 18.8079 19.0602C18.3887 19.256 17.9845 19.3535 17.5937 19.3535C17.1754 19.3535 16.4079 19.116 15.292 18.6418C14.5499 18.279 13.8713 17.7983 13.2829 17.2185C12.7245 16.6602 12.1387 15.921 11.5245 15.0002C10.9387 14.1627 10.6454 13.396 10.6454 12.6977V12.5727C10.7012 11.8477 10.9945 11.2193 11.5245 10.6893C11.7195 10.5218 11.9295 10.4377 12.152 10.4377H12.362C12.4454 10.466 12.5287 10.4793 12.6129 10.4793C12.7795 10.4793 12.8779 10.5077 12.9062 10.5627C12.962 10.591 13.0312 10.6885 13.1145 10.856C13.1145 10.9118 13.1645 11.0585 13.262 11.296C13.3595 11.5327 13.4362 11.7493 13.492 11.9443C13.687 12.4468 13.7845 12.7402 13.7845 12.8235C13.7845 12.991 13.6595 13.2143 13.4079 13.4935C13.1287 13.7727 12.9895 13.9677 12.9895 14.0793C12.9895 14.1352 13.0037 14.191 13.0312 14.246C13.3221 14.8665 13.7351 15.422 14.2454 15.8793C14.7788 16.3746 15.3861 16.784 16.0454 17.0927C16.212 17.1485 16.3104 17.176 16.3379 17.176C16.4495 17.176 16.6587 16.981 16.9662 16.591C17.3012 16.1993 17.5104 16.0043 17.5937 16.0043ZM15.1662 22.3668C16.1761 22.3658 17.1745 22.152 18.0962 21.7393C18.9907 21.3755 19.8023 20.8343 20.482 20.1485C21.1679 19.4687 21.709 18.6571 22.0729 17.7627C22.4629 16.8977 22.6587 15.921 22.6587 14.8327C22.6587 13.7727 22.4629 12.8093 22.0729 11.9443C21.6812 10.996 21.152 10.186 20.4812 9.51683C19.8679 8.90266 19.0729 8.37266 18.0962 7.926C17.0912 7.536 16.1145 7.34016 15.1662 7.34016C14.217 7.34016 13.2412 7.536 12.2362 7.926C11.2595 8.37266 10.4645 8.90266 9.85036 9.51766C9.18036 10.1868 8.65036 10.996 8.25953 11.9443C7.8687 12.8093 7.6737 13.7727 7.6737 14.8327C7.6737 16.4793 8.1487 17.9443 9.09703 19.2277L8.13453 22.0318L11.022 21.111C12.3337 21.9485 13.7154 22.3668 15.1662 22.3668ZM15.1654 5.8335C16.337 5.8335 17.5095 6.071 18.682 6.54516C19.7472 6.99492 20.714 7.64889 21.5279 8.47016C22.3362 9.25183 22.9779 10.2143 23.4529 11.3585C23.9279 12.3918 24.1645 13.5493 24.1645 14.8335C24.1645 16.1168 23.927 17.2885 23.4529 18.3485C22.9779 19.4652 22.3362 20.4277 21.5279 21.2368C20.7745 21.9902 19.8254 22.6318 18.6812 23.1618C17.5095 23.6368 16.337 23.8735 15.1645 23.8735C13.6399 23.8832 12.1394 23.4936 10.812 22.7435L5.83203 24.3343L7.42286 19.4785C6.58536 18.1118 6.16703 16.5627 6.16703 14.8335C6.16703 13.5502 6.4037 12.3918 6.8787 11.3593C7.35286 10.2152 7.99536 9.25266 8.8037 8.471C9.61773 7.64933 10.5848 6.99507 11.6504 6.54516C12.822 6.07016 13.9945 5.8335 15.1654 5.8335Z", fill: "black" })), Ts = /* @__PURE__ */ k("button", {
  target: "e1uptd6o1"
})({
  name: "pt3bba",
  styles: "position:relative;padding:0;color:inherit;font:inherit;border:none;background-color:transparent;cursor:pointer"
}), Vs = /* @__PURE__ */ k("div", {
  target: "e1uptd6o0"
})({
  name: "wrqbg1",
  styles: "position:relative;z-index:2"
}), n2 = ({
  children: e,
  className: t,
  onClick: n,
  url: r
}) => {
  const a = () => {
    window.open(`/print${r}`, "_blank"), n == null || n();
  };
  return /* @__PURE__ */ f.createElement(Ts, {
    className: t,
    onClick: a,
    type: "button",
    "data-qa": "print-button"
  }, /* @__PURE__ */ f.createElement(Vs, null, e));
};
n2.displayName = "PrintButton";
const _n = /* @__PURE__ */ k("span", {
  target: "e136m1kq1"
})("padding-block-start:11px;font-size:14px;font-family:", Q, ";line-height:16px;white-space:nowrap;"), Ls = /* @__PURE__ */ k("div", {
  ...er,
  target: "e136m1kq0"
})("display:flex;inline-size:", (e) => e.$size + e.$mobilePadding * 2, "px;block-size:", (e) => e.$size + e.$mobilePadding * 2, "px;padding:", (e) => e.$mobilePadding, "px;border-radius:200px;background-color:", (e) => e.$backgroundColor, ";", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:", (e) => e.$size + e.$padding * 2, "px;block-size:", (e) => e.$size + e.$padding * 2, "px;padding:", (e) => e.$padding, "px;}svg{inline-size:", (e) => e.$size, "px;block-size:", (e) => e.$size, "px;", (e) => e.$iconFillColor && /* @__PURE__ */ De("path{fill:", e.$iconFillColor, ";}", ""), " ", (e) => e.$svgTransform && /* @__PURE__ */ De("transform:", e.$svgTransform, ";", ""), ";}"), r2 = ({
  children: e,
  className: t,
  extraProps: n,
  hideIcon: r = !1,
  onClick: a,
  position: i,
  relativeUrl: o,
  shortUrl: s,
  showLabel: l = !1,
  style: c,
  title: u,
  type: m,
  utm: p
}) => {
  var h, C, g, v, y;
  const {
    config: E,
    handleTrackGA4: H,
    userCountry: b
  } = R(), w = new URL(s ?? o, E.siteUrl), x = () => {
    var S, $, D, P;
    if (r) return null;
    const W = {
      "copy-link": bs,
      email: ws,
      facebook: xs,
      print: ks,
      telegram: Es,
      twitter: Hs,
      whatsapp: Ss,
      ...n == null ? void 0 : n.overrideIcons
    }[m];
    return /* @__PURE__ */ f.createElement(Ls, {
      $backgroundColor: (S = c == null ? void 0 : c.backgroundColor) !== null && S !== void 0 ? S : "transparent",
      $iconFillColor: c == null ? void 0 : c.color,
      $mobilePadding: ($ = c == null ? void 0 : c.mobilePadding) !== null && $ !== void 0 ? $ : 0,
      $padding: (D = c == null ? void 0 : c.padding) !== null && D !== void 0 ? D : 0,
      $size: (P = c == null ? void 0 : c.size) !== null && P !== void 0 ? P : 36,
      $svgTransform: c == null ? void 0 : c.svgTransform,
      "data-qa": "render-icon"
    }, /* @__PURE__ */ f.createElement(W, null));
  }, T = (S) => l && /* @__PURE__ */ f.createElement(_n, null, S), L = () => {
    switch (m) {
      case "copy-link":
        return "copy_link";
      default:
        return m;
    }
  }, M = () => {
    const S = L(), $ = new URL(o, E.siteUrl).href;
    i && H({
      action: "click",
      category: "share",
      customized_parameters: {
        method: S,
        position: i,
        share_url: $
      },
      subcategory: ""
    });
  }, V = () => {
    M(), a == null || a();
  }, A = (() => {
    if (!(p != null && p.campaign)) return w.href;
    const S = new URL(w);
    return S.searchParams.set("utm_source", m), S.searchParams.set("utm_campaign", p.campaign), p.medium && S.searchParams.set("utm_medium", p.medium), p.content && S.searchParams.set("utm_content", p.content), S.href;
  })();
  switch (m) {
    case "copy-link":
      return /* @__PURE__ */ f.createElement(t2, {
        className: t,
        disablePortal: n == null || (h = n.copyLink) === null || h === void 0 ? void 0 : h.disablePortal,
        LabelComponent: _n,
        onClick: V,
        showLabel: l,
        tooltipPlacement: (C = n == null || (g = n.copyLink) === null || g === void 0 ? void 0 : g.tooltipPlacement) !== null && C !== void 0 ? C : "bottom-start",
        url: A,
        variant: (v = n == null || (y = n.copyLink) === null || y === void 0 ? void 0 : y.variant) !== null && v !== void 0 ? v : "tooltip"
      }, x(), e);
    case "email":
      const S = `\r
`, $ = `${u}${S}${A}${S}------------------------------${S}` + (b === "HK" ? "Join our Telegram to get the latest Hong Kong updates https://sc.mp/join-our-telegram" : "Download the SCMP app to explore our daily digest of Hong Kong news. https://scmp.onelink.me/3586748601/kdat6bde");
      return /* @__PURE__ */ f.createElement(La, {
        beforeOnClick: V,
        body: $,
        className: t,
        separator: S,
        subject: "Shared from South China Morning Post",
        url: ""
      }, x(), T("Email"), e);
    case "facebook":
      return /* @__PURE__ */ f.createElement(Va, {
        className: t,
        onClick: V,
        url: A
      }, x(), T("Facebook"), e);
    case "print":
      return /* @__PURE__ */ f.createElement(n2, {
        className: t,
        onClick: V,
        url: o
      }, x(), T("Print"), e);
    case "telegram":
      return /* @__PURE__ */ f.createElement(Ta, {
        className: t,
        onClick: V,
        title: `${u}

Join SCMP's Channel: t.me/scmp_news - Get Daily News Update`,
        url: A
      }, x(), T("Telegram"), e);
    case "twitter":
      return /* @__PURE__ */ f.createElement(Sa, {
        className: t,
        onClick: V,
        title: u,
        url: A,
        via: E.twitter.accountName.toLowerCase()
      }, x(), T("X/Twitter"), e);
    case "whatsapp":
      return /* @__PURE__ */ f.createElement(Ha, {
        className: t,
        onClick: V,
        separator: `

`,
        title: u,
        url: A
      }, x(), T("Whatsapp"), e);
    default:
      return null;
  }
};
r2.displayName = "ShareButton";
const As = /* @__PURE__ */ k(j2, {
  target: "e109f9ks5"
})("z-index:", b1.Tooltip, ";"), Ms = /* @__PURE__ */ k("div", {
  target: "e109f9ks4"
})({
  name: "12xxavj",
  styles: "display:flex;flex-flow:row nowrap;align-items:center;padding:20px"
}), Ps = /* @__PURE__ */ k(pr, {
  target: "e109f9ks3"
})({
  name: "hnshaw",
  styles: "inline-size:15px;block-size:19px;margin-inline-end:14px;padding:0;& path:last-of-type{fill:#001246;}"
}), _s = /* @__PURE__ */ k("button", {
  target: "e109f9ks2"
})("margin-inline-start:10px;padding:0;color:#4585ff;font-size:14px;font-family:", Q, ";line-height:16px;border:none;background:transparent;cursor:pointer;"), $s = /* @__PURE__ */ k(r2, {
  target: "e109f9ks1"
})({
  name: "7ug3wf",
  styles: "display:flex;justify-content:center;align-items:center;inline-size:30px;block-size:30px;rect{display:none;}"
}), $n = /* @__PURE__ */ k("div", {
  target: "e109f9ks0"
})({
  name: "y1gwey",
  styles: "inline-size:1px;block-size:20px;margin-inline:5px;background:#bbbbbb"
});
function g1() {
  return g1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, g1.apply(null, arguments);
}
const a2 = ({
  children: e
}) => {
  const {
    removeReadingHistory: t
  } = pt(), [n, r] = ve(), {
    bindBookmarkButton: a
  } = K9();
  return /* @__PURE__ */ f.createElement(xa, {
    popupId: "reading-history-item-popover",
    variant: "popover",
    "data-qa": "reading-history-action-menu"
  }, (i) => {
    const o = ka(i), s = (C) => {
      const g = {
        ...o
      };
      return g.onClick = (v) => {
        r(C), o.onClick(v);
      }, g;
    }, l = Ea(i), c = () => {
      l.onClose(), setTimeout(() => {
        r(void 0);
      }, 500);
    }, u = () => {
      const C = {
        ...l
      };
      return C.onClose = c, C;
    }, m = (C) => i.isOpen && !!n && n.entityUuid === C.entityUuid && n.createdAt === C.createdAt, p = (C) => {
      const g = s1(zr, C.article);
      return ["facebook", "twitter", "copy-link", "email"].map((y) => /* @__PURE__ */ f.createElement($s, {
        extraProps: {
          copyLink: {
            disablePortal: !1,
            tooltipPlacement: "top",
            variant: "tooltip"
          }
        },
        key: y,
        onClick: () => {
          c();
        },
        position: "history",
        relativeUrl: g.urlAlias,
        shortUrl: g.urlAlias,
        showLabel: !1,
        style: {
          /* stylelint-disable csstree/validator */
          /* stylelint-disable property-no-unknown */
          backgroundColor: "transparent",
          svgTransform: "scale(0.75)"
        },
        title: ba(g.socialHeadline, g.headline),
        type: y,
        utm: {
          campaign: g.entityId,
          medium: "share_widget"
        }
      }));
    }, h = (C) => {
      const g = s1(Fr, C.article);
      return /* @__PURE__ */ f.createElement(Ps, g1({}, a({
        entityId: g.entityId,
        trackings: {
          ga4Events: {
            click: {
              action: "click",
              category: "bookmark",
              customized_parameters: {
                action_type: "add",
                article_id: g.entityId,
                trigger_point: "history"
              },
              subcategory: ""
            }
          }
        }
      }, () => {
        setTimeout(c, 500);
      }), {
        "data-qa": "render-bookmark-button"
      }));
    };
    return /* @__PURE__ */ f.createElement(f.Fragment, null, e({
      bindTrigger: s,
      isCurrentItem: m
    }), /* @__PURE__ */ f.createElement(As, g1({
      anchorOrigin: {
        horizontal: "left",
        vertical: "top"
      },
      elevation: 4,
      transformOrigin: {
        horizontal: "left",
        vertical: "bottom"
      }
    }, u()), n ? /* @__PURE__ */ f.createElement(Ms, null, h(n), /* @__PURE__ */ f.createElement($n, null), p(n), /* @__PURE__ */ f.createElement($n, null), /* @__PURE__ */ f.createElement(_s, {
      onClick: () => {
        c(), t(n.article, n.createdAt);
      }
    }, "Remove")) : null));
  });
};
a2.displayName = "ReadingHistoryActionMenu";
const Os = /* @__PURE__ */ k("div", {
  target: "e1h768hc8"
})({
  name: "1ehb0iy",
  styles: "display:flex;flex-flow:column nowrap;border:1px solid #a1a1a1;border-radius:4px;background:#f2f2f2;overflow:hidden"
}), Rs = /* @__PURE__ */ k("div", {
  target: "e1h768hc7"
})({
  name: "6cm4s2",
  styles: "display:flex;flex-flow:column nowrap;gap:20px;padding:20px"
}), Is = /* @__PURE__ */ k("div", {
  target: "e1h768hc6"
})({
  name: "ege6rc",
  styles: 'display:grid;grid:"greeting link" min-content "message message" min-content/1fr max-content;grid-gap:12px;align-items:baseline;min-inline-size:90px'
}), Ds = /* @__PURE__ */ k("span", {
  target: "e1h768hc5"
})("grid-area:greeting;color:#000000;font-weight:400;font-size:16px;font-family:", ce, ";line-height:21px;", (e) => e.theme.breakpoints.up("tablet"), "{font-size:16px;line-height:19px;}"), Bs = /* @__PURE__ */ k("span", {
  target: "e1h768hc4"
})({
  name: "1666q6m",
  styles: "font-weight:700;word-break:break-all"
}), On = /* @__PURE__ */ k("a", {
  target: "e1h768hc3"
})("grid-area:link;justify-self:flex-end;color:#4585ff;font-weight:400;font-size:16px;font-family:", Q, ";line-height:19px;white-space:nowrap;cursor:pointer;", (e) => e.theme.breakpoints.up("tablet"), "{font-size:14px;line-height:16px;}"), Fs = /* @__PURE__ */ k("div", {
  target: "e1h768hc2"
})({
  name: "1k47rlg",
  styles: "grid-area:message"
}), zs = /* @__PURE__ */ k("div", {
  target: "e1h768hc1"
})({
  name: "1tc6xju",
  styles: "flex:1;overflow:auto"
}), Zs = /* @__PURE__ */ k("div", {
  target: "e1h768hc0"
})({
  name: "w65oug",
  styles: "display:flex;justify-content:center;align-items:center;min-block-size:56px;background:#ededed"
}), Ws = {
  name: "1qpdkzg",
  styles: "scrollbar-width:thin;scrollbar-gutter:stable;&::-webkit-scrollbar{inline-size:6px;background-color:#f5f5f5;}&::-webkit-scrollbar-track{background-color:#f5f5f5;}&::-webkit-scrollbar-thumb{border-radius:20px;background-color:#cccccc;}&::-webkit-scrollbar-thumb:hover{background:#bbbbbb;}"
}, Ns = (e) => /* @__PURE__ */ d.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 180 203", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("circle", { cx: 90, cy: 90, r: 90, fill: "#F2F2F2" }), /* @__PURE__ */ d.createElement("circle", { cx: 90, cy: 90, r: 57.012, fill: "white" }), /* @__PURE__ */ d.createElement("path", { d: "M89.9731 63.1076C75.1285 63.1076 63.1076 75.1554 63.1076 90C63.1076 104.845 75.1285 116.892 89.9731 116.892C104.845 116.892 116.892 104.845 116.892 90C116.892 75.1554 104.845 63.1076 89.9731 63.1076ZM98.8476 102.666L87.3108 91.1026V76.5538H92.6892V88.8974L102.666 98.8745L98.8476 102.666Z", fill: "#7E8599" }), /* @__PURE__ */ d.createElement("circle", { cx: 90.3387, cy: 136.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ d.createElement("circle", { cx: 90.3387, cy: 166.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ d.createElement("circle", { cx: 90.3387, cy: 196.235, r: 5, fill: "#FFCA05" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.6517 89.6331C30.6872 84.8257 31.2607 80.0599 32.4238 75.4906C36.2166 60.5304 45.6985 47.4666 59.3946 39.2491C72.9853 31.1369 88.8938 28.8191 104.17 32.6118C119.552 36.4045 132.405 45.9917 140.517 59.5823C148.63 73.1728 151.053 89.0812 147.155 104.357C143.362 119.739 133.775 132.592 120.184 140.704C106.593 148.816 90.6848 151.24 75.4084 147.342C60.0267 143.549 47.1735 133.962 39.0612 120.371L42.6432 118.159C50.1234 130.801 62.1338 139.651 76.3566 143.233C90.5795 146.815 105.329 144.602 117.972 137.122C130.614 129.642 139.464 117.632 143.046 103.409C146.628 89.1865 144.416 74.4371 136.935 61.7947C129.455 49.1523 117.445 40.3026 103.222 36.7206C88.9992 33.1386 74.2495 35.351 61.607 42.8311C44.4532 53.0416 34.3254 71.5644 34.868 91.3985L41.4801 85.5759L44.4408 88.8678L32.8173 99.1825L22.9482 87.1121L26.3476 84.3689L30.6517 89.6331Z", fill: "#DAE3E9" }), /* @__PURE__ */ d.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 132, x2: 139, y2: 132, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 142, x2: 133, y2: 142, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 137, x2: 121, y2: 137, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 126, y1: 137, x2: 145, y2: 137, stroke: "#7E8599", strokeWidth: 2 })), /* @__PURE__ */ d.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 162, x2: 139, y2: 162, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 172, x2: 139, y2: 172, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 167, x2: 126, y2: 167, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 128, y1: 167, x2: 147, y2: 167, stroke: "#7E8599", strokeWidth: 2 })), /* @__PURE__ */ d.createElement("g", { opacity: 0.6 }, /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 192, x2: 115, y2: 192, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 117, y1: 192, x2: 139, y2: 192, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 202, x2: 149, y2: 202, stroke: "#7E8599", strokeWidth: 2 }), /* @__PURE__ */ d.createElement("line", { x1: 102, y1: 197, x2: 128, y2: 197, stroke: "#7E8599", strokeWidth: 2 }))), Us = /* @__PURE__ */ k("div", {
  target: "euvv2st11"
})("block-size:100%;padding:20px;background:#ffffff;overflow-y:auto;", Ws, ";"), js = /* @__PURE__ */ k("div", {
  target: "euvv2st10"
})("color:#000000;font-weight:700;font-size:16px;font-family:", Q, ";line-height:19px;"), qs = /* @__PURE__ */ k("div", {
  target: "euvv2st9"
})(""), Gs = /* @__PURE__ */ k("div", {
  target: "euvv2st8"
})({
  name: "84lqid",
  styles: "display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;padding-block:20px"
}), Ys = /* @__PURE__ */ k("div", {
  target: "euvv2st7"
})("color:#000000;font-size:14px;font-family:", ce, ";line-height:18px;text-transform:uppercase;"), Ks = /* @__PURE__ */ k("button", {
  target: "euvv2st6"
})("color:#4585ff;font-size:14px;font-family:", Q, ";line-height:16px;border:none;background:transparent;cursor:pointer;"), Xs = /* @__PURE__ */ k("div", {
  target: "euvv2st5"
})({
  name: "1tzhvsk",
  styles: 'position:relative;padding-block-end:28px;padding-inline-start:20px;::before{position:absolute;inset-block-start:2px;inset-inline-start:0;content:"";z-index:2;display:block;inline-size:10px;block-size:10px;border-radius:50%;background:#ffca05;}::after{position:absolute;inset-block-start:2px;inset-inline-start:0;content:"";z-index:1;display:block;inline-size:10px;block-size:calc(100% + 8px);border-radius:5px 5px 0 0;background:#f2f2f2;}:last-child{::after{block-size:calc(100% - 2px);}}'
}), Qs = /* @__PURE__ */ k("div", {
  target: "euvv2st4"
})("color:#666666;font-size:16px;font-family:", Q, ";line-height:22px;cursor:pointer;", (e) => e.theme.breakpoints.up("tablet"), "{font-size:14px;line-height:18px;}:hover{color:#4585ff;}"), Js = /* @__PURE__ */ k(X1, {
  ...er,
  target: "euvv2st3"
})("padding-block:4px;padding-inline:0;color:", (e) => e.$isActive ? "#000000" : "#cccccc", ";"), el = /* @__PURE__ */ k("div", {
  target: "euvv2st2"
})("display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;margin-block-start:16px;color:#666666;font-size:14px;font-family:", Q, ";"), tl = /* @__PURE__ */ k(Ns, {
  target: "euvv2st1"
})("min-inline-size:180px;max-inline-size:250px;margin-block-start:28px;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:180px;}"), Rn = /* @__PURE__ */ k(q2, {
  target: "euvv2st0"
})({
  name: "7rcus4",
  styles: "display:block;margin-block:30px;margin-inline:auto;color:#4585ff"
});
function j1() {
  return j1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, j1.apply(null, arguments);
}
const i2 = ({
  state: e
}) => {
  const {
    currentPageType: t,
    handleRoutePush: n,
    handleTrackGA4: r,
    user: a
  } = R(), {
    clearReadingHistory: i
  } = pt(), o = Object.entries(Y9(e.result, (s) => ke(s.createdAt)));
  return Ve(() => {
    r({
      action: "imp",
      category: "readinghistory",
      subcategory: ""
    });
  }), /* @__PURE__ */ f.createElement(a2, {
    "data-qa": "reading-history-panel"
  }, ({
    bindTrigger: s,
    isCurrentItem: l
  }) => {
    const c = () => {
      const p = a ? "Your recently viewed stories will appear here. This allows us to give you a more personalised experience." : "By signing up as a registered user, your recently viewed stories will appear here. This allows us to give you a more personalised experience.";
      return /* @__PURE__ */ f.createElement(el, {
        "data-qa": "render-empty-message"
      }, p, /* @__PURE__ */ f.createElement(tl, null));
    }, u = () => {
      const p = (C) => {
        const g = new Date(C);
        return Ii(g) ? "Today" : Bi(g) ? "Yesterday" : C;
      }, h = (C) => {
        var g;
        const v = s1(Br, C.article);
        return /* @__PURE__ */ f.createElement(Xs, {
          key: C.entityUuid,
          "data-qa": "render-item"
        }, /* @__PURE__ */ f.createElement(Qs, {
          onClick: () => {
            var y;
            r({
              action: "click",
              category: "readinghistory",
              customized_parameters: {
                action_type: "read",
                article_id: v.entityId
              },
              subcategory: ""
            }), n(v.urlAlias, {
              applicationId: (y = v.application) === null || y === void 0 ? void 0 : y.entityUuid,
              entityId: v.entityId,
              entityUuid: v.entityUuid,
              query: {
                campaign: "reading_history",
                module: "my_account_overlay",
                pgtype: t
              },
              type: W2(v.__typename)
            });
          }
        }, (g = v.socialHeadline) !== null && g !== void 0 ? g : v.headline), /* @__PURE__ */ f.createElement(Js, j1({
          "aria-label": "more action",
          disableRipple: !0
        }, s(C), {
          $isActive: l(C)
        }), /* @__PURE__ */ f.createElement(p9, {
          color: "inherit"
        })));
      };
      return o.map(([C, g]) => /* @__PURE__ */ f.createElement(qs, {
        key: C
      }, /* @__PURE__ */ f.createElement(Gs, null, /* @__PURE__ */ f.createElement(Ys, null, p(C)), /* @__PURE__ */ f.createElement(Ks, {
        onClick: () => void i(C)
      }, "Clear")), g.map((v) => h(v))));
    }, m = () => {
      const p = o.length === 0;
      switch (e.status) {
        case "error":
        case "success":
          return p ? c() : u();
        case "loading":
          return p ? /* @__PURE__ */ f.createElement(Rn, {
            color: "inherit"
          }) : void 0;
        case "not-executed":
          return /* @__PURE__ */ f.createElement(Rn, {
            color: "inherit"
          });
      }
    };
    return /* @__PURE__ */ f.createElement(Us, null, /* @__PURE__ */ f.createElement(js, null, "Recently Viewed"), m());
  });
};
i2.displayName = "ReadingHistoryPanel";
const o2 = ({
  beforeHeaderSlot: e,
  className: t,
  messageRenders: n
}) => {
  var r;
  const {
    config: a,
    handleOpenLoginDialog: i,
    handleRoutePush: o,
    user: s
  } = R(), l = s != null && s.firstname && s !== null && s !== void 0 && s.lastname ? `${s.firstname} ${s.lastname}` : (r = s == null ? void 0 : s.username) !== null && r !== void 0 ? r : "Guest", c = () => s ? /* @__PURE__ */ f.createElement(On, {
    onClick: () => {
      const p = new URL(`${a.accounts.host}/settings`);
      p.searchParams.set("destination", window.location.href), o(p.toString());
    },
    "data-qa": "render-account-link"
  }, "My Account") : /* @__PURE__ */ f.createElement(On, {
    onClick: () => {
      i({
        destination: window.location.href,
        ga4CustomParameter: {
          trigger_point: "header"
        }
      });
    }
  }, "Sign In / Register"), {
    message: u
  } = o9(n), {
    state: m
  } = r9();
  return /* @__PURE__ */ f.createElement(Os, {
    className: t,
    "data-qa": "dashboard-display"
  }, /* @__PURE__ */ f.createElement(Rs, null, e, /* @__PURE__ */ f.createElement(Is, null, /* @__PURE__ */ f.createElement(Ds, null, "Hi, ", /* @__PURE__ */ f.createElement(Bs, null, l)), c(), /* @__PURE__ */ f.createElement(Fs, null, u))), /* @__PURE__ */ f.createElement(zs, null, /* @__PURE__ */ f.createElement(i2, {
    state: m
  })), /* @__PURE__ */ f.createElement(Zs, null, c()));
};
o2.displayName = "DashboardDisplay";
const nl = /* @__PURE__ */ k("div", {
  target: "eprlsh16"
})({
  name: "14l2p6l",
  styles: "inline-size:fit-content"
}), rl = /* @__PURE__ */ k(o2, {
  target: "eprlsh15"
})("block-size:100vh;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:300px;block-size:574px;}"), al = /* @__PURE__ */ k(G2, {
  target: "eprlsh14"
})("z-index:", b1.Modal, ";"), il = /* @__PURE__ */ k("div", {
  target: "eprlsh13"
})("display:flex;justify-content:space-between;align-items:center;", (e) => e.theme.breakpoints.up("tablet"), "{display:none;}"), ol = /* @__PURE__ */ k(Y2, {
  target: "eprlsh12"
})("z-index:", b1.Modal, ";"), sl = /* @__PURE__ */ k("div", {
  target: "eprlsh11"
})(""), ll = (e) => /* @__PURE__ */ d.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.81257 8.03137L16 15.1874L15.2503 15.9999L8 8.78108L0.812571 15.9999L0 15.1874L7.18743 8.03137L0 0.81251L0.812571 -6.10352e-05L8 7.2188L15.2503 -6.10352e-05L16 0.81251L8.81257 8.03137Z", fill: "white" }));
function q1() {
  return q1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, q1.apply(null, arguments);
}
const cl = /* @__PURE__ */ k(X1, {
  target: "e15aj8c1"
})({
  name: "if9fso",
  styles: "flex:none;margin-inline-start:18px;padding:0"
}), ul = /* @__PURE__ */ k(({
  className: e,
  ...t
}) => /* @__PURE__ */ f.createElement(K2, q1({}, t, {
  classes: {
    popper: e
  }
})), {
  target: "e15aj8c0"
})("& .", _t.tooltip, "{display:flex;flex-flow:row nowrap;justify-content:end;align-items:flex-start;inline-size:max-content;max-inline-size:325px;padding:16px;color:#ffffff;font-weight:400;font-size:16px;font-family:", Q, ";line-height:22px;border-radius:0;background:rgba(0, 18, 70, 0.9);cursor:pointer;user-select:none;}& .", _t.arrow, "{color:rgba(0, 18, 70, 0.9);font-size:25px;}"), s2 = ({
  children: e,
  isDashboardOpen: t,
  isTooltipVisible: n,
  tooltipRenders: r
}) => {
  var a;
  const [i, o] = je(async () => {
    if (!r) return null;
    const p = await Promise.allSettled(r.map((h) => h.current));
    for (const h of p)
      if (!(h.status === "rejected" || h.value === null))
        return h.value;
  }), [s, l] = ve(!1);
  Zn(() => {
    s || o.execute();
  }, [r, s]);
  const c = n && !t && !s && i.status === "success" && !!((a = i.result) !== null && a !== void 0 && a.node), u = i.status === "success" ? i.result : void 0, {
    router: m
  } = R();
  return F(() => {
    const p = () => {
      var h;
      !c || !u || (l(!0), u == null || (h = u.onChangeUrl) === null || h === void 0 || h.call(u));
    };
    return m.events.on("routeChangeStart", p), () => {
      m.events.off("routeChangeStart", p);
    };
  }, [u, m, c]), F(() => {
    t && u && l(!0);
  }, [t, c, u]), /* @__PURE__ */ f.createElement(ul, {
    arrow: !0,
    open: c,
    placement: "bottom-end",
    PopperProps: {
      disablePortal: !0,
      modifiers: [{
        name: "offset",
        options: {
          offset: [16, 0]
        }
      }]
    },
    title: /* @__PURE__ */ f.createElement(f.Fragment, null, u == null ? void 0 : u.node, /* @__PURE__ */ f.createElement(cl, {
      "aria-label": "close",
      disableRipple: !0,
      onClick: () => {
        var p;
        l(!0), u == null || (p = u.onClose) === null || p === void 0 || p.call(u);
      }
    }, /* @__PURE__ */ f.createElement(ll, null))),
    "data-qa": "dashboard-tooltips"
  }, e);
};
s2.displayName = "DashboardTooltips";
function G1() {
  return G1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, G1.apply(null, arguments);
}
const hc = ({
  children: e,
  className: t,
  messageRenders: n,
  tooltipRenders: r
}) => {
  const {
    hasAcceptedGDPR: a
  } = R();
  t9();
  const i = Y1(null), [o, s] = na(!0), [l, c] = ve(!1), u = ra(i), m = o1(i1.breakpoints.only("mobile"), !1), p = o1(i1.breakpoints.up("desktop"), !1), h = () => /* @__PURE__ */ f.createElement(rl, {
    beforeHeaderSlot: /* @__PURE__ */ f.createElement(il, null, /* @__PURE__ */ f.createElement(i9, null), /* @__PURE__ */ f.createElement(X1, {
      "aria-label": "close",
      disableRipple: !0,
      onClick: () => c(!1)
    }, /* @__PURE__ */ f.createElement(a9, null))),
    messageRenders: n,
    "data-qa": "render-display"
  }), {
    setIsFirstTime: C
  } = Dr();
  F(() => {
    !l || !a || C(!1);
  }, [a, l, C]), F(() => {
    s(u == null ? void 0 : u.isIntersecting);
  }, [u == null ? void 0 : u.isIntersecting, s]);
  const g = he(() => [{
    name: "offset",
    options: {
      // This is for handling tablet placement of the popper
      offset: [p ? 0 : 42, 10]
    }
  }], [p]), v = () => c(!1);
  return F(() => {
    if (l && p)
      window.addEventListener("scroll", v);
    else
      return () => {
        window.removeEventListener("scroll", v);
      };
    return () => {
      window.removeEventListener("scroll", v);
    };
  }, [p, l]), /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement(Uo, null, /* @__PURE__ */ f.createElement(s2, {
    isDashboardOpen: l,
    isTooltipVisible: o,
    tooltipRenders: r
  }, /* @__PURE__ */ f.createElement(nl, {
    className: t,
    onClick: () => c(!0),
    ref: i
  }, e))), /* @__PURE__ */ f.createElement(al, {
    anchor: "bottom",
    hideBackdrop: !0,
    onClose: () => c(!1),
    open: m && l,
    SlideProps: {
      easing: {
        enter: "ease"
      },
      timeout: {
        enter: 500,
        exit: 0
      }
    }
  }, h()), /* @__PURE__ */ f.createElement(ol, {
    anchorEl: i.current,
    modifiers: g,
    open: !m && l,
    placement: "bottom-end",
    transition: !0
  }, ({
    TransitionProps: y
  }) => /* @__PURE__ */ f.createElement(X2, {
    onClickAway: () => c(!1)
  }, /* @__PURE__ */ f.createElement(Q2, G1({}, y, {
    timeout: {
      enter: 500,
      exit: 0
    }
  }), /* @__PURE__ */ f.createElement(sl, null, h())))));
}, l2 = /* @__PURE__ */ function() {
  var e = [{
    kind: "Literal",
    name: "filter",
    value: {
      entityId: "acquisition"
    }
  }], t = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "json",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: [],
      kind: "Fragment",
      metadata: null,
      name: "hooksUseGroupSubscriptionDataQuery",
      selections: [{
        alias: null,
        args: e,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [
          t
          /*: any*/
        ],
        storageKey: 'appConfig(filter:{"entityId":"acquisition"})'
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: [],
      kind: "Operation",
      name: "hooksUseGroupSubscriptionDataQuery",
      selections: [{
        alias: null,
        args: e,
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: [t, {
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "id",
          storageKey: null
        }],
        storageKey: 'appConfig(filter:{"entityId":"acquisition"})'
      }]
    },
    params: {
      cacheID: "f8a59a268fef536b2b8a27cbc8bf3147",
      id: null,
      metadata: {},
      name: "hooksUseGroupSubscriptionDataQuery",
      operationKind: "query",
      text: `query hooksUseGroupSubscriptionDataQuery {
  appConfig(filter: {entityId: "acquisition"}) {
    json
    id
  }
}
`
    }
  };
}();
l2.hash = "10b91bd845ddc4c70e045441fbd4454d";
var dl = kr, fl = Sr, pl = x1, ml = J, gl = rt, Cl = ot, hl = xr, vl = st, yl = "[object Map]", bl = "[object Set]", wl = Object.prototype, xl = wl.hasOwnProperty;
function kl(e) {
  if (e == null)
    return !0;
  if (gl(e) && (ml(e) || typeof e == "string" || typeof e.splice == "function" || Cl(e) || vl(e) || pl(e)))
    return !e.length;
  var t = fl(e);
  if (t == yl || t == bl)
    return !e.size;
  if (hl(e))
    return !dl(e).length;
  for (var n in e)
    if (xl.call(e, n))
      return !1;
  return !0;
}
var El = kl;
const In = /* @__PURE__ */ C1(El), Hl = async (e, t) => (await e.post("/tier", {
  email: t,
  withCredentials: !0
})).data || "", Sl = /* @__PURE__ */ k("div", {
  target: "e1dy73d80"
})({
  name: "dpbic8",
  styles: "inline-size:240px;color:#ffffff;font-size:16px;line-height:18px;a{color:#ffffff;text-decoration:underline;}"
}), c2 = ({
  message: e,
  onImpression: t
}) => (Ve(() => {
  t();
}), /* @__PURE__ */ f.createElement(Sl, {
  dangerouslySetInnerHTML: {
    __html: e
  },
  "data-qa": "group-subscriber-tooltip"
}));
c2.displayName = "GroupSubscriberTooltip";
const vc = () => {
  const {
    user: e
  } = R(), {
    remove: t,
    set: n,
    value: r
  } = ae("groupSubscriberTooltipData"), a = Tl(), i = Vl(), o = Wn(r), {
    promise: s,
    reject: l,
    resolve: c
  } = y1();
  return F(() => {
    var u, m;
    if (Dn(a) || Dn(i)) return;
    if (!e || Bn(a) || Bn(i)) return l.current();
    const p = a.result, h = i.result;
    if (!p || !h) return l.current();
    (o == null || (u = o.current) === null || u === void 0 ? void 0 : u.version) !== p.tooltip.version && t();
    const C = (m = o.current) !== null && m !== void 0 ? m : {
      intervalData: [{
        intervalTime: 0,
        shown: !1
      }, {
        intervalTime: 604800,
        shown: !1
      }, {
        intervalTime: 1209600,
        shown: !1
      }, {
        intervalTime: 1814400,
        shown: !1
      }, {
        intervalTime: 2419200,
        shown: !1
      }],
      lastShownTimeStamp: O1(Date.now()),
      version: p.tooltip.version
    }, g = O1(Date.now()) - C.lastShownTimeStamp;
    if (!C.intervalData) return l.current();
    for (const [v] of C.intervalData.entries()) {
      const y = C.intervalData;
      if (n(() => {
        var E;
        const H = [...y];
        return H[v] = {
          intervalTime: y[v].intervalTime,
          shown: !0
        }, {
          intervalData: H,
          lastShownTimeStamp: C.lastShownTimeStamp,
          version: (E = C.version) !== null && E !== void 0 ? E : ""
        };
      }), g >= C.intervalData[v].intervalTime && !C.intervalData[v].shown)
        return c.current({
          node: /* @__PURE__ */ f.createElement(c2, {
            message: `${p.tooltip.message}`,
            onImpression: () => {
            }
          }),
          onChangeUrl: () => {
          }
        });
    }
    return l.current();
  }, [a, i, l, t, c, n, o, e, s]), {
    groupSubscriberTooltipRender: s
  };
}, Dn = (e) => !e || e.status === "loading" || e.status === "not-executed", Bn = (e) => e.status === "error", Tl = () => {
  const e = Xn(), {
    config: t
  } = R(), [n, r] = je(async () => {
    var a, i;
    const o = await Qn(e, l2, {}).toPromise();
    if (o != null && (a = o.appConfig) !== null && a !== void 0 && a.json) return (o == null || (i = o.appConfig) === null || i === void 0 ? void 0 : i.json)[t.environment];
  });
  return Ve(() => {
    r.execute();
  }), n;
}, Vl = () => {
  const {
    config: e,
    user: t
  } = R(), {
    remove: n,
    set: r,
    value: a
  } = ae("corp_subscriber_tier"), i = he(() => Q1.create({
    baseURL: e.corporateSubscriber.host,
    headers: {
      apikey: e.graphql.apiKey
    }
  }), [e]), [o, s] = je(async () => {
    var l, c;
    const u = /* @__PURE__ */ new Set(["C-suite", "T2", "T3", "T4"]);
    if (!(t != null && t.useremail)) return !1;
    if (a && (a == null ? void 0 : a["Users Email Address"]) !== (t == null ? void 0 : t.useremail) && n(), !In(a)) return u.has((l = a == null ? void 0 : a.Tier) !== null && l !== void 0 ? l : "");
    const m = await Hl(i, t == null ? void 0 : t.useremail);
    return In(a) && m && r(m), u.has((c = m == null ? void 0 : m.Tier) !== null && c !== void 0 ? c : "");
  });
  return Ve(() => void s.execute()), o;
}, Ll = /* @__PURE__ */ k("div", {
  target: "e6yd7ba0"
})("display:flex;flex:none;justify-content:center;align-items:center;padding-block:1px;padding-inline:5px;color:#ffffff;font-weight:700;font-size:14px;font-family:", ce, ";line-height:18px;text-transform:uppercase;border-radius:4px;background:#eb4254;"), yc = () => {
  const {
    hasAcceptedGDPR: e
  } = R(), {
    isFirstTime: t,
    setIsFirstTime: n
  } = Dr(), {
    promise: r,
    reject: a,
    resolve: i
  } = y1();
  return F(() => e && t ? i.current({
    node: /* @__PURE__ */ f.createElement(f.Fragment, null, "Find your recently read stories and latest notifications here.", /* @__PURE__ */ f.createElement(Ll, null, "New")),
    onChangeUrl: () => {
      n(!1);
    },
    onClose: () => {
      n(!1);
    }
  }) : a.current(), [i, a, t, r, n, e]), {
    hintTooltipRender: r
  };
}, Al = (e) => /* @__PURE__ */ d.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.414 19.6869L21.437 10.6639L19.141 8.36694L12.414 15.0389L8.914 11.4839L6.562 13.8349L12.414 19.6869ZM23.898 23.8979C21.164 26.6319 17.864 27.9999 14 27.9999C10.135 27.9999 6.836 26.6319 4.101 23.8979C1.367 21.1639 0 17.8649 0 13.9999C0 10.1349 1.367 6.83494 4.101 4.10094C6.836 1.36694 10.135 -6.10352e-05 14 -6.10352e-05C17.864 -6.10352e-05 21.164 1.36694 23.898 4.10094C26.633 6.83494 28 10.1349 28 13.9999C28 17.8649 26.633 21.1639 23.898 23.8979Z", fill: "white" })), Ml = /* @__PURE__ */ k("div", {
  target: "e1yc3qie1"
})({
  name: "zjik7",
  styles: "display:flex"
}), Pl = /* @__PURE__ */ k(Al, {
  target: "e1yc3qie0"
})({
  name: "dyx8jd",
  styles: "flex:none;inline-size:28px;block-size:28px;margin-inline-end:16px"
}), u2 = ({
  onImpression: e
}) => (Ve(() => {
  e();
}), /* @__PURE__ */ f.createElement(Ml, {
  "data-qa": "login-reminder-tooltip"
}, /* @__PURE__ */ f.createElement(Pl, null), "Log in again for better content recommendations."));
u2.displayName = "LoginReminderTooltip";
const bc = () => {
  const {
    hasAcceptedGDPR: e,
    user: t
  } = R(), [n] = R2("last_logout_timestamp"), {
    remove: r,
    set: a,
    value: i
  } = ae("loginReminderData"), o = Wn(i);
  F(() => {
    t && r();
  }, [r, t]);
  const {
    promise: s,
    reject: l,
    resolve: c
  } = y1();
  return F(() => {
    var u;
    if (!e || n === null || t) return l.current();
    const m = (u = o.current) !== null && u !== void 0 ? u : [{
      // 30 minutes
      intervalTime: 1800,
      shown: !1
    }, {
      // 1 day
      intervalTime: 86400,
      shown: !1
    }, {
      // 30 days
      intervalTime: 172800,
      shown: !1
    }], p = O1(/* @__PURE__ */ new Date()), h = Number.parseInt(n ?? "0");
    for (const [C, g] of m.entries())
      if (p - h >= g.intervalTime && !g.shown)
        return a(() => (m[C].shown = !0, m)), c.current({
          node: /* @__PURE__ */ f.createElement(u2, {
            onImpression: () => {
            }
          }),
          onChangeUrl: () => {
          }
        });
    return l.current();
  }, [n, l, c, a, o, e, t]), {
    loginReminderTooltipRender: s
  };
}, _l = /* @__PURE__ */ k("div", {
  target: "e1nmhixk0"
})({
  name: "dpbic8",
  styles: "inline-size:240px;color:#ffffff;font-size:16px;line-height:18px;a{color:#ffffff;text-decoration:underline;}"
}), d2 = ({
  message: e
}) => /* @__PURE__ */ f.createElement(_l, {
  dangerouslySetInnerHTML: {
    __html: e
  },
  "data-qa": "piano-tooltip-display"
});
d2.displayName = "PianoTooltipDisplay";
const wc = () => {
  var e;
  const {
    rosettaInstance: t
  } = R(), {
    set: n,
    value: r
  } = ae("pianoTooltipHistory", {
    defaultValue: []
  }), {
    message: a,
    shortKey: i,
    version: o
  } = (e = t == null ? void 0 : t.rulesEngine.getOutcome("ui.tooltip.messageObject")) !== null && e !== void 0 ? e : {}, s = i && o && `${i}_${o.toString()}`, [l, c] = ve(), {
    promise: u,
    reject: m,
    resolve: p
  } = y1();
  return F(() => {
    if (t) {
      if (s && r) {
        c(!r.includes(s));
        return;
      }
    } else return;
    c(!1);
  }, [r, t, s, o]), F(() => {
    if (!(!t || l === void 0))
      return l && a && s ? p.current({
        node: /* @__PURE__ */ f.createElement(d2, {
          message: a
        }),
        onChangeUrl: () => {
          n((h) => $t(h ?? [], [s])), c(!1);
        },
        onClose: () => {
          n((h) => $t(h ?? [], [s])), c(!1);
        }
      }) : m.current();
  }, [l, a, m, p, t, n, s]), {
    pianoTooltipRender: u
  };
}, $l = /* @__PURE__ */ k("div", {
  target: "e1que4v90"
})({
  name: "u25i9k",
  styles: "display:flex;flex-flow:column;justify-content:flex-start;align-items:center;inline-size:600px;min-block-size:252px;margin:auto;padding-block:40px;padding-inline:0;border-radius:8px;background-color:#ffffff;outline:none"
}), f2 = ({
  children: e,
  isShow: t,
  onClose: n
}) => /* @__PURE__ */ f.createElement(fa, {
  onClose: n,
  open: t,
  "data-qa": "popup"
}, /* @__PURE__ */ f.createElement($l, null, e));
f2.displayName = "Popup";
const Ol = /* @__PURE__ */ k(I2, {
  target: "e1qc5gx50"
})(D2, "{margin-block-start:0;}", B2, "{font-size:21px;line-height:27px;}", F2, "{font-size:16px;}", z2, "{font-size:14px;}"), Rl = ({
  isShow: e,
  onClose: t
}) => /* @__PURE__ */ f.createElement(f2, {
  isShow: e,
  onClose: t,
  "data-qa": "sign-up-popup"
}, /* @__PURE__ */ f.createElement(J2, {
  theme: {
    signUpSuccess: {
      hasCheckEmail: !0
    }
  }
}, /* @__PURE__ */ f.createElement(Ol, null)));
Rl.displayName = "SignUpPopup";
async function Il(e) {
  const t = await Q1.post("/piano/renew", {
    subscriptionId: e
  }), {
    code: n,
    data: r
  } = t.data;
  return n === 0 && r === !0;
}
const X = /* @__PURE__ */ k("button", {
  target: "e1uch9rj1"
})("padding-block:8px;padding-inline:12px;color:#001246;font-size:14px;font-family:", ce, ";line-height:16px;white-space:nowrap;text-align:center;text-transform:uppercase;border-radius:2px;background:#ffca05;cursor:pointer;", (e) => e.theme.breakpoints.up("tablet"), "{padding-block:6px;padding-inline:10px;}"), Dl = /* @__PURE__ */ k("span", {
  target: "e1uch9rj0"
})((e) => {
  switch (e.$variant) {
    case "dark":
      return /* @__PURE__ */ De(X, "{color:#ffffff;background:#222222;}", "");
    case "dark-blue":
      return /* @__PURE__ */ De(X, "{color:#ffffff;font-weight:700;background:#001246;}", "");
    case "light-blue":
      return /* @__PURE__ */ De(X, "{padding-block:7px;padding-inline:8px;color:#ffffff;background:#4585ff;}", "");
    default:
      return null;
  }
}, ";"), p2 = ({
  className: e
}) => {
  const {
    handleTrackGA4: t,
    rosettaInstance: n
  } = R(), {
    computeGA4CommonParameters: r
  } = be(), [a, i] = ve(!1);
  F(() => {
    n != null && n.rulesEngine.getOutcome("user.autoRenewEnabled") || i(!0);
  }, [n == null ? void 0 : n.rulesEngine]);
  const {
    captureTrackImpressionEventTargetElement: o
  } = Ue({
    ga4Event: q(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...r(),
        call_to_action: "enable auto-renew",
        trigger_point: "masthead renewal button"
      },
      subcategory: "entry_point"
    }), [r])
  });
  return a ? /* @__PURE__ */ f.createElement(X, {
    className: e,
    onClick: () => {
      (async () => {
        const l = n == null ? void 0 : n.rulesEngine.getOutcome("user.autoRenewSubscriptionId");
        t({
          action: "click",
          category: "subs",
          customized_parameters: {
            ...r(),
            call_to_action: "enable auto-renew",
            trigger_point: "masthead enable auto-renew button"
          },
          subcategory: "entry_point"
        }), !(!l || !await Il(l)) && (window.postMessage({
          type: "PIANO_AUTORENEW_CONFIRMATION"
        }, "*"), n == null || n.rulesEngine.addRule(new n.Rule("user.autoRenewEnabled").priority(10).when(() => !0).then(!0)), await (n == null ? void 0 : n.rulesEngine.run()), i(!1));
      })();
    },
    ref: o,
    "data-qa": "auto-renew-button"
  }, "Enable Auto-renew") : null;
};
p2.displayName = "AutoRenewButton";
const m2 = ({
  className: e
}) => {
  const {
    handleTrackGA4: t
  } = R();
  return /* @__PURE__ */ f.createElement(X, {
    className: e,
    onClick: () => {
      t({
        action: "click",
        category: "plus",
        subcategory: "masthead"
      });
      const n = new URL("/plus", location.origin), r = new URL(location.href).searchParams;
      n.search = r.toString(), window.location.href = n.toString();
    },
    "data-qa": "scmp-plus-button"
  }, "SCMP ", /* @__PURE__ */ f.createElement("i", null, "Plus"));
};
m2.displayName = "ScmpPlusButton";
const g2 = ({
  className: e
}) => {
  const {
    handleTrackGA4: t
  } = R(), {
    computeGA4CommonParameters: n
  } = be();
  return /* @__PURE__ */ f.createElement(X, {
    className: e,
    onClick: () => {
      t({
        action: "click",
        category: "epaper",
        customized_parameters: {
          call_to_action: "read epaper",
          ...n(),
          trigger_point: "masthead"
        },
        subcategory: ""
      }), window.location.href = "/epaper";
    },
    "data-qa": "epaper-button"
  }, "Read ePaper");
};
g2.displayName = "EpaperButton";
const Bl = ({
  className: e,
  location: t = "masthead",
  variant: n
}) => {
  const {
    rosettaInstance: r
  } = R(), a = o1(i1.breakpoints.only("mobile"), !1), i = r == null ? void 0 : r.rulesEngine.getOutcome("ui.masthead.button"), o = he(() => i == null ? void 0 : i.getDisplayVariant({
    shouldIncludeEpaper: !0,
    shouldIncludeScmpPlus: !a
  }), [a, i]), s = he(() => o === "SCMPPLUS" ? "dark-blue" : n, [o, n]), l = () => {
    switch (o) {
      case "AUTORENEW":
        return /* @__PURE__ */ f.createElement(p2, {
          className: e
        });
      case "EPAPER":
        return /* @__PURE__ */ f.createElement(g2, {
          className: e
        });
      case "GRACEPERIOD":
        return /* @__PURE__ */ f.createElement(C2, {
          className: e
        });
      case "REACTIVATE":
        return /* @__PURE__ */ f.createElement(h2, {
          className: e,
          location: t
        });
      case "RENEW":
        return /* @__PURE__ */ f.createElement(v2, {
          className: e
        });
      case "SCMPPLUS":
        return /* @__PURE__ */ f.createElement(m2, {
          className: e
        });
      case "SUBSCRIBE":
        return /* @__PURE__ */ f.createElement(y2, {
          className: e,
          location: t
        });
      case "UPGRADE":
        return /* @__PURE__ */ f.createElement(b2, {
          className: e
        });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ f.createElement(Dl, {
    $variant: s,
    "data-qa": "subscription-button"
  }, l());
};
Bl.displayName = "SubscriptionButton";
const Fl = (e) => /* @__PURE__ */ d.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ d.createElement("path", { d: "M12 16.5a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75Z", fill: "#EB4254", stroke: "#EB4254", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12 13.5V5.25", stroke: "#EB4254", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ d.createElement("path", { d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5Z", stroke: "#EB4254", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ d.createElement("circle", { cx: 12, cy: 17, r: 1, fill: "#EB4254" })), zl = /* @__PURE__ */ k(X, {
  target: "e7roqsw1"
})("display:flex;color:#eb4254;border:1px solid #eb4254;background:#fff6f7;", (e) => e.theme.breakpoints.up("tablet"), "{border-radius:2px;}"), Zl = /* @__PURE__ */ k(Fl, {
  target: "e7roqsw0"
})("inline-size:17.5px;margin-inline-end:5px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-inline-end:9px;}"), C2 = ({
  className: e
}) => {
  const {
    config: t,
    handleTrackGA4: n
  } = R(), {
    computeGA4CommonParameters: r
  } = be(), {
    captureTrackImpressionEventTargetElement: a
  } = Ue({
    ga4Event: q(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...r(),
        call_to_action: "update payment",
        trigger_point: "masthead grace period renewal failure banner"
      },
      subcategory: "entry_point"
    }), [r])
  });
  return /* @__PURE__ */ f.createElement(zl, {
    className: e,
    onClick: () => {
      n({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...r(),
          call_to_action: "update payment",
          trigger_point: "masthead grace period renewal failure banner"
        },
        subcategory: "entry_point"
      }), window.location.href = `${t.accounts.host}/settings`;
    },
    ref: a,
    "data-qa": "grace-period-button"
  }, /* @__PURE__ */ f.createElement(Zl, null), "Renewal Failed");
};
C2.displayName = "GracePeriodButton";
const h2 = ({
  className: e,
  location: t
}) => {
  const {
    config: n,
    currentPageType: r,
    handleTrackGA4: a
  } = R(), {
    computeGA4CommonParameters: i
  } = be(), {
    captureTrackImpressionEventTargetElement: o
  } = Ue({
    ga4Event: null
  });
  return /* @__PURE__ */ f.createElement(X, {
    className: e,
    onClick: () => {
      const s = (() => {
        if (t === "masthead")
          return "masthead reactivation button";
        switch (r) {
          case re.Article:
            return "article footer";
          case re.Homepage:
            return "homepage footer";
          case re.Section:
            return "section footer";
          default:
            return "footer";
        }
      })();
      a({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...i(),
          call_to_action: "reactivation",
          trigger_point: s
        },
        subcategory: "entry_point"
      }), window.location.href = `${n.subscribe.host}/?product=winback`;
    },
    ref: o,
    "data-qa": "reactivate-button"
  }, "Reactivate Access");
};
h2.displayName = "ReactivateButton";
const v2 = ({
  className: e
}) => {
  const {
    handleTrackGA4: t,
    rosettaInstance: n
  } = R(), {
    computeGA4CommonParameters: r
  } = be(), {
    captureTrackImpressionEventTargetElement: a,
    intersection: i
  } = Ue({
    ga4Event: q(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...r(),
        call_to_action: "renew",
        trigger_point: "masthead renewal button"
      },
      subcategory: "entry_point"
    }), [r])
  });
  return /* @__PURE__ */ f.createElement(X, {
    className: e,
    onClick: () => {
      var o, s;
      t({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...r(),
          call_to_action: "renew",
          trigger_point: "masthead renewal button"
        },
        subcategory: "entry_point"
      });
      const l = n == null || (o = n.rulesEngine.getOutcome("user")) === null || o === void 0 ? void 0 : o.expiryReminder, {
        bottom: c,
        left: u,
        right: m,
        top: p
      } = (s = i == null ? void 0 : i.boundingClientRect) !== null && s !== void 0 ? s : {};
      window.postMessage({
        bottom: c,
        expiryReminder: l,
        left: u,
        right: m,
        top: p,
        type: "PIANO_RENEW_POPUP"
      }, "*");
    },
    ref: a,
    "data-qa": "renew-button"
  }, "Renew & Save");
};
v2.displayName = "RenewButton";
const y2 = ({
  className: e,
  location: t
}) => {
  const {
    config: n,
    currentPageType: r,
    handleTrackGA4: a
  } = R(), {
    computeGA4CommonParameters: i
  } = be();
  return /* @__PURE__ */ f.createElement(X, {
    className: e,
    onClick: () => {
      a({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...i(),
          call_to_action: "subscribe",
          trigger_point: (() => {
            switch (t) {
              case "footer":
                switch (r) {
                  case re.Article:
                    return "article footer";
                  case re.Homepage:
                    return "homepage footer";
                  case re.Section:
                    return "section footer";
                  default:
                    return "footer";
                }
              case "masthead":
                return r === re.Article ? "article masthead" : "masthead";
              case "print-button":
                return "print article";
            }
          })()
        },
        subcategory: "entry_point"
      }), window.location.href = n.subscribe.host;
    },
    "data-qa": "subscribe-button"
  }, "Subscribe");
};
y2.displayName = "SubscribeButton";
const b2 = ({
  className: e
}) => {
  const {
    config: t,
    currentPageType: n,
    handleTrackGA4: r
  } = R(), {
    computeGA4CommonParameters: a
  } = be(), {
    captureTrackImpressionEventTargetElement: i
  } = Ue({
    ga4Event: q(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...a(),
        call_to_action: "upgrade",
        trigger_point: n === re.Article ? "article masthead upgrade button" : "masthead"
      },
      subcategory: "entry_point"
    }), [a, n])
  });
  return /* @__PURE__ */ f.createElement(X, {
    className: e,
    onClick: () => {
      r({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...a(),
          call_to_action: "upgrade",
          trigger_point: n === re.Article ? "article masthead upgrade button" : "masthead"
        },
        subcategory: "entry_point"
      }), window.location.href = `${t.accounts.host}/manage/subscription?upgrade=true`, window.postMessage({
        type: "PIANO_UPGRADE_POPUP"
      }, "*");
    },
    ref: i,
    "data-qa": "upgrade-button"
  }, "Upgrade & Save");
};
b2.displayName = "UpgradeButton";
function Wl(e) {
  const {
    checked: t,
    defaultChecked: n,
    disabled: r,
    onBlur: a,
    onChange: i,
    onFocus: o,
    onFocusVisible: s,
    readOnly: l,
    required: c
  } = e, [u, m] = Ji({
    controlled: t,
    default: !!n,
    name: "Switch",
    state: "checked"
  }), p = (b) => (w) => {
    var x;
    w.nativeEvent.defaultPrevented || (m(w.target.checked), i == null || i(w), (x = b.onChange) == null || x.call(b, w));
  }, [h, C] = d.useState(!1);
  r && h && C(!1);
  const g = d.useRef(null), v = (b) => (w) => {
    var x;
    g.current || (g.current = w.currentTarget), Nt(w.target) && (C(!0), s == null || s(w)), o == null || o(w), (x = b.onFocus) == null || x.call(b, w);
  }, y = (b) => (w) => {
    var x;
    Nt(w.target) || C(!1), a == null || a(w), (x = b.onBlur) == null || x.call(b, w);
  }, E = ze(g);
  return {
    checked: u,
    disabled: !!r,
    focusVisible: h,
    getInputProps: (b = {}) => ({
      checked: t,
      defaultChecked: n,
      disabled: r,
      readOnly: l,
      ref: E,
      required: c,
      type: "checkbox",
      role: "switch",
      "aria-checked": t,
      ...b,
      onChange: p(b),
      onFocus: v(b),
      onBlur: y(b)
    }),
    inputRef: E,
    readOnly: !!l
  };
}
const w2 = "Switch";
function Nl(e) {
  return wt(w2, e);
}
const ne = Qr(w2, ["root", "input", "track", "thumb", "checked", "disabled", "focusVisible", "readOnly"]), Ul = (e) => {
  const {
    checked: t,
    disabled: n,
    focusVisible: r,
    readOnly: a
  } = e;
  return at({
    root: ["root", t && "checked", n && "disabled", r && "focusVisible", a && "readOnly"],
    thumb: ["thumb"],
    input: ["input"],
    track: ["track"]
  }, e2(Nl));
}, jl = /* @__PURE__ */ d.forwardRef(function(t, n) {
  const {
    checked: r,
    defaultChecked: a,
    disabled: i,
    onBlur: o,
    onChange: s,
    onFocus: l,
    onFocusVisible: c,
    readOnly: u,
    required: m,
    slotProps: p = {},
    slots: h = {},
    ...C
  } = t, {
    getInputProps: g,
    checked: v,
    disabled: y,
    focusVisible: E,
    readOnly: H
  } = Wl(t), b = {
    ...t,
    checked: v,
    disabled: y,
    focusVisible: E,
    readOnly: H
  }, w = Ul(b), x = h.root ?? "span", T = Ie({
    elementType: x,
    externalSlotProps: p.root,
    externalForwardedProps: C,
    additionalProps: {
      ref: n
    },
    ownerState: b,
    className: w.root
  }), L = h.thumb ?? "span", M = Ie({
    elementType: L,
    externalSlotProps: p.thumb,
    ownerState: b,
    className: w.thumb
  }), V = h.input ?? "input", O = Ie({
    elementType: V,
    getSlotProps: g,
    externalSlotProps: p.input,
    ownerState: b,
    className: w.input
  }), A = h.track === null ? () => null : h.track ?? "span", S = Ie({
    elementType: A,
    externalSlotProps: p.track,
    ownerState: b,
    className: w.track
  });
  return /* @__PURE__ */ N.jsxs(x, {
    ...T,
    children: [/* @__PURE__ */ N.jsx(A, {
      ...S
    }), /* @__PURE__ */ N.jsx(L, {
      ...M
    }), /* @__PURE__ */ N.jsx(V, {
      ...O
    })]
  });
}), ql = /* @__PURE__ */ k("span", {
  target: "e167yolf1"
})({
  name: "1nb6kt7",
  styles: "display:flex;flex-flow:row;justify-content:flex-start;align-items:center"
}), Fn = /* @__PURE__ */ k(jl, {
  target: "e167yolf0"
})("position:relative;display:inline-block;&.", ne.root, "{inline-size:37px;block-size:24px;}& .", ne.input, "{position:absolute;inset-block-start:0;inset-inline-start:0;z-index:1;inline-size:100%;block-size:100%;margin:0;cursor:pointer;opacity:0;}& .", ne.track, "{position:absolute;display:block;inline-size:100%;block-size:100%;border-radius:12px;background-color:#cccccc;}& .", ne.thumb, "{position:absolute;inset-block-start:2px;inset-inline-start:2px;display:block;inline-size:20px;block-size:20px;border-radius:10px;background-color:#ffffff;transition:all 0.2s ease;}&.", ne.checked, "{.", ne.track, "{background-color:#4585ff;}.", ne.thumb, "{inset-block-start:2px;inset-inline-start:15px;}}&.", ne.disabled, "{opacity:0.4;.", ne.input, "{cursor:not-allowed;}}"), Gl = ({
  label: e,
  ...t
}) => e ? /* @__PURE__ */ f.createElement(ql, null, /* @__PURE__ */ f.createElement(Fn, t), e) : /* @__PURE__ */ f.createElement(Fn, t);
Gl.displayName = "Switch";
export {
  po as A,
  pr as B,
  hc as D,
  C2 as G,
  f2 as P,
  h2 as R,
  Rl as S,
  b2 as U,
  yc as a,
  bc as b,
  wc as c,
  Co as d,
  So as e,
  Ao as f,
  Io as g,
  r2 as h,
  Gl as i,
  p2 as j,
  Bl as k,
  v2 as l,
  y2 as m,
  vc as u
};
//# sourceMappingURL=index-BY0nqonX.mjs.map
